/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable import/order */

import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { CommandResult } from 'src/util/graphql/command-result';
import {
  AddActivationRule,
  AddActivationRuleMutation,
  AddActivationRuleMutationVariables,
  DeleteActivationRule,
  DeleteActivationRuleMutation,
  DeleteActivationRuleMutationVariables,
  UpdateActivationRule,
  UpdateActivationRuleMutation,
  UpdateActivationRuleMutationVariables,
  AcknowledgeAlert,
  AcknowledgeAlertMutation,
  AcknowledgeAlertMutationVariables,
  AddActiveAlert,
  AddActiveAlertMutation,
  AddActiveAlertMutationVariables,
  CleanupActiveAlerts,
  CleanupActiveAlertsMutation,
  CleanupActiveAlertsMutationVariables,
  CleanupCardActiveAlerts,
  CleanupCardActiveAlertsMutation,
  CleanupCardActiveAlertsMutationVariables,
  DeleteActiveAlert,
  DeleteActiveAlertMutation,
  DeleteActiveAlertMutationVariables,
  SnoozeAlert,
  SnoozeAlertMutation,
  SnoozeAlertMutationVariables,
  UpdateActiveAlert,
  UpdateActiveAlertMutation,
  UpdateActiveAlertMutationVariables,
  DeleteActiveTimeline,
  DeleteActiveTimelineMutation,
  DeleteActiveTimelineMutationVariables,
  UpdateActiveTimeline,
  UpdateActiveTimelineMutation,
  UpdateActiveTimelineMutationVariables,
  AddAlert,
  AddAlertMutation,
  AddAlertMutationVariables,
  CopyAlert,
  CopyAlertMutation,
  CopyAlertMutationVariables,
  DeleteAlert,
  DeleteAlertMutation,
  DeleteAlertMutationVariables,
  UpdateAlert,
  UpdateAlertMutation,
  UpdateAlertMutationVariables,
  AddApplicationNotification,
  AddApplicationNotificationMutation,
  AddApplicationNotificationMutationVariables,
  DeleteApplicationNotification,
  DeleteApplicationNotificationMutation,
  DeleteApplicationNotificationMutationVariables,
  DismissApplicationNotification,
  DismissApplicationNotificationMutation,
  DismissApplicationNotificationMutationVariables,
  UpdateApplicationNotification,
  UpdateApplicationNotificationMutation,
  UpdateApplicationNotificationMutationVariables,
  AddAssignmentDelayedReason,
  AddAssignmentDelayedReasonMutation,
  AddAssignmentDelayedReasonMutationVariables,
  DeleteAssignmentDelayedReason,
  DeleteAssignmentDelayedReasonMutation,
  DeleteAssignmentDelayedReasonMutationVariables,
  UpdateAssignmentDelayedReason,
  UpdateAssignmentDelayedReasonMutation,
  UpdateAssignmentDelayedReasonMutationVariables,
  AddCancellationCategory,
  AddCancellationCategoryMutation,
  AddCancellationCategoryMutationVariables,
  DeleteCancellationCategory,
  DeleteCancellationCategoryMutation,
  DeleteCancellationCategoryMutationVariables,
  UpdateCancellationCategory,
  UpdateCancellationCategoryMutation,
  UpdateCancellationCategoryMutationVariables,
  AddCancellationReason,
  AddCancellationReasonMutation,
  AddCancellationReasonMutationVariables,
  DeleteCancellationReason,
  DeleteCancellationReasonMutation,
  DeleteCancellationReasonMutationVariables,
  UpdateCancellationReason,
  UpdateCancellationReasonMutation,
  UpdateCancellationReasonMutationVariables,
  AddCancellationSecondaryReason,
  AddCancellationSecondaryReasonMutation,
  AddCancellationSecondaryReasonMutationVariables,
  DeleteCancellationSecondaryReason,
  DeleteCancellationSecondaryReasonMutation,
  DeleteCancellationSecondaryReasonMutationVariables,
  UpdateCancellationSecondaryReason,
  UpdateCancellationSecondaryReasonMutation,
  UpdateCancellationSecondaryReasonMutationVariables,
  AddCardLink,
  AddCardLinkMutation,
  AddCardLinkMutationVariables,
  DeleteCardLink,
  DeleteCardLinkMutation,
  DeleteCardLinkMutationVariables,
  UpdateCardLink,
  UpdateCardLinkMutation,
  UpdateCardLinkMutationVariables,
  AddCardNoteArchive,
  AddCardNoteArchiveMutation,
  AddCardNoteArchiveMutationVariables,
  DeleteCardNoteArchive,
  DeleteCardNoteArchiveMutation,
  DeleteCardNoteArchiveMutationVariables,
  UpdateCardNoteArchive,
  UpdateCardNoteArchiveMutation,
  UpdateCardNoteArchiveMutationVariables,
  AddCardNote,
  AddCardNoteMutation,
  AddCardNoteMutationVariables,
  DeleteCardNote,
  DeleteCardNoteMutation,
  DeleteCardNoteMutationVariables,
  SendNoteToCard,
  SendNoteToCardMutation,
  SendNoteToCardMutationVariables,
  UpdateCardNote,
  UpdateCardNoteMutation,
  UpdateCardNoteMutationVariables,
  AddCardReOpenReason,
  AddCardReOpenReasonMutation,
  AddCardReOpenReasonMutationVariables,
  DeleteCardReOpenReason,
  DeleteCardReOpenReasonMutation,
  DeleteCardReOpenReasonMutationVariables,
  UpdateCardReOpenReason,
  UpdateCardReOpenReasonMutation,
  UpdateCardReOpenReasonMutationVariables,
  AddCard,
  AddCardMutation,
  AddCardMutationVariables,
  ChangeCardCallStatus,
  ChangeCardCallStatusMutation,
  ChangeCardCallStatusMutationVariables,
  ChangeUnit,
  ChangeUnitMutation,
  ChangeUnitMutationVariables,
  CheckForFlightFollowingDestinationConflict,
  CheckForFlightFollowingDestinationConflictMutation,
  CheckForFlightFollowingDestinationConflictMutationVariables,
  CleanupCards,
  CleanupCardsMutation,
  CleanupCardsMutationVariables,
  CloseCard,
  CloseCardMutation,
  CloseCardMutationVariables,
  CreateSystemCrewNotification,
  CreateSystemCrewNotificationMutation,
  CreateSystemCrewNotificationMutationVariables,
  DeleteCard,
  DeleteCardMutation,
  DeleteCardMutationVariables,
  Divert,
  DivertMutation,
  DivertMutationVariables,
  GenerateCardReport,
  GenerateCardReportMutation,
  GenerateCardReportMutationVariables,
  GenerateCardSummaryChange,
  GenerateCardSummaryChangeMutation,
  GenerateCardSummaryChangeMutationVariables,
  GenerateCardSummaryChangeV2,
  GenerateCardSummaryChangeV2Mutation,
  GenerateCardSummaryChangeV2MutationVariables,
  LinkCards,
  LinkCardsMutation,
  LinkCardsMutationVariables,
  ReOpenCard,
  ReOpenCardMutation,
  ReOpenCardMutationVariables,
  RequestAdditionalUnits,
  RequestAdditionalUnitsMutation,
  RequestAdditionalUnitsMutationVariables,
  ScanForFlights,
  ScanForFlightsMutation,
  ScanForFlightsMutationVariables,
  SendPatientInfo,
  SendPatientInfoMutation,
  SendPatientInfoMutationVariables,
  SetCardLockStatus,
  SetCardLockStatusMutation,
  SetCardLockStatusMutationVariables,
  UnDeleteCard,
  UnDeleteCardMutation,
  UnDeleteCardMutationVariables,
  UpdateCard,
  UpdateCardMutation,
  UpdateCardMutationVariables,
  UpdateCardBillable,
  UpdateCardBillableMutation,
  UpdateCardBillableMutationVariables,
  UpdateCardContactCompleted,
  UpdateCardContactCompletedMutation,
  UpdateCardContactCompletedMutationVariables,
  UpdateCardDiversionType,
  UpdateCardDiversionTypeMutation,
  UpdateCardDiversionTypeMutationVariables,
  UpdateCardSearchIndex,
  UpdateCardSearchIndexMutation,
  UpdateCardSearchIndexMutationVariables,
  UpdateGmrCadNumber,
  UpdateGmrCadNumberMutation,
  UpdateGmrCadNumberMutationVariables,
  UpdatePlannedCardCompletionTime,
  UpdatePlannedCardCompletionTimeMutation,
  UpdatePlannedCardCompletionTimeMutationVariables,
  AddConfigurationSetting,
  AddConfigurationSettingMutation,
  AddConfigurationSettingMutationVariables,
  UpdateConfigurationSetting,
  UpdateConfigurationSettingMutation,
  UpdateConfigurationSettingMutationVariables,
  AddConversationToCardWithParticipant,
  AddConversationToCardWithParticipantMutation,
  AddConversationToCardWithParticipantMutationVariables,
  CloseConversation,
  CloseConversationMutation,
  CloseConversationMutationVariables,
  AddDeclineCategory,
  AddDeclineCategoryMutation,
  AddDeclineCategoryMutationVariables,
  DeleteDeclineCategory,
  DeleteDeclineCategoryMutation,
  DeleteDeclineCategoryMutationVariables,
  UpdateDeclineCategory,
  UpdateDeclineCategoryMutation,
  UpdateDeclineCategoryMutationVariables,
  AddDeclineReason,
  AddDeclineReasonMutation,
  AddDeclineReasonMutationVariables,
  DeleteDeclineReason,
  DeleteDeclineReasonMutation,
  DeleteDeclineReasonMutationVariables,
  UpdateDeclineReason,
  UpdateDeclineReasonMutation,
  UpdateDeclineReasonMutationVariables,
  AddDeclineSecondaryReason,
  AddDeclineSecondaryReasonMutation,
  AddDeclineSecondaryReasonMutationVariables,
  DeleteDeclineSecondaryReason,
  DeleteDeclineSecondaryReasonMutation,
  DeleteDeclineSecondaryReasonMutationVariables,
  UpdateDeclineSecondaryReason,
  UpdateDeclineSecondaryReasonMutation,
  UpdateDeclineSecondaryReasonMutationVariables,
  AddDiversionReason,
  AddDiversionReasonMutation,
  AddDiversionReasonMutationVariables,
  DeleteDiversionReason,
  DeleteDiversionReasonMutation,
  DeleteDiversionReasonMutationVariables,
  UpdateDiversionReason,
  UpdateDiversionReasonMutation,
  UpdateDiversionReasonMutationVariables,
  AddEscortRequest,
  AddEscortRequestMutation,
  AddEscortRequestMutationVariables,
  DeleteEscortRequest,
  DeleteEscortRequestMutation,
  DeleteEscortRequestMutationVariables,
  UpdateEscortRequest,
  UpdateEscortRequestMutation,
  UpdateEscortRequestMutationVariables,
  MakeEstimatedDurationOfficial,
  MakeEstimatedDurationOfficialMutation,
  MakeEstimatedDurationOfficialMutationVariables,
  UpdateEstimatedDurations,
  UpdateEstimatedDurationsMutation,
  UpdateEstimatedDurationsMutationVariables,
  UpdateTripLegDuration,
  UpdateTripLegDurationMutation,
  UpdateTripLegDurationMutationVariables,
  UpdateWaypointDuration,
  UpdateWaypointDurationMutation,
  UpdateWaypointDurationMutationVariables,
  AddExternalAction,
  AddExternalActionMutation,
  AddExternalActionMutationVariables,
  CleanupPendingExternalActions,
  CleanupPendingExternalActionsMutation,
  CleanupPendingExternalActionsMutationVariables,
  DeleteExternalAction,
  DeleteExternalActionMutation,
  DeleteExternalActionMutationVariables,
  DisregardExternalAction,
  DisregardExternalActionMutation,
  DisregardExternalActionMutationVariables,
  UpdateExternalAction,
  UpdateExternalActionMutation,
  UpdateExternalActionMutationVariables,
  AddExternalActionType,
  AddExternalActionTypeMutation,
  AddExternalActionTypeMutationVariables,
  DeleteExternalActionType,
  DeleteExternalActionTypeMutation,
  DeleteExternalActionTypeMutationVariables,
  UpdateExternalActionType,
  UpdateExternalActionTypeMutation,
  UpdateExternalActionTypeMutationVariables,
  AddFacilityNonAcceptanceReason,
  AddFacilityNonAcceptanceReasonMutation,
  AddFacilityNonAcceptanceReasonMutationVariables,
  DeleteFacilityNonAcceptanceReason,
  DeleteFacilityNonAcceptanceReasonMutation,
  DeleteFacilityNonAcceptanceReasonMutationVariables,
  UpdateFacilityNonAcceptanceReason,
  UpdateFacilityNonAcceptanceReasonMutation,
  UpdateFacilityNonAcceptanceReasonMutationVariables,
  AddFirewallRule,
  AddFirewallRuleMutation,
  AddFirewallRuleMutationVariables,
  DeleteFirewallRule,
  DeleteFirewallRuleMutation,
  DeleteFirewallRuleMutationVariables,
  UpdateFirewallRule,
  UpdateFirewallRuleMutation,
  UpdateFirewallRuleMutationVariables,
  AddFlightFollowingReport,
  AddFlightFollowingReportMutation,
  AddFlightFollowingReportMutationVariables,
  DeleteFlightFollowingReport,
  DeleteFlightFollowingReportMutation,
  DeleteFlightFollowingReportMutationVariables,
  UpdateFlightFollowingReport,
  UpdateFlightFollowingReportMutation,
  UpdateFlightFollowingReportMutationVariables,
  DeleteLocationHazardAttachment,
  DeleteLocationHazardAttachmentMutation,
  DeleteLocationHazardAttachmentMutationVariables,
  GenerateLocationHazardAttachmentUrl,
  GenerateLocationHazardAttachmentUrlMutation,
  GenerateLocationHazardAttachmentUrlMutationVariables,
  AddLocationHazard,
  AddLocationHazardMutation,
  AddLocationHazardMutationVariables,
  DeleteLocationHazard,
  DeleteLocationHazardMutation,
  DeleteLocationHazardMutationVariables,
  UpdateLocationHazard,
  UpdateLocationHazardMutation,
  UpdateLocationHazardMutationVariables,
  AddMedicalControlContactLogEntry,
  AddMedicalControlContactLogEntryMutation,
  AddMedicalControlContactLogEntryMutationVariables,
  DeleteMedicalControlContactLogEntry,
  DeleteMedicalControlContactLogEntryMutation,
  DeleteMedicalControlContactLogEntryMutationVariables,
  UpdateMedicalControlContactLogEntry,
  UpdateMedicalControlContactLogEntryMutation,
  UpdateMedicalControlContactLogEntryMutationVariables,
  AddMessageStatusUpdate,
  AddMessageStatusUpdateMutation,
  AddMessageStatusUpdateMutationVariables,
  AddNewAgencyLocationRequest,
  AddNewAgencyLocationRequestMutation,
  AddNewAgencyLocationRequestMutationVariables,
  DeleteNewAgencyLocationRequest,
  DeleteNewAgencyLocationRequestMutation,
  DeleteNewAgencyLocationRequestMutationVariables,
  UpdateNewAgencyLocationRequest,
  UpdateNewAgencyLocationRequestMutation,
  UpdateNewAgencyLocationRequestMutationVariables,
  AddNextDueType,
  AddNextDueTypeMutation,
  AddNextDueTypeMutationVariables,
  DeleteNextDueType,
  DeleteNextDueTypeMutation,
  DeleteNextDueTypeMutationVariables,
  UpdateNextDueType,
  UpdateNextDueTypeMutation,
  UpdateNextDueTypeMutationVariables,
  AddNonReferralReason,
  AddNonReferralReasonMutation,
  AddNonReferralReasonMutationVariables,
  DeleteNonReferralReason,
  DeleteNonReferralReasonMutation,
  DeleteNonReferralReasonMutationVariables,
  UpdateNonReferralReason,
  UpdateNonReferralReasonMutation,
  UpdateNonReferralReasonMutationVariables,
  AddNotificationGroupMember,
  AddNotificationGroupMemberMutation,
  AddNotificationGroupMemberMutationVariables,
  DeleteNotificationGroupMember,
  DeleteNotificationGroupMemberMutation,
  DeleteNotificationGroupMemberMutationVariables,
  UpdateNotificationGroupMember,
  UpdateNotificationGroupMemberMutation,
  UpdateNotificationGroupMemberMutationVariables,
  AddNotificationGroup,
  AddNotificationGroupMutation,
  AddNotificationGroupMutationVariables,
  DeleteNotificationGroup,
  DeleteNotificationGroupMutation,
  DeleteNotificationGroupMutationVariables,
  UpdateNotificationGroup,
  UpdateNotificationGroupMutation,
  UpdateNotificationGroupMutationVariables,
  UpsertPersonNotificationGroups,
  UpsertPersonNotificationGroupsMutation,
  UpsertPersonNotificationGroupsMutationVariables,
  AddNotificationRecipient,
  AddNotificationRecipientMutation,
  AddNotificationRecipientMutationVariables,
  AddNotificationRecipients,
  AddNotificationRecipientsMutation,
  AddNotificationRecipientsMutationVariables,
  DeleteNotificationRecipient,
  DeleteNotificationRecipientMutation,
  DeleteNotificationRecipientMutationVariables,
  DeleteNotificationRecipients,
  DeleteNotificationRecipientsMutation,
  DeleteNotificationRecipientsMutationVariables,
  UpdateNotificationRecipient,
  UpdateNotificationRecipientMutation,
  UpdateNotificationRecipientMutationVariables,
  UpdateRecipientMessageStatus,
  UpdateRecipientMessageStatusMutation,
  UpdateRecipientMessageStatusMutationVariables,
  AddNotification,
  AddNotificationMutation,
  AddNotificationMutationVariables,
  DeleteNotification,
  DeleteNotificationMutation,
  DeleteNotificationMutationVariables,
  SendNotification,
  SendNotificationMutation,
  SendNotificationMutationVariables,
  UpdateNotification,
  UpdateNotificationMutation,
  UpdateNotificationMutationVariables,
  AddNotificationSubscription,
  AddNotificationSubscriptionMutation,
  AddNotificationSubscriptionMutationVariables,
  DeleteNotificationSubscription,
  DeleteNotificationSubscriptionMutation,
  DeleteNotificationSubscriptionMutationVariables,
  UpdateNotificationSubscription,
  UpdateNotificationSubscriptionMutation,
  UpdateNotificationSubscriptionMutationVariables,
  AddNotificationTemplate,
  AddNotificationTemplateMutation,
  AddNotificationTemplateMutationVariables,
  CopyNotificationTemplate,
  CopyNotificationTemplateMutation,
  CopyNotificationTemplateMutationVariables,
  DeleteNotificationTemplate,
  DeleteNotificationTemplateMutation,
  DeleteNotificationTemplateMutationVariables,
  UpdateNotificationTemplate,
  UpdateNotificationTemplateMutation,
  UpdateNotificationTemplateMutationVariables,
  AddOemActivity,
  AddOemActivityMutation,
  AddOemActivityMutationVariables,
  DeleteOemActivity,
  DeleteOemActivityMutation,
  DeleteOemActivityMutationVariables,
  UpdateOemActivity,
  UpdateOemActivityMutation,
  UpdateOemActivityMutationVariables,
  AddOemAsset,
  AddOemAssetMutation,
  AddOemAssetMutationVariables,
  DeleteOemAsset,
  DeleteOemAssetMutation,
  DeleteOemAssetMutationVariables,
  UpdateOemAsset,
  UpdateOemAssetMutation,
  UpdateOemAssetMutationVariables,
  AddOemPlanChangeRequest,
  AddOemPlanChangeRequestMutation,
  AddOemPlanChangeRequestMutationVariables,
  DeleteOemPlanChangeRequest,
  DeleteOemPlanChangeRequestMutation,
  DeleteOemPlanChangeRequestMutationVariables,
  UpdateOemPlanChangeRequest,
  UpdateOemPlanChangeRequestMutation,
  UpdateOemPlanChangeRequestMutationVariables,
  AddOemPlan,
  AddOemPlanMutation,
  AddOemPlanMutationVariables,
  DeleteOemPlan,
  DeleteOemPlanMutation,
  DeleteOemPlanMutationVariables,
  UpdateOemPlan,
  UpdateOemPlanMutation,
  UpdateOemPlanMutationVariables,
  AddOfferAlgorithm,
  AddOfferAlgorithmMutation,
  AddOfferAlgorithmMutationVariables,
  CopyOfferAlgorithm,
  CopyOfferAlgorithmMutation,
  CopyOfferAlgorithmMutationVariables,
  DeleteOfferAlgorithm,
  DeleteOfferAlgorithmMutation,
  DeleteOfferAlgorithmMutationVariables,
  UpdateOfferAlgorithm,
  UpdateOfferAlgorithmMutation,
  UpdateOfferAlgorithmMutationVariables,
  ActivateUnit,
  ActivateUnitMutation,
  ActivateUnitMutationVariables,
  AddOperation,
  AddOperationMutation,
  AddOperationMutationVariables,
  ArriveVehicle,
  ArriveVehicleMutation,
  ArriveVehicleMutationVariables,
  CancelOperation,
  CancelOperationMutation,
  CancelOperationMutationVariables,
  ChangeVehicle,
  ChangeVehicleMutation,
  ChangeVehicleMutationVariables,
  CreateGroundRun,
  CreateGroundRunMutation,
  CreateGroundRunMutationVariables,
  CreateMaintenanceOperation,
  CreateMaintenanceOperationMutation,
  CreateMaintenanceOperationMutationVariables,
  CreateTrainingOperation,
  CreateTrainingOperationMutation,
  CreateTrainingOperationMutationVariables,
  DeclineOrAbortOperation,
  DeclineOrAbortOperationMutation,
  DeclineOrAbortOperationMutationVariables,
  DeleteOperation,
  DeleteOperationMutation,
  DeleteOperationMutationVariables,
  DepartVehicle,
  DepartVehicleMutation,
  DepartVehicleMutationVariables,
  PlaceUnitOnStandby,
  PlaceUnitOnStandbyMutation,
  PlaceUnitOnStandbyMutationVariables,
  RepositionUnit,
  RepositionUnitMutation,
  RepositionUnitMutationVariables,
  UndoAbortOperation,
  UndoAbortOperationMutation,
  UndoAbortOperationMutationVariables,
  UndoArriveVehicle,
  UndoArriveVehicleMutation,
  UndoArriveVehicleMutationVariables,
  UndoDepartVehicle,
  UndoDepartVehicleMutation,
  UndoDepartVehicleMutationVariables,
  UpdateOperation,
  UpdateOperationMutation,
  UpdateOperationMutationVariables,
  UpdateOperationContactInfo,
  UpdateOperationContactInfoMutation,
  UpdateOperationContactInfoMutationVariables,
  UpdateRiskAnalysis,
  UpdateRiskAnalysisMutation,
  UpdateRiskAnalysisMutationVariables,
  AddOutOfServiceEventNote,
  AddOutOfServiceEventNoteMutation,
  AddOutOfServiceEventNoteMutationVariables,
  DeleteOutOfServiceEventNote,
  DeleteOutOfServiceEventNoteMutation,
  DeleteOutOfServiceEventNoteMutationVariables,
  UpdateOutOfServiceEventNote,
  UpdateOutOfServiceEventNoteMutation,
  UpdateOutOfServiceEventNoteMutationVariables,
  AcknowledgeOutOfServiceEvent,
  AcknowledgeOutOfServiceEventMutation,
  AcknowledgeOutOfServiceEventMutationVariables,
  AddCrewOutOfServiceEvent,
  AddCrewOutOfServiceEventMutation,
  AddCrewOutOfServiceEventMutationVariables,
  AddOutOfServiceEvent,
  AddOutOfServiceEventMutation,
  AddOutOfServiceEventMutationVariables,
  AddUnitOutOfServiceEvent,
  AddUnitOutOfServiceEventMutation,
  AddUnitOutOfServiceEventMutationVariables,
  AddVehicleOutOfServiceEvent,
  AddVehicleOutOfServiceEventMutation,
  AddVehicleOutOfServiceEventMutationVariables,
  BeginOutOfServiceEvent,
  BeginOutOfServiceEventMutation,
  BeginOutOfServiceEventMutationVariables,
  CreateTicketFromOutOfServiceEvent,
  CreateTicketFromOutOfServiceEventMutation,
  CreateTicketFromOutOfServiceEventMutationVariables,
  DeleteOutOfServiceEvent,
  DeleteOutOfServiceEventMutation,
  DeleteOutOfServiceEventMutationVariables,
  EndCrewMemberOutOfServiceEvent,
  EndCrewMemberOutOfServiceEventMutation,
  EndCrewMemberOutOfServiceEventMutationVariables,
  EndOutOfServiceEvent,
  EndOutOfServiceEventMutation,
  EndOutOfServiceEventMutationVariables,
  LinkOutOfServiceEvent,
  LinkOutOfServiceEventMutation,
  LinkOutOfServiceEventMutationVariables,
  UpdateOutOfServiceEvent,
  UpdateOutOfServiceEventMutation,
  UpdateOutOfServiceEventMutationVariables,
  AddOutOfServiceReason,
  AddOutOfServiceReasonMutation,
  AddOutOfServiceReasonMutationVariables,
  DeleteOutOfServiceReason,
  DeleteOutOfServiceReasonMutation,
  DeleteOutOfServiceReasonMutationVariables,
  UpdateOutOfServiceReason,
  UpdateOutOfServiceReasonMutation,
  UpdateOutOfServiceReasonMutationVariables,
  AddOutOfServiceSecondaryReason,
  AddOutOfServiceSecondaryReasonMutation,
  AddOutOfServiceSecondaryReasonMutationVariables,
  DeleteOutOfServiceSecondaryReason,
  DeleteOutOfServiceSecondaryReasonMutation,
  DeleteOutOfServiceSecondaryReasonMutationVariables,
  UpdateOutOfServiceSecondaryReason,
  UpdateOutOfServiceSecondaryReasonMutation,
  UpdateOutOfServiceSecondaryReasonMutationVariables,
  AcceptOutOfServiceTicket,
  AcceptOutOfServiceTicketMutation,
  AcceptOutOfServiceTicketMutationVariables,
  AcknowledgeOutOfServiceTicket,
  AcknowledgeOutOfServiceTicketMutation,
  AcknowledgeOutOfServiceTicketMutationVariables,
  CloseTicketsForOOSEvent,
  CloseTicketsForOOSEventMutation,
  CloseTicketsForOOSEventMutationVariables,
  DeleteOutOfServiceTicket,
  DeleteOutOfServiceTicketMutation,
  DeleteOutOfServiceTicketMutationVariables,
  ReviewSubmittedOutOfServiceTicket,
  ReviewSubmittedOutOfServiceTicketMutation,
  ReviewSubmittedOutOfServiceTicketMutationVariables,
  SubmitOutOfServiceTicket,
  SubmitOutOfServiceTicketMutation,
  SubmitOutOfServiceTicketMutationVariables,
  AddPaipEvent,
  AddPaipEventMutation,
  AddPaipEventMutationVariables,
  DeletePaipEvent,
  DeletePaipEventMutation,
  DeletePaipEventMutationVariables,
  EndPaipEvent,
  EndPaipEventMutation,
  EndPaipEventMutationVariables,
  UpdatePaipEvent,
  UpdatePaipEventMutation,
  UpdatePaipEventMutationVariables,
  AddPaipReason,
  AddPaipReasonMutation,
  AddPaipReasonMutationVariables,
  DeletePaipReason,
  DeletePaipReasonMutation,
  DeletePaipReasonMutationVariables,
  UpdatePaipReason,
  UpdatePaipReasonMutation,
  UpdatePaipReasonMutationVariables,
  ArchivePassdownLog,
  ArchivePassdownLogMutation,
  ArchivePassdownLogMutationVariables,
  AcknowledgePassdownLog,
  AcknowledgePassdownLogMutation,
  AcknowledgePassdownLogMutationVariables,
  AddPassdownLog,
  AddPassdownLogMutation,
  AddPassdownLogMutationVariables,
  DeletePassdownLog,
  DeletePassdownLogMutation,
  DeletePassdownLogMutationVariables,
  UpdatePassdownLog,
  UpdatePassdownLogMutation,
  UpdatePassdownLogMutationVariables,
  AddPositionReportAlert,
  AddPositionReportAlertMutation,
  AddPositionReportAlertMutationVariables,
  DeletePositionReportAlert,
  DeletePositionReportAlertMutation,
  DeletePositionReportAlertMutationVariables,
  UpdatePositionReportAlert,
  UpdatePositionReportAlertMutation,
  UpdatePositionReportAlertMutationVariables,
  AddPositionReport,
  AddPositionReportMutation,
  AddPositionReportMutationVariables,
  ConfirmPositionReport,
  ConfirmPositionReportMutation,
  ConfirmPositionReportMutationVariables,
  DeletePositionReport,
  DeletePositionReportMutation,
  DeletePositionReportMutationVariables,
  UpdatePositionReport,
  UpdatePositionReportMutation,
  UpdatePositionReportMutationVariables,
  UpsertQuestionChoice,
  UpsertQuestionChoiceMutation,
  UpsertQuestionChoiceMutationVariables,
  AddQuestionnaireQuestionResponseNote,
  AddQuestionnaireQuestionResponseNoteMutation,
  AddQuestionnaireQuestionResponseNoteMutationVariables,
  DeleteQuestionnaireQuestionResponseNote,
  DeleteQuestionnaireQuestionResponseNoteMutation,
  DeleteQuestionnaireQuestionResponseNoteMutationVariables,
  UpdateQuestionnaireQuestionResponseNote,
  UpdateQuestionnaireQuestionResponseNoteMutation,
  UpdateQuestionnaireQuestionResponseNoteMutationVariables,
  UpsertQuestionnaireQuestionResponseNote,
  UpsertQuestionnaireQuestionResponseNoteMutation,
  UpsertQuestionnaireQuestionResponseNoteMutationVariables,
  AddQuestionnaireQuestionResponse,
  AddQuestionnaireQuestionResponseMutation,
  AddQuestionnaireQuestionResponseMutationVariables,
  DeleteQuestionnaireQuestionResponse,
  DeleteQuestionnaireQuestionResponseMutation,
  DeleteQuestionnaireQuestionResponseMutationVariables,
  UpdateQuestionnaireQuestionResponse,
  UpdateQuestionnaireQuestionResponseMutation,
  UpdateQuestionnaireQuestionResponseMutationVariables,
  UpdateQuestionnaireQuestionResponseDeep,
  UpdateQuestionnaireQuestionResponseDeepMutation,
  UpdateQuestionnaireQuestionResponseDeepMutationVariables,
  AddQuestionnaireResponse,
  AddQuestionnaireResponseMutation,
  AddQuestionnaireResponseMutationVariables,
  DeleteQuestionnaireResponse,
  DeleteQuestionnaireResponseMutation,
  DeleteQuestionnaireResponseMutationVariables,
  SubmitQuestionnaireResponse,
  SubmitQuestionnaireResponseMutation,
  SubmitQuestionnaireResponseMutationVariables,
  UpdateQuestionnaireResponse,
  UpdateQuestionnaireResponseMutation,
  UpdateQuestionnaireResponseMutationVariables,
  UpdateQuestionnaireResponseDeep,
  UpdateQuestionnaireResponseDeepMutation,
  UpdateQuestionnaireResponseDeepMutationVariables,
  AddQuestionnaire,
  AddQuestionnaireMutation,
  AddQuestionnaireMutationVariables,
  DeleteQuestionnaire,
  DeleteQuestionnaireMutation,
  DeleteQuestionnaireMutationVariables,
  UpdateQuestionnaire,
  UpdateQuestionnaireMutation,
  UpdateQuestionnaireMutationVariables,
  DeleteQuestionnaireSectionQuestion,
  DeleteQuestionnaireSectionQuestionMutation,
  DeleteQuestionnaireSectionQuestionMutationVariables,
  UpsertQuestionnaireSectionQuestion,
  UpsertQuestionnaireSectionQuestionMutation,
  UpsertQuestionnaireSectionQuestionMutationVariables,
  DeleteQuestionnaireSection,
  DeleteQuestionnaireSectionMutation,
  DeleteQuestionnaireSectionMutationVariables,
  UpsertQuestionnaireSection,
  UpsertQuestionnaireSectionMutation,
  UpsertQuestionnaireSectionMutationVariables,
  AddQuestion,
  AddQuestionMutation,
  AddQuestionMutationVariables,
  DeleteQuestion,
  DeleteQuestionMutation,
  DeleteQuestionMutationVariables,
  UpdateQuestion,
  UpdateQuestionMutation,
  UpdateQuestionMutationVariables,
  AcceptReceivingFacilityRequest,
  AcceptReceivingFacilityRequestMutation,
  AcceptReceivingFacilityRequestMutationVariables,
  AddReceivingFacilityRequestDeclineHistory,
  AddReceivingFacilityRequestDeclineHistoryMutation,
  AddReceivingFacilityRequestDeclineHistoryMutationVariables,
  CancelReceivingFacilityRequest,
  CancelReceivingFacilityRequestMutation,
  CancelReceivingFacilityRequestMutationVariables,
  DeleteReceivingFacilityRequest,
  DeleteReceivingFacilityRequestMutation,
  DeleteReceivingFacilityRequestMutationVariables,
  DenyReceivingFacilityRequest,
  DenyReceivingFacilityRequestMutation,
  DenyReceivingFacilityRequestMutationVariables,
  DivertReceivingFacilityRequest,
  DivertReceivingFacilityRequestMutation,
  DivertReceivingFacilityRequestMutationVariables,
  ReferReceivingFacilityRequest,
  ReferReceivingFacilityRequestMutation,
  ReferReceivingFacilityRequestMutationVariables,
  AddRendezvousRequest,
  AddRendezvousRequestMutation,
  AddRendezvousRequestMutationVariables,
  DeleteRendezvousRequest,
  DeleteRendezvousRequestMutation,
  DeleteRendezvousRequestMutationVariables,
  UpdateRendezvousRequest,
  UpdateRendezvousRequestMutation,
  UpdateRendezvousRequestMutationVariables,
  AddRequesterRole,
  AddRequesterRoleMutation,
  AddRequesterRoleMutationVariables,
  DeleteRequesterRole,
  DeleteRequesterRoleMutation,
  DeleteRequesterRoleMutationVariables,
  UpdateRequesterRole,
  UpdateRequesterRoleMutation,
  UpdateRequesterRoleMutationVariables,
  UpdateRequester,
  UpdateRequesterMutation,
  UpdateRequesterMutationVariables,
  UpdateRequesterSpecialtyTeam,
  UpdateRequesterSpecialtyTeamMutation,
  UpdateRequesterSpecialtyTeamMutationVariables,
  UpdateRequestorAgencyLocation,
  UpdateRequestorAgencyLocationMutation,
  UpdateRequestorAgencyLocationMutationVariables,
  UpdateTransferCenterCallInfo,
  UpdateTransferCenterCallInfoMutation,
  UpdateTransferCenterCallInfoMutationVariables,
  UpdateReceivingFacilityAutoAcceptance,
  UpdateReceivingFacilityAutoAcceptanceMutation,
  UpdateReceivingFacilityAutoAcceptanceMutationVariables,
  UpdateRequestLocation,
  UpdateRequestLocationMutation,
  UpdateRequestLocationMutationVariables,
  AddRequestPatient,
  AddRequestPatientMutation,
  AddRequestPatientMutationVariables,
  DeleteRequestPatient,
  DeleteRequestPatientMutation,
  DeleteRequestPatientMutationVariables,
  UpdateChiefComplaint,
  UpdateChiefComplaintMutation,
  UpdateChiefComplaintMutationVariables,
  UpdatePatientClinicalInfo,
  UpdatePatientClinicalInfoMutation,
  UpdatePatientClinicalInfoMutationVariables,
  UpdatePatientInfo,
  UpdatePatientInfoMutation,
  UpdatePatientInfoMutationVariables,
  UpdateRequestPatient,
  UpdateRequestPatientMutation,
  UpdateRequestPatientMutationVariables,
  AcknowledgeExternalRequest,
  AcknowledgeExternalRequestMutation,
  AcknowledgeExternalRequestMutationVariables,
  BeginAssignment,
  BeginAssignmentMutation,
  BeginAssignmentMutationVariables,
  CancelRequest,
  CancelRequestMutation,
  CancelRequestMutationVariables,
  CancelRequestFromTransferCenter,
  CancelRequestFromTransferCenterMutation,
  CancelRequestFromTransferCenterMutationVariables,
  ChangeCallType,
  ChangeCallTypeMutation,
  ChangeCallTypeMutationVariables,
  ChangeRequestCancellationReason,
  ChangeRequestCancellationReasonMutation,
  ChangeRequestCancellationReasonMutationVariables,
  ChangeRequestType,
  ChangeRequestTypeMutation,
  ChangeRequestTypeMutationVariables,
  CreateRequest,
  CreateRequestMutation,
  CreateRequestMutationVariables,
  DelayAssignment,
  DelayAssignmentMutation,
  DelayAssignmentMutationVariables,
  DuplicateRequest,
  DuplicateRequestMutation,
  DuplicateRequestMutationVariables,
  ReactivateRequest,
  ReactivateRequestMutation,
  ReactivateRequestMutationVariables,
  ReactivateRequestFromTransferCenter,
  ReactivateRequestFromTransferCenterMutation,
  ReactivateRequestFromTransferCenterMutationVariables,
  RecalculateCandidates,
  RecalculateCandidatesMutation,
  RecalculateCandidatesMutationVariables,
  RequestPublicRelationFromUnit,
  RequestPublicRelationFromUnitMutation,
  RequestPublicRelationFromUnitMutationVariables,
  UpdateRequest,
  UpdateRequestMutation,
  UpdateRequestMutationVariables,
  UpdateRequestAtlo,
  UpdateRequestAtloMutation,
  UpdateRequestAtloMutationVariables,
  UpdateRequestPublicUtilityInfo,
  UpdateRequestPublicUtilityInfoMutation,
  UpdateRequestPublicUtilityInfoMutationVariables,
  UpdateRequestRegion,
  UpdateRequestRegionMutation,
  UpdateRequestRegionMutationVariables,
  UpdateRequestSafetyQuestions,
  UpdateRequestSafetyQuestionsMutation,
  UpdateRequestSafetyQuestionsMutationVariables,
  UpdateRequestStandbyStatus,
  UpdateRequestStandbyStatusMutation,
  UpdateRequestStandbyStatusMutationVariables,
  AddTimelineItem,
  AddTimelineItemMutation,
  AddTimelineItemMutationVariables,
  DeleteTimelineItem,
  DeleteTimelineItemMutation,
  DeleteTimelineItemMutationVariables,
  UpdateTimelineItem,
  UpdateTimelineItemMutation,
  UpdateTimelineItemMutationVariables,
  UpsertTimelineItem,
  UpsertTimelineItemMutation,
  UpsertTimelineItemMutationVariables,
  AddTimeline,
  AddTimelineMutation,
  AddTimelineMutationVariables,
  DeleteTimeline,
  DeleteTimelineMutation,
  DeleteTimelineMutationVariables,
  UpdateTimeline,
  UpdateTimelineMutation,
  UpdateTimelineMutationVariables,
  AddEmsReport,
  AddEmsReportMutation,
  AddEmsReportMutationVariables,
  AddTimestamp,
  AddTimestampMutation,
  AddTimestampMutationVariables,
  DeleteTimestamp,
  DeleteTimestampMutation,
  DeleteTimestampMutationVariables,
  ReSendToDataWarehouse,
  ReSendToDataWarehouseMutation,
  ReSendToDataWarehouseMutationVariables,
  SendToImageTrend,
  SendToImageTrendMutation,
  SendToImageTrendMutationVariables,
  UpdateEmsReport,
  UpdateEmsReportMutation,
  UpdateEmsReportMutationVariables,
  UpdateTimestamp,
  UpdateTimestampMutation,
  UpdateTimestampMutationVariables,
  AddTimestampType,
  AddTimestampTypeMutation,
  AddTimestampTypeMutationVariables,
  DeleteTimestampType,
  DeleteTimestampTypeMutation,
  DeleteTimestampTypeMutationVariables,
  UpdateTimestampType,
  UpdateTimestampTypeMutation,
  UpdateTimestampTypeMutationVariables,
  DeliverTrackedMessage,
  DeliverTrackedMessageMutation,
  DeliverTrackedMessageMutationVariables,
  SendMessage,
  SendMessageMutation,
  SendMessageMutationVariables,
  SendSupportRequestEmail,
  SendSupportRequestEmailMutation,
  SendSupportRequestEmailMutationVariables,
  UpdateTrackedMessage,
  UpdateTrackedMessageMutation,
  UpdateTrackedMessageMutationVariables,
  AddTransferReason,
  AddTransferReasonMutation,
  AddTransferReasonMutationVariables,
  DeleteTransferReason,
  DeleteTransferReasonMutation,
  DeleteTransferReasonMutationVariables,
  UpdateTransferReason,
  UpdateTransferReasonMutation,
  UpdateTransferReasonMutationVariables,
  UpdateTransportOfferOption,
  UpdateTransportOfferOptionMutation,
  UpdateTransportOfferOptionMutationVariables,
  AcceptTransportOffer,
  AcceptTransportOfferMutation,
  AcceptTransportOfferMutationVariables,
  AddCancellation,
  AddCancellationMutation,
  AddCancellationMutationVariables,
  AddDecline,
  AddDeclineMutation,
  AddDeclineMutationVariables,
  AddTransportOffer,
  AddTransportOfferMutation,
  AddTransportOfferMutationVariables,
  BeginTransportOffer,
  BeginTransportOfferMutation,
  BeginTransportOfferMutationVariables,
  CancelTransportOffer,
  CancelTransportOfferMutation,
  CancelTransportOfferMutationVariables,
  DeclineAndAssignNewTransportOffer,
  DeclineAndAssignNewTransportOfferMutation,
  DeclineAndAssignNewTransportOfferMutationVariables,
  DeclineTransportOffer,
  DeclineTransportOfferMutation,
  DeclineTransportOfferMutationVariables,
  DeclineTransportOfferAndDelayAssignment,
  DeclineTransportOfferAndDelayAssignmentMutation,
  DeclineTransportOfferAndDelayAssignmentMutationVariables,
  DeleteTransportOffer,
  DeleteTransportOfferMutation,
  DeleteTransportOfferMutationVariables,
  InitiateTransportCheck,
  InitiateTransportCheckMutation,
  InitiateTransportCheckMutationVariables,
  OfferWithBulkSkip,
  OfferWithBulkSkipMutation,
  OfferWithBulkSkipMutationVariables,
  ReferTransportOffer,
  ReferTransportOfferMutation,
  ReferTransportOfferMutationVariables,
  SkipTransportOffer,
  SkipTransportOfferMutation,
  SkipTransportOfferMutationVariables,
  UpdateCancellation,
  UpdateCancellationMutation,
  UpdateCancellationMutationVariables,
  UpdateDecline,
  UpdateDeclineMutation,
  UpdateDeclineMutationVariables,
  UpdateOfferRank,
  UpdateOfferRankMutation,
  UpdateOfferRankMutationVariables,
  UpdateSkip,
  UpdateSkipMutation,
  UpdateSkipMutationVariables,
  UpdateTransportOffer,
  UpdateTransportOfferMutation,
  UpdateTransportOfferMutationVariables,
  UpdateTransportOfferEta,
  UpdateTransportOfferEtaMutation,
  UpdateTransportOfferEtaMutationVariables,
  AddTransportReason,
  AddTransportReasonMutation,
  AddTransportReasonMutationVariables,
  DeleteTransportReason,
  DeleteTransportReasonMutation,
  DeleteTransportReasonMutationVariables,
  UpdateTransportReason,
  UpdateTransportReasonMutation,
  UpdateTransportReasonMutationVariables,
  AddManifestEntry,
  AddManifestEntryMutation,
  AddManifestEntryMutationVariables,
  DeleteManifestEntry,
  DeleteManifestEntryMutation,
  DeleteManifestEntryMutationVariables,
  UpdateManifestEntry,
  UpdateManifestEntryMutation,
  UpdateManifestEntryMutationVariables,
  UpdateOdometerReadings,
  UpdateOdometerReadingsMutation,
  UpdateOdometerReadingsMutationVariables,
  UpdateTripLegOnFinal,
  UpdateTripLegOnFinalMutation,
  UpdateTripLegOnFinalMutationVariables,
  AddTripPassenger,
  AddTripPassengerMutation,
  AddTripPassengerMutationVariables,
  DeleteTripPassenger,
  DeleteTripPassengerMutation,
  DeleteTripPassengerMutationVariables,
  UpdateTripPassenger,
  UpdateTripPassengerMutation,
  UpdateTripPassengerMutationVariables,
  AddTrip,
  AddTripMutation,
  AddTripMutationVariables,
  AddTripLegManifestEntry,
  AddTripLegManifestEntryMutation,
  AddTripLegManifestEntryMutationVariables,
  CalculateEtas,
  CalculateEtasMutation,
  CalculateEtasMutationVariables,
  ConfirmManifest,
  ConfirmManifestMutation,
  ConfirmManifestMutationVariables,
  CreatePrecautionaryLanding,
  CreatePrecautionaryLandingMutation,
  CreatePrecautionaryLandingMutationVariables,
  CreatePrecautionaryLandingV2,
  CreatePrecautionaryLandingV2Mutation,
  CreatePrecautionaryLandingV2MutationVariables,
  DeleteTrip,
  DeleteTripMutation,
  DeleteTripMutationVariables,
  DeleteTripLegManifestEntry,
  DeleteTripLegManifestEntryMutation,
  DeleteTripLegManifestEntryMutationVariables,
  InsertWaypoint,
  InsertWaypointMutation,
  InsertWaypointMutationVariables,
  MergePostAndDropoffWaypoints,
  MergePostAndDropoffWaypointsMutation,
  MergePostAndDropoffWaypointsMutationVariables,
  MergeUnitOriginAndPickupWaypoints,
  MergeUnitOriginAndPickupWaypointsMutation,
  MergeUnitOriginAndPickupWaypointsMutationVariables,
  ModifyWaypoint,
  ModifyWaypointMutation,
  ModifyWaypointMutationVariables,
  RecalculateTripMileage,
  RecalculateTripMileageMutation,
  RecalculateTripMileageMutationVariables,
  RemoveWaypoint,
  RemoveWaypointMutation,
  RemoveWaypointMutationVariables,
  SplitUnitOriginAndPickupWaypoints,
  SplitUnitOriginAndPickupWaypointsMutation,
  SplitUnitOriginAndPickupWaypointsMutationVariables,
  SplitUnitPostAndDropoffWaypoints,
  SplitUnitPostAndDropoffWaypointsMutation,
  SplitUnitPostAndDropoffWaypointsMutationVariables,
  SwapWaypoint,
  SwapWaypointMutation,
  SwapWaypointMutationVariables,
  UpdateTrip,
  UpdateTripMutation,
  UpdateTripMutationVariables,
  AddUnitActivationRule,
  AddUnitActivationRuleMutation,
  AddUnitActivationRuleMutationVariables,
  DeleteUnitActivationRule,
  DeleteUnitActivationRuleMutation,
  DeleteUnitActivationRuleMutationVariables,
  UpdateUnitActivationRule,
  UpdateUnitActivationRuleMutation,
  UpdateUnitActivationRuleMutationVariables,
  AddUnitEMSystemMapping,
  AddUnitEMSystemMappingMutation,
  AddUnitEMSystemMappingMutationVariables,
  DeleteUnitEMSystemMapping,
  DeleteUnitEMSystemMappingMutation,
  DeleteUnitEMSystemMappingMutationVariables,
  UpdateUnitEMSystemMapping,
  UpdateUnitEMSystemMappingMutation,
  UpdateUnitEMSystemMappingMutationVariables,
  AddUnitNote,
  AddUnitNoteMutation,
  AddUnitNoteMutationVariables,
  DeleteUnitNote,
  DeleteUnitNoteMutation,
  DeleteUnitNoteMutationVariables,
  UpdateUnitNote,
  UpdateUnitNoteMutation,
  UpdateUnitNoteMutationVariables,
  AddUnitPosition,
  AddUnitPositionMutation,
  AddUnitPositionMutationVariables,
  DeleteUnitPosition,
  DeleteUnitPositionMutation,
  DeleteUnitPositionMutationVariables,
  RemoveTeamMemberFromUnitPosition,
  RemoveTeamMemberFromUnitPositionMutation,
  RemoveTeamMemberFromUnitPositionMutationVariables,
  UpdateUnitPosition,
  UpdateUnitPositionMutation,
  UpdateUnitPositionMutationVariables,
  UpsertUnitPosition,
  UpsertUnitPositionMutation,
  UpsertUnitPositionMutationVariables,
  AddUnit,
  AddUnitMutation,
  AddUnitMutationVariables,
  AssignVehicle,
  AssignVehicleMutation,
  AssignVehicleMutationVariables,
  DelayUnit,
  DelayUnitMutation,
  DelayUnitMutationVariables,
  DeleteUnit,
  DeleteUnitMutation,
  DeleteUnitMutationVariables,
  DisableUnit,
  DisableUnitMutation,
  DisableUnitMutationVariables,
  EnableUnit,
  EnableUnitMutation,
  EnableUnitMutationVariables,
  EnsureThirdPartyUnit,
  EnsureThirdPartyUnitMutation,
  EnsureThirdPartyUnitMutationVariables,
  EnsureThirdPartyUnits,
  EnsureThirdPartyUnitsMutation,
  EnsureThirdPartyUnitsMutationVariables,
  HideUnit,
  HideUnitMutation,
  HideUnitMutationVariables,
  MarkAsPilotUpdated,
  MarkAsPilotUpdatedMutation,
  MarkAsPilotUpdatedMutationVariables,
  ReassignVehicle,
  ReassignVehicleMutation,
  ReassignVehicleMutationVariables,
  RemoveDelayFromUnit,
  RemoveDelayFromUnitMutation,
  RemoveDelayFromUnitMutationVariables,
  RemoveVehicleFromUnit,
  RemoveVehicleFromUnitMutation,
  RemoveVehicleFromUnitMutationVariables,
  ReturnUnitToService,
  ReturnUnitToServiceMutation,
  ReturnUnitToServiceMutationVariables,
  SourceCrewFromOutOfServiceUnit,
  SourceCrewFromOutOfServiceUnitMutation,
  SourceCrewFromOutOfServiceUnitMutationVariables,
  SwapUnitVehicles,
  SwapUnitVehiclesMutation,
  SwapUnitVehiclesMutationVariables,
  TakeUnitOutOfService,
  TakeUnitOutOfServiceMutation,
  TakeUnitOutOfServiceMutationVariables,
  TeleportUnit,
  TeleportUnitMutation,
  TeleportUnitMutationVariables,
  UnhideUnit,
  UnhideUnitMutation,
  UnhideUnitMutationVariables,
  UpdatePilotUnitConfiguration,
  UpdatePilotUnitConfigurationMutation,
  UpdatePilotUnitConfigurationMutationVariables,
  UpdateUnit,
  UpdateUnitMutation,
  UpdateUnitMutationVariables,
  UpdateUnitConfiguration,
  UpdateUnitConfigurationMutation,
  UpdateUnitConfigurationMutationVariables,
  AddUnitShift,
  AddUnitShiftMutation,
  AddUnitShiftMutationVariables,
  DeleteUnitShift,
  DeleteUnitShiftMutation,
  DeleteUnitShiftMutationVariables,
  UpdateUnitShift,
  UpdateUnitShiftMutation,
  UpdateUnitShiftMutationVariables,
  AddVehicleDisposition,
  AddVehicleDispositionMutation,
  AddVehicleDispositionMutationVariables,
  DeleteVehicleDisposition,
  DeleteVehicleDispositionMutation,
  DeleteVehicleDispositionMutationVariables,
  UpdateVehicleDisposition,
  UpdateVehicleDispositionMutation,
  UpdateVehicleDispositionMutationVariables,
  AddVehicleNotificationGroup,
  AddVehicleNotificationGroupMutation,
  AddVehicleNotificationGroupMutationVariables,
  DeleteVehicleNotificationGroup,
  DeleteVehicleNotificationGroupMutation,
  DeleteVehicleNotificationGroupMutationVariables,
  AddFuelBurn,
  AddFuelBurnMutation,
  AddFuelBurnMutationVariables,
  AddWaypoint,
  AddWaypointMutation,
  AddWaypointMutationVariables,
  DeleteWaypoint,
  DeleteWaypointMutation,
  DeleteWaypointMutationVariables,
  UpdateWaypoint,
  UpdateWaypointMutation,
  UpdateWaypointMutationVariables,
  AcknowledgeWebOrderLog,
  AcknowledgeWebOrderLogMutation,
  AcknowledgeWebOrderLogMutationVariables,
  AddWebOrderLog,
  AddWebOrderLogMutation,
  AddWebOrderLogMutationVariables,
} from '../graphql-operation-types.generated';
import {
  GraphqlMutationExecutorService,
  GraphQLMutationExecutionOptions,
} from '../graphql-mutation-executor.service';

export enum OpsCommand {
  AddActivationRule = 'AddActivationRule',
  DeleteActivationRule = 'DeleteActivationRule',
  UpdateActivationRule = 'UpdateActivationRule',
  AcknowledgeAlert = 'AcknowledgeAlert',
  AddActiveAlert = 'AddActiveAlert',
  CleanupActiveAlerts = 'CleanupActiveAlerts',
  CleanupCardActiveAlerts = 'CleanupCardActiveAlerts',
  DeleteActiveAlert = 'DeleteActiveAlert',
  SnoozeAlert = 'SnoozeAlert',
  UpdateActiveAlert = 'UpdateActiveAlert',
  DeleteActiveTimeline = 'DeleteActiveTimeline',
  UpdateActiveTimeline = 'UpdateActiveTimeline',
  AddAlert = 'AddAlert',
  CopyAlert = 'CopyAlert',
  DeleteAlert = 'DeleteAlert',
  UpdateAlert = 'UpdateAlert',
  AddApplicationNotification = 'AddApplicationNotification',
  DeleteApplicationNotification = 'DeleteApplicationNotification',
  DismissApplicationNotification = 'DismissApplicationNotification',
  UpdateApplicationNotification = 'UpdateApplicationNotification',
  AddAssignmentDelayedReason = 'AddAssignmentDelayedReason',
  DeleteAssignmentDelayedReason = 'DeleteAssignmentDelayedReason',
  UpdateAssignmentDelayedReason = 'UpdateAssignmentDelayedReason',
  AddCancellationCategory = 'AddCancellationCategory',
  DeleteCancellationCategory = 'DeleteCancellationCategory',
  UpdateCancellationCategory = 'UpdateCancellationCategory',
  AddCancellationReason = 'AddCancellationReason',
  DeleteCancellationReason = 'DeleteCancellationReason',
  UpdateCancellationReason = 'UpdateCancellationReason',
  AddCancellationSecondaryReason = 'AddCancellationSecondaryReason',
  DeleteCancellationSecondaryReason = 'DeleteCancellationSecondaryReason',
  UpdateCancellationSecondaryReason = 'UpdateCancellationSecondaryReason',
  AddCardLink = 'AddCardLink',
  DeleteCardLink = 'DeleteCardLink',
  UpdateCardLink = 'UpdateCardLink',
  AddCardNoteArchive = 'AddCardNoteArchive',
  DeleteCardNoteArchive = 'DeleteCardNoteArchive',
  UpdateCardNoteArchive = 'UpdateCardNoteArchive',
  AddCardNote = 'AddCardNote',
  DeleteCardNote = 'DeleteCardNote',
  SendNoteToCard = 'SendNoteToCard',
  UpdateCardNote = 'UpdateCardNote',
  AddCardReOpenReason = 'AddCardReOpenReason',
  DeleteCardReOpenReason = 'DeleteCardReOpenReason',
  UpdateCardReOpenReason = 'UpdateCardReOpenReason',
  AddCard = 'AddCard',
  ChangeCardCallStatus = 'ChangeCardCallStatus',
  ChangeUnit = 'ChangeUnit',
  CheckForFlightFollowingDestinationConflict = 'CheckForFlightFollowingDestinationConflict',
  CleanupCards = 'CleanupCards',
  CloseCard = 'CloseCard',
  CreateSystemCrewNotification = 'CreateSystemCrewNotification',
  DeleteCard = 'DeleteCard',
  Divert = 'Divert',
  GenerateCardReport = 'GenerateCardReport',
  GenerateCardSummaryChange = 'GenerateCardSummaryChange',
  GenerateCardSummaryChangeV2 = 'GenerateCardSummaryChangeV2',
  LinkCards = 'LinkCards',
  ReOpenCard = 'ReOpenCard',
  RequestAdditionalUnits = 'RequestAdditionalUnits',
  ScanForFlights = 'ScanForFlights',
  SendPatientInfo = 'SendPatientInfo',
  SetCardLockStatus = 'SetCardLockStatus',
  UnDeleteCard = 'UnDeleteCard',
  UpdateCard = 'UpdateCard',
  UpdateCardBillable = 'UpdateCardBillable',
  UpdateCardContactCompleted = 'UpdateCardContactCompleted',
  UpdateCardDiversionType = 'UpdateCardDiversionType',
  UpdateCardSearchIndex = 'UpdateCardSearchIndex',
  UpdateGmrCadNumber = 'UpdateGmrCadNumber',
  UpdatePlannedCardCompletionTime = 'UpdatePlannedCardCompletionTime',
  AddConfigurationSetting = 'AddConfigurationSetting',
  UpdateConfigurationSetting = 'UpdateConfigurationSetting',
  AddConversationToCardWithParticipant = 'AddConversationToCardWithParticipant',
  CloseConversation = 'CloseConversation',
  AddDeclineCategory = 'AddDeclineCategory',
  DeleteDeclineCategory = 'DeleteDeclineCategory',
  UpdateDeclineCategory = 'UpdateDeclineCategory',
  AddDeclineReason = 'AddDeclineReason',
  DeleteDeclineReason = 'DeleteDeclineReason',
  UpdateDeclineReason = 'UpdateDeclineReason',
  AddDeclineSecondaryReason = 'AddDeclineSecondaryReason',
  DeleteDeclineSecondaryReason = 'DeleteDeclineSecondaryReason',
  UpdateDeclineSecondaryReason = 'UpdateDeclineSecondaryReason',
  AddDiversionReason = 'AddDiversionReason',
  DeleteDiversionReason = 'DeleteDiversionReason',
  UpdateDiversionReason = 'UpdateDiversionReason',
  AddEscortRequest = 'AddEscortRequest',
  DeleteEscortRequest = 'DeleteEscortRequest',
  UpdateEscortRequest = 'UpdateEscortRequest',
  MakeEstimatedDurationOfficial = 'MakeEstimatedDurationOfficial',
  UpdateEstimatedDurations = 'UpdateEstimatedDurations',
  UpdateTripLegDuration = 'UpdateTripLegDuration',
  UpdateWaypointDuration = 'UpdateWaypointDuration',
  AddExternalAction = 'AddExternalAction',
  CleanupPendingExternalActions = 'CleanupPendingExternalActions',
  DeleteExternalAction = 'DeleteExternalAction',
  DisregardExternalAction = 'DisregardExternalAction',
  UpdateExternalAction = 'UpdateExternalAction',
  AddExternalActionType = 'AddExternalActionType',
  DeleteExternalActionType = 'DeleteExternalActionType',
  UpdateExternalActionType = 'UpdateExternalActionType',
  AddFacilityNonAcceptanceReason = 'AddFacilityNonAcceptanceReason',
  DeleteFacilityNonAcceptanceReason = 'DeleteFacilityNonAcceptanceReason',
  UpdateFacilityNonAcceptanceReason = 'UpdateFacilityNonAcceptanceReason',
  AddFirewallRule = 'AddFirewallRule',
  DeleteFirewallRule = 'DeleteFirewallRule',
  UpdateFirewallRule = 'UpdateFirewallRule',
  AddFlightFollowingReport = 'AddFlightFollowingReport',
  DeleteFlightFollowingReport = 'DeleteFlightFollowingReport',
  UpdateFlightFollowingReport = 'UpdateFlightFollowingReport',
  DeleteLocationHazardAttachment = 'DeleteLocationHazardAttachment',
  GenerateLocationHazardAttachmentUrl = 'GenerateLocationHazardAttachmentUrl',
  AddLocationHazard = 'AddLocationHazard',
  DeleteLocationHazard = 'DeleteLocationHazard',
  UpdateLocationHazard = 'UpdateLocationHazard',
  AddMedicalControlContactLogEntry = 'AddMedicalControlContactLogEntry',
  DeleteMedicalControlContactLogEntry = 'DeleteMedicalControlContactLogEntry',
  UpdateMedicalControlContactLogEntry = 'UpdateMedicalControlContactLogEntry',
  AddMessageStatusUpdate = 'AddMessageStatusUpdate',
  AddNewAgencyLocationRequest = 'AddNewAgencyLocationRequest',
  DeleteNewAgencyLocationRequest = 'DeleteNewAgencyLocationRequest',
  UpdateNewAgencyLocationRequest = 'UpdateNewAgencyLocationRequest',
  AddNextDueType = 'AddNextDueType',
  DeleteNextDueType = 'DeleteNextDueType',
  UpdateNextDueType = 'UpdateNextDueType',
  AddNonReferralReason = 'AddNonReferralReason',
  DeleteNonReferralReason = 'DeleteNonReferralReason',
  UpdateNonReferralReason = 'UpdateNonReferralReason',
  AddNotificationGroupMember = 'AddNotificationGroupMember',
  DeleteNotificationGroupMember = 'DeleteNotificationGroupMember',
  UpdateNotificationGroupMember = 'UpdateNotificationGroupMember',
  AddNotificationGroup = 'AddNotificationGroup',
  DeleteNotificationGroup = 'DeleteNotificationGroup',
  UpdateNotificationGroup = 'UpdateNotificationGroup',
  UpsertPersonNotificationGroups = 'UpsertPersonNotificationGroups',
  AddNotificationRecipient = 'AddNotificationRecipient',
  AddNotificationRecipients = 'AddNotificationRecipients',
  DeleteNotificationRecipient = 'DeleteNotificationRecipient',
  DeleteNotificationRecipients = 'DeleteNotificationRecipients',
  UpdateNotificationRecipient = 'UpdateNotificationRecipient',
  UpdateRecipientMessageStatus = 'UpdateRecipientMessageStatus',
  AddNotification = 'AddNotification',
  DeleteNotification = 'DeleteNotification',
  SendNotification = 'SendNotification',
  UpdateNotification = 'UpdateNotification',
  AddNotificationSubscription = 'AddNotificationSubscription',
  DeleteNotificationSubscription = 'DeleteNotificationSubscription',
  UpdateNotificationSubscription = 'UpdateNotificationSubscription',
  AddNotificationTemplate = 'AddNotificationTemplate',
  CopyNotificationTemplate = 'CopyNotificationTemplate',
  DeleteNotificationTemplate = 'DeleteNotificationTemplate',
  UpdateNotificationTemplate = 'UpdateNotificationTemplate',
  AddOemActivity = 'AddOemActivity',
  DeleteOemActivity = 'DeleteOemActivity',
  UpdateOemActivity = 'UpdateOemActivity',
  AddOemAsset = 'AddOemAsset',
  DeleteOemAsset = 'DeleteOemAsset',
  UpdateOemAsset = 'UpdateOemAsset',
  AddOemPlanChangeRequest = 'AddOemPlanChangeRequest',
  DeleteOemPlanChangeRequest = 'DeleteOemPlanChangeRequest',
  UpdateOemPlanChangeRequest = 'UpdateOemPlanChangeRequest',
  AddOemPlan = 'AddOemPlan',
  DeleteOemPlan = 'DeleteOemPlan',
  UpdateOemPlan = 'UpdateOemPlan',
  AddOfferAlgorithm = 'AddOfferAlgorithm',
  CopyOfferAlgorithm = 'CopyOfferAlgorithm',
  DeleteOfferAlgorithm = 'DeleteOfferAlgorithm',
  UpdateOfferAlgorithm = 'UpdateOfferAlgorithm',
  ActivateUnit = 'ActivateUnit',
  AddOperation = 'AddOperation',
  ArriveVehicle = 'ArriveVehicle',
  CancelOperation = 'CancelOperation',
  ChangeVehicle = 'ChangeVehicle',
  CreateGroundRun = 'CreateGroundRun',
  CreateMaintenanceOperation = 'CreateMaintenanceOperation',
  CreateTrainingOperation = 'CreateTrainingOperation',
  DeclineOrAbortOperation = 'DeclineOrAbortOperation',
  DeleteOperation = 'DeleteOperation',
  DepartVehicle = 'DepartVehicle',
  PlaceUnitOnStandby = 'PlaceUnitOnStandby',
  RepositionUnit = 'RepositionUnit',
  UndoAbortOperation = 'UndoAbortOperation',
  UndoArriveVehicle = 'UndoArriveVehicle',
  UndoDepartVehicle = 'UndoDepartVehicle',
  UpdateOperation = 'UpdateOperation',
  UpdateOperationContactInfo = 'UpdateOperationContactInfo',
  UpdateRiskAnalysis = 'UpdateRiskAnalysis',
  AddOutOfServiceEventNote = 'AddOutOfServiceEventNote',
  DeleteOutOfServiceEventNote = 'DeleteOutOfServiceEventNote',
  UpdateOutOfServiceEventNote = 'UpdateOutOfServiceEventNote',
  AcknowledgeOutOfServiceEvent = 'AcknowledgeOutOfServiceEvent',
  AddCrewOutOfServiceEvent = 'AddCrewOutOfServiceEvent',
  AddOutOfServiceEvent = 'AddOutOfServiceEvent',
  AddUnitOutOfServiceEvent = 'AddUnitOutOfServiceEvent',
  AddVehicleOutOfServiceEvent = 'AddVehicleOutOfServiceEvent',
  BeginOutOfServiceEvent = 'BeginOutOfServiceEvent',
  CreateTicketFromOutOfServiceEvent = 'CreateTicketFromOutOfServiceEvent',
  DeleteOutOfServiceEvent = 'DeleteOutOfServiceEvent',
  EndCrewMemberOutOfServiceEvent = 'EndCrewMemberOutOfServiceEvent',
  EndOutOfServiceEvent = 'EndOutOfServiceEvent',
  LinkOutOfServiceEvent = 'LinkOutOfServiceEvent',
  UpdateOutOfServiceEvent = 'UpdateOutOfServiceEvent',
  AddOutOfServiceReason = 'AddOutOfServiceReason',
  DeleteOutOfServiceReason = 'DeleteOutOfServiceReason',
  UpdateOutOfServiceReason = 'UpdateOutOfServiceReason',
  AddOutOfServiceSecondaryReason = 'AddOutOfServiceSecondaryReason',
  DeleteOutOfServiceSecondaryReason = 'DeleteOutOfServiceSecondaryReason',
  UpdateOutOfServiceSecondaryReason = 'UpdateOutOfServiceSecondaryReason',
  AcceptOutOfServiceTicket = 'AcceptOutOfServiceTicket',
  AcknowledgeOutOfServiceTicket = 'AcknowledgeOutOfServiceTicket',
  CloseTicketsForOOSEvent = 'CloseTicketsForOOSEvent',
  DeleteOutOfServiceTicket = 'DeleteOutOfServiceTicket',
  ReviewSubmittedOutOfServiceTicket = 'ReviewSubmittedOutOfServiceTicket',
  SubmitOutOfServiceTicket = 'SubmitOutOfServiceTicket',
  AddPaipEvent = 'AddPaipEvent',
  DeletePaipEvent = 'DeletePaipEvent',
  EndPaipEvent = 'EndPaipEvent',
  UpdatePaipEvent = 'UpdatePaipEvent',
  AddPaipReason = 'AddPaipReason',
  DeletePaipReason = 'DeletePaipReason',
  UpdatePaipReason = 'UpdatePaipReason',
  ArchivePassdownLog = 'ArchivePassdownLog',
  AcknowledgePassdownLog = 'AcknowledgePassdownLog',
  AddPassdownLog = 'AddPassdownLog',
  DeletePassdownLog = 'DeletePassdownLog',
  UpdatePassdownLog = 'UpdatePassdownLog',
  AddPositionReportAlert = 'AddPositionReportAlert',
  DeletePositionReportAlert = 'DeletePositionReportAlert',
  UpdatePositionReportAlert = 'UpdatePositionReportAlert',
  AddPositionReport = 'AddPositionReport',
  ConfirmPositionReport = 'ConfirmPositionReport',
  DeletePositionReport = 'DeletePositionReport',
  UpdatePositionReport = 'UpdatePositionReport',
  UpsertQuestionChoice = 'UpsertQuestionChoice',
  AddQuestionnaireQuestionResponseNote = 'AddQuestionnaireQuestionResponseNote',
  DeleteQuestionnaireQuestionResponseNote = 'DeleteQuestionnaireQuestionResponseNote',
  UpdateQuestionnaireQuestionResponseNote = 'UpdateQuestionnaireQuestionResponseNote',
  UpsertQuestionnaireQuestionResponseNote = 'UpsertQuestionnaireQuestionResponseNote',
  AddQuestionnaireQuestionResponse = 'AddQuestionnaireQuestionResponse',
  DeleteQuestionnaireQuestionResponse = 'DeleteQuestionnaireQuestionResponse',
  UpdateQuestionnaireQuestionResponse = 'UpdateQuestionnaireQuestionResponse',
  UpdateQuestionnaireQuestionResponseDeep = 'UpdateQuestionnaireQuestionResponseDeep',
  AddQuestionnaireResponse = 'AddQuestionnaireResponse',
  DeleteQuestionnaireResponse = 'DeleteQuestionnaireResponse',
  SubmitQuestionnaireResponse = 'SubmitQuestionnaireResponse',
  UpdateQuestionnaireResponse = 'UpdateQuestionnaireResponse',
  UpdateQuestionnaireResponseDeep = 'UpdateQuestionnaireResponseDeep',
  AddQuestionnaire = 'AddQuestionnaire',
  DeleteQuestionnaire = 'DeleteQuestionnaire',
  UpdateQuestionnaire = 'UpdateQuestionnaire',
  DeleteQuestionnaireSectionQuestion = 'DeleteQuestionnaireSectionQuestion',
  UpsertQuestionnaireSectionQuestion = 'UpsertQuestionnaireSectionQuestion',
  DeleteQuestionnaireSection = 'DeleteQuestionnaireSection',
  UpsertQuestionnaireSection = 'UpsertQuestionnaireSection',
  AddQuestion = 'AddQuestion',
  DeleteQuestion = 'DeleteQuestion',
  UpdateQuestion = 'UpdateQuestion',
  AcceptReceivingFacilityRequest = 'AcceptReceivingFacilityRequest',
  AddReceivingFacilityRequestDeclineHistory = 'AddReceivingFacilityRequestDeclineHistory',
  CancelReceivingFacilityRequest = 'CancelReceivingFacilityRequest',
  DeleteReceivingFacilityRequest = 'DeleteReceivingFacilityRequest',
  DenyReceivingFacilityRequest = 'DenyReceivingFacilityRequest',
  DivertReceivingFacilityRequest = 'DivertReceivingFacilityRequest',
  ReferReceivingFacilityRequest = 'ReferReceivingFacilityRequest',
  AddRendezvousRequest = 'AddRendezvousRequest',
  DeleteRendezvousRequest = 'DeleteRendezvousRequest',
  UpdateRendezvousRequest = 'UpdateRendezvousRequest',
  AddRequesterRole = 'AddRequesterRole',
  DeleteRequesterRole = 'DeleteRequesterRole',
  UpdateRequesterRole = 'UpdateRequesterRole',
  UpdateRequester = 'UpdateRequester',
  UpdateRequesterSpecialtyTeam = 'UpdateRequesterSpecialtyTeam',
  UpdateRequestorAgencyLocation = 'UpdateRequestorAgencyLocation',
  UpdateTransferCenterCallInfo = 'UpdateTransferCenterCallInfo',
  UpdateReceivingFacilityAutoAcceptance = 'UpdateReceivingFacilityAutoAcceptance',
  UpdateRequestLocation = 'UpdateRequestLocation',
  AddRequestPatient = 'AddRequestPatient',
  DeleteRequestPatient = 'DeleteRequestPatient',
  UpdateChiefComplaint = 'UpdateChiefComplaint',
  UpdatePatientClinicalInfo = 'UpdatePatientClinicalInfo',
  UpdatePatientInfo = 'UpdatePatientInfo',
  UpdateRequestPatient = 'UpdateRequestPatient',
  AcknowledgeExternalRequest = 'AcknowledgeExternalRequest',
  BeginAssignment = 'BeginAssignment',
  CancelRequest = 'CancelRequest',
  CancelRequestFromTransferCenter = 'CancelRequestFromTransferCenter',
  ChangeCallType = 'ChangeCallType',
  ChangeRequestCancellationReason = 'ChangeRequestCancellationReason',
  ChangeRequestType = 'ChangeRequestType',
  CreateRequest = 'CreateRequest',
  DelayAssignment = 'DelayAssignment',
  DuplicateRequest = 'DuplicateRequest',
  ReactivateRequest = 'ReactivateRequest',
  ReactivateRequestFromTransferCenter = 'ReactivateRequestFromTransferCenter',
  RecalculateCandidates = 'RecalculateCandidates',
  RequestPublicRelationFromUnit = 'RequestPublicRelationFromUnit',
  UpdateRequest = 'UpdateRequest',
  UpdateRequestAtlo = 'UpdateRequestAtlo',
  UpdateRequestPublicUtilityInfo = 'UpdateRequestPublicUtilityInfo',
  UpdateRequestRegion = 'UpdateRequestRegion',
  UpdateRequestSafetyQuestions = 'UpdateRequestSafetyQuestions',
  UpdateRequestStandbyStatus = 'UpdateRequestStandbyStatus',
  AddTimelineItem = 'AddTimelineItem',
  DeleteTimelineItem = 'DeleteTimelineItem',
  UpdateTimelineItem = 'UpdateTimelineItem',
  UpsertTimelineItem = 'UpsertTimelineItem',
  AddTimeline = 'AddTimeline',
  DeleteTimeline = 'DeleteTimeline',
  UpdateTimeline = 'UpdateTimeline',
  AddEmsReport = 'AddEmsReport',
  AddTimestamp = 'AddTimestamp',
  DeleteTimestamp = 'DeleteTimestamp',
  ReSendToDataWarehouse = 'ReSendToDataWarehouse',
  SendToImageTrend = 'SendToImageTrend',
  UpdateEmsReport = 'UpdateEmsReport',
  UpdateTimestamp = 'UpdateTimestamp',
  AddTimestampType = 'AddTimestampType',
  DeleteTimestampType = 'DeleteTimestampType',
  UpdateTimestampType = 'UpdateTimestampType',
  DeliverTrackedMessage = 'DeliverTrackedMessage',
  SendMessage = 'SendMessage',
  SendSupportRequestEmail = 'SendSupportRequestEmail',
  UpdateTrackedMessage = 'UpdateTrackedMessage',
  AddTransferReason = 'AddTransferReason',
  DeleteTransferReason = 'DeleteTransferReason',
  UpdateTransferReason = 'UpdateTransferReason',
  UpdateTransportOfferOption = 'UpdateTransportOfferOption',
  AcceptTransportOffer = 'AcceptTransportOffer',
  AddCancellation = 'AddCancellation',
  AddDecline = 'AddDecline',
  AddTransportOffer = 'AddTransportOffer',
  BeginTransportOffer = 'BeginTransportOffer',
  CancelTransportOffer = 'CancelTransportOffer',
  DeclineAndAssignNewTransportOffer = 'DeclineAndAssignNewTransportOffer',
  DeclineTransportOffer = 'DeclineTransportOffer',
  DeclineTransportOfferAndDelayAssignment = 'DeclineTransportOfferAndDelayAssignment',
  DeleteTransportOffer = 'DeleteTransportOffer',
  InitiateTransportCheck = 'InitiateTransportCheck',
  OfferWithBulkSkip = 'OfferWithBulkSkip',
  ReferTransportOffer = 'ReferTransportOffer',
  SkipTransportOffer = 'SkipTransportOffer',
  UpdateCancellation = 'UpdateCancellation',
  UpdateDecline = 'UpdateDecline',
  UpdateOfferRank = 'UpdateOfferRank',
  UpdateSkip = 'UpdateSkip',
  UpdateTransportOffer = 'UpdateTransportOffer',
  UpdateTransportOfferEta = 'UpdateTransportOfferEta',
  AddTransportReason = 'AddTransportReason',
  DeleteTransportReason = 'DeleteTransportReason',
  UpdateTransportReason = 'UpdateTransportReason',
  AddManifestEntry = 'AddManifestEntry',
  DeleteManifestEntry = 'DeleteManifestEntry',
  UpdateManifestEntry = 'UpdateManifestEntry',
  UpdateOdometerReadings = 'UpdateOdometerReadings',
  UpdateTripLegOnFinal = 'UpdateTripLegOnFinal',
  AddTripPassenger = 'AddTripPassenger',
  DeleteTripPassenger = 'DeleteTripPassenger',
  UpdateTripPassenger = 'UpdateTripPassenger',
  AddTrip = 'AddTrip',
  AddTripLegManifestEntry = 'AddTripLegManifestEntry',
  CalculateEtas = 'CalculateEtas',
  ConfirmManifest = 'ConfirmManifest',
  CreatePrecautionaryLanding = 'CreatePrecautionaryLanding',
  CreatePrecautionaryLandingV2 = 'CreatePrecautionaryLandingV2',
  DeleteTrip = 'DeleteTrip',
  DeleteTripLegManifestEntry = 'DeleteTripLegManifestEntry',
  InsertWaypoint = 'InsertWaypoint',
  MergePostAndDropoffWaypoints = 'MergePostAndDropoffWaypoints',
  MergeUnitOriginAndPickupWaypoints = 'MergeUnitOriginAndPickupWaypoints',
  ModifyWaypoint = 'ModifyWaypoint',
  RecalculateTripMileage = 'RecalculateTripMileage',
  RemoveWaypoint = 'RemoveWaypoint',
  SplitUnitOriginAndPickupWaypoints = 'SplitUnitOriginAndPickupWaypoints',
  SplitUnitPostAndDropoffWaypoints = 'SplitUnitPostAndDropoffWaypoints',
  SwapWaypoint = 'SwapWaypoint',
  UpdateTrip = 'UpdateTrip',
  AddUnitActivationRule = 'AddUnitActivationRule',
  DeleteUnitActivationRule = 'DeleteUnitActivationRule',
  UpdateUnitActivationRule = 'UpdateUnitActivationRule',
  AddUnitEMSystemMapping = 'AddUnitEMSystemMapping',
  DeleteUnitEMSystemMapping = 'DeleteUnitEMSystemMapping',
  UpdateUnitEMSystemMapping = 'UpdateUnitEMSystemMapping',
  AddUnitNote = 'AddUnitNote',
  DeleteUnitNote = 'DeleteUnitNote',
  UpdateUnitNote = 'UpdateUnitNote',
  AddUnitPosition = 'AddUnitPosition',
  DeleteUnitPosition = 'DeleteUnitPosition',
  RemoveTeamMemberFromUnitPosition = 'RemoveTeamMemberFromUnitPosition',
  UpdateUnitPosition = 'UpdateUnitPosition',
  UpsertUnitPosition = 'UpsertUnitPosition',
  AddUnit = 'AddUnit',
  AssignVehicle = 'AssignVehicle',
  DelayUnit = 'DelayUnit',
  DeleteUnit = 'DeleteUnit',
  DisableUnit = 'DisableUnit',
  EnableUnit = 'EnableUnit',
  EnsureThirdPartyUnit = 'EnsureThirdPartyUnit',
  EnsureThirdPartyUnits = 'EnsureThirdPartyUnits',
  HideUnit = 'HideUnit',
  MarkAsPilotUpdated = 'MarkAsPilotUpdated',
  ReassignVehicle = 'ReassignVehicle',
  RemoveDelayFromUnit = 'RemoveDelayFromUnit',
  RemoveVehicleFromUnit = 'RemoveVehicleFromUnit',
  ReturnUnitToService = 'ReturnUnitToService',
  SourceCrewFromOutOfServiceUnit = 'SourceCrewFromOutOfServiceUnit',
  SwapUnitVehicles = 'SwapUnitVehicles',
  TakeUnitOutOfService = 'TakeUnitOutOfService',
  TeleportUnit = 'TeleportUnit',
  UnhideUnit = 'UnhideUnit',
  UpdatePilotUnitConfiguration = 'UpdatePilotUnitConfiguration',
  UpdateUnit = 'UpdateUnit',
  UpdateUnitConfiguration = 'UpdateUnitConfiguration',
  AddUnitShift = 'AddUnitShift',
  DeleteUnitShift = 'DeleteUnitShift',
  UpdateUnitShift = 'UpdateUnitShift',
  AddVehicleDisposition = 'AddVehicleDisposition',
  DeleteVehicleDisposition = 'DeleteVehicleDisposition',
  UpdateVehicleDisposition = 'UpdateVehicleDisposition',
  AddVehicleNotificationGroup = 'AddVehicleNotificationGroup',
  DeleteVehicleNotificationGroup = 'DeleteVehicleNotificationGroup',
  AddFuelBurn = 'AddFuelBurn',
  AddWaypoint = 'AddWaypoint',
  DeleteWaypoint = 'DeleteWaypoint',
  UpdateWaypoint = 'UpdateWaypoint',
  AcknowledgeWebOrderLog = 'AcknowledgeWebOrderLog',
  AddWebOrderLog = 'AddWebOrderLog',
}

export enum OpsFeature {
  ActivationRules = 'ActivationRules',
  ActiveAlerts = 'ActiveAlerts',
  ActiveTimelines = 'ActiveTimelines',
  Alerts = 'Alerts',
  ApplicationNotifications = 'ApplicationNotifications',
  AssignmentDelayedReasons = 'AssignmentDelayedReasons',
  CancellationCategories = 'CancellationCategories',
  CancellationReasons = 'CancellationReasons',
  CancellationSecondaryReasons = 'CancellationSecondaryReasons',
  CardLinks = 'CardLinks',
  CardNoteArchives = 'CardNoteArchives',
  CardNotes = 'CardNotes',
  CardReOpenReasons = 'CardReOpenReasons',
  Cards = 'Cards',
  ConfigurationSettings = 'ConfigurationSettings',
  Conversations = 'Conversations',
  DeclineCategories = 'DeclineCategories',
  DeclineReasons = 'DeclineReasons',
  DeclineSecondaryReasons = 'DeclineSecondaryReasons',
  DiversionReasons = 'DiversionReasons',
  EscortRequests = 'EscortRequests',
  EstimatedDurations = 'EstimatedDurations',
  ExternalActions = 'ExternalActions',
  ExternalActionTypes = 'ExternalActionTypes',
  FacilityNonAcceptanceReasons = 'FacilityNonAcceptanceReasons',
  FirewallRules = 'FirewallRules',
  FlightFollowingReports = 'FlightFollowingReports',
  LocationHazardAttachments = 'LocationHazardAttachments',
  LocationHazards = 'LocationHazards',
  MedicalControlContactLogEntries = 'MedicalControlContactLogEntries',
  MessageStatusUpdates = 'MessageStatusUpdates',
  NewAgencyLocationRequests = 'NewAgencyLocationRequests',
  NextDueTypes = 'NextDueTypes',
  NonReferralReasons = 'NonReferralReasons',
  NotificationGroupMembers = 'NotificationGroupMembers',
  NotificationGroups = 'NotificationGroups',
  NotificationRecipients = 'NotificationRecipients',
  Notifications = 'Notifications',
  NotificationSubscriptions = 'NotificationSubscriptions',
  NotificationTemplates = 'NotificationTemplates',
  OemActivities = 'OemActivities',
  OemAssets = 'OemAssets',
  OemPlanChangeRequests = 'OemPlanChangeRequests',
  OemPlans = 'OemPlans',
  OfferAlgorithms = 'OfferAlgorithms',
  Operations = 'Operations',
  OutOfServiceEventNotes = 'OutOfServiceEventNotes',
  OutOfServiceEvents = 'OutOfServiceEvents',
  OutOfServiceReasons = 'OutOfServiceReasons',
  OutOfServiceSecondaryReasons = 'OutOfServiceSecondaryReasons',
  OutOfServiceTickets = 'OutOfServiceTickets',
  PaipEvents = 'PaipEvents',
  PaipReasons = 'PaipReasons',
  PassdownLogArchivedLogs = 'PassdownLogArchivedLogs',
  PassdownLogs = 'PassdownLogs',
  PositionReportAlerts = 'PositionReportAlerts',
  PositionReports = 'PositionReports',
  QuestionChoices = 'QuestionChoices',
  QuestionnaireQuestionResponseNotes = 'QuestionnaireQuestionResponseNotes',
  QuestionnaireQuestionResponses = 'QuestionnaireQuestionResponses',
  QuestionnaireResponses = 'QuestionnaireResponses',
  Questionnaires = 'Questionnaires',
  QuestionnaireSectionQuestions = 'QuestionnaireSectionQuestions',
  QuestionnaireSections = 'QuestionnaireSections',
  Questions = 'Questions',
  ReceivingFacilityRequests = 'ReceivingFacilityRequests',
  RendezvousRequests = 'RendezvousRequests',
  RequesterRoles = 'RequesterRoles',
  Requesters = 'Requesters',
  RequestLocations = 'RequestLocations',
  RequestPatients = 'RequestPatients',
  Requests = 'Requests',
  TimelineItems = 'TimelineItems',
  Timelines = 'Timelines',
  Timestamps = 'Timestamps',
  TimestampTypes = 'TimestampTypes',
  TrackedMessages = 'TrackedMessages',
  TransferReasons = 'TransferReasons',
  TransportOfferOptions = 'TransportOfferOptions',
  TransportOffers = 'TransportOffers',
  TransportReasons = 'TransportReasons',
  TripLegManifestEntries = 'TripLegManifestEntries',
  TripLegs = 'TripLegs',
  TripPassengers = 'TripPassengers',
  Trips = 'Trips',
  UnitActivationRules = 'UnitActivationRules',
  UnitEMSystemMappings = 'UnitEMSystemMappings',
  UnitNotes = 'UnitNotes',
  UnitPositions = 'UnitPositions',
  Units = 'Units',
  UnitShifts = 'UnitShifts',
  VehicleDispositions = 'VehicleDispositions',
  VehicleNotificationGroups = 'VehicleNotificationGroups',
  Waypoints = 'Waypoints',
  WebOrderLogs = 'WebOrderLogs',
}

export type ActivationRulesFeatureCommand =
  | OpsCommand.AddActivationRule
  | OpsCommand.DeleteActivationRule
  | OpsCommand.UpdateActivationRule;
export type ActiveAlertsFeatureCommand =
  | OpsCommand.AcknowledgeAlert
  | OpsCommand.AddActiveAlert
  | OpsCommand.CleanupActiveAlerts
  | OpsCommand.CleanupCardActiveAlerts
  | OpsCommand.DeleteActiveAlert
  | OpsCommand.SnoozeAlert
  | OpsCommand.UpdateActiveAlert;
export type ActiveTimelinesFeatureCommand =
  | OpsCommand.DeleteActiveTimeline
  | OpsCommand.UpdateActiveTimeline;
export type AlertsFeatureCommand =
  | OpsCommand.AddAlert
  | OpsCommand.CopyAlert
  | OpsCommand.DeleteAlert
  | OpsCommand.UpdateAlert;
export type ApplicationNotificationsFeatureCommand =
  | OpsCommand.AddApplicationNotification
  | OpsCommand.DeleteApplicationNotification
  | OpsCommand.DismissApplicationNotification
  | OpsCommand.UpdateApplicationNotification;
export type AssignmentDelayedReasonsFeatureCommand =
  | OpsCommand.AddAssignmentDelayedReason
  | OpsCommand.DeleteAssignmentDelayedReason
  | OpsCommand.UpdateAssignmentDelayedReason;
export type CancellationCategoriesFeatureCommand =
  | OpsCommand.AddCancellationCategory
  | OpsCommand.DeleteCancellationCategory
  | OpsCommand.UpdateCancellationCategory;
export type CancellationReasonsFeatureCommand =
  | OpsCommand.AddCancellationReason
  | OpsCommand.DeleteCancellationReason
  | OpsCommand.UpdateCancellationReason;
export type CancellationSecondaryReasonsFeatureCommand =
  | OpsCommand.AddCancellationSecondaryReason
  | OpsCommand.DeleteCancellationSecondaryReason
  | OpsCommand.UpdateCancellationSecondaryReason;
export type CardLinksFeatureCommand =
  | OpsCommand.AddCardLink
  | OpsCommand.DeleteCardLink
  | OpsCommand.UpdateCardLink;
export type CardNoteArchivesFeatureCommand =
  | OpsCommand.AddCardNoteArchive
  | OpsCommand.DeleteCardNoteArchive
  | OpsCommand.UpdateCardNoteArchive;
export type CardNotesFeatureCommand =
  | OpsCommand.AddCardNote
  | OpsCommand.DeleteCardNote
  | OpsCommand.SendNoteToCard
  | OpsCommand.UpdateCardNote;
export type CardReOpenReasonsFeatureCommand =
  | OpsCommand.AddCardReOpenReason
  | OpsCommand.DeleteCardReOpenReason
  | OpsCommand.UpdateCardReOpenReason;
export type CardsFeatureCommand =
  | OpsCommand.AddCard
  | OpsCommand.ChangeCardCallStatus
  | OpsCommand.ChangeUnit
  | OpsCommand.CheckForFlightFollowingDestinationConflict
  | OpsCommand.CleanupCards
  | OpsCommand.CloseCard
  | OpsCommand.CreateSystemCrewNotification
  | OpsCommand.DeleteCard
  | OpsCommand.Divert
  | OpsCommand.GenerateCardReport
  | OpsCommand.GenerateCardSummaryChange
  | OpsCommand.GenerateCardSummaryChangeV2
  | OpsCommand.LinkCards
  | OpsCommand.ReOpenCard
  | OpsCommand.RequestAdditionalUnits
  | OpsCommand.ScanForFlights
  | OpsCommand.SendPatientInfo
  | OpsCommand.SetCardLockStatus
  | OpsCommand.UnDeleteCard
  | OpsCommand.UpdateCard
  | OpsCommand.UpdateCardBillable
  | OpsCommand.UpdateCardContactCompleted
  | OpsCommand.UpdateCardDiversionType
  | OpsCommand.UpdateCardSearchIndex
  | OpsCommand.UpdateGmrCadNumber
  | OpsCommand.UpdatePlannedCardCompletionTime;
export type ConfigurationSettingsFeatureCommand =
  | OpsCommand.AddConfigurationSetting
  | OpsCommand.UpdateConfigurationSetting;
export type ConversationsFeatureCommand =
  | OpsCommand.AddConversationToCardWithParticipant
  | OpsCommand.CloseConversation;
export type DeclineCategoriesFeatureCommand =
  | OpsCommand.AddDeclineCategory
  | OpsCommand.DeleteDeclineCategory
  | OpsCommand.UpdateDeclineCategory;
export type DeclineReasonsFeatureCommand =
  | OpsCommand.AddDeclineReason
  | OpsCommand.DeleteDeclineReason
  | OpsCommand.UpdateDeclineReason;
export type DeclineSecondaryReasonsFeatureCommand =
  | OpsCommand.AddDeclineSecondaryReason
  | OpsCommand.DeleteDeclineSecondaryReason
  | OpsCommand.UpdateDeclineSecondaryReason;
export type DiversionReasonsFeatureCommand =
  | OpsCommand.AddDiversionReason
  | OpsCommand.DeleteDiversionReason
  | OpsCommand.UpdateDiversionReason;
export type EscortRequestsFeatureCommand =
  | OpsCommand.AddEscortRequest
  | OpsCommand.DeleteEscortRequest
  | OpsCommand.UpdateEscortRequest;
export type EstimatedDurationsFeatureCommand =
  | OpsCommand.MakeEstimatedDurationOfficial
  | OpsCommand.UpdateEstimatedDurations
  | OpsCommand.UpdateTripLegDuration
  | OpsCommand.UpdateWaypointDuration;
export type ExternalActionsFeatureCommand =
  | OpsCommand.AddExternalAction
  | OpsCommand.CleanupPendingExternalActions
  | OpsCommand.DeleteExternalAction
  | OpsCommand.DisregardExternalAction
  | OpsCommand.UpdateExternalAction;
export type ExternalActionTypesFeatureCommand =
  | OpsCommand.AddExternalActionType
  | OpsCommand.DeleteExternalActionType
  | OpsCommand.UpdateExternalActionType;
export type FacilityNonAcceptanceReasonsFeatureCommand =
  | OpsCommand.AddFacilityNonAcceptanceReason
  | OpsCommand.DeleteFacilityNonAcceptanceReason
  | OpsCommand.UpdateFacilityNonAcceptanceReason;
export type FirewallRulesFeatureCommand =
  | OpsCommand.AddFirewallRule
  | OpsCommand.DeleteFirewallRule
  | OpsCommand.UpdateFirewallRule;
export type FlightFollowingReportsFeatureCommand =
  | OpsCommand.AddFlightFollowingReport
  | OpsCommand.DeleteFlightFollowingReport
  | OpsCommand.UpdateFlightFollowingReport;
export type LocationHazardAttachmentsFeatureCommand =
  | OpsCommand.DeleteLocationHazardAttachment
  | OpsCommand.GenerateLocationHazardAttachmentUrl;
export type LocationHazardsFeatureCommand =
  | OpsCommand.AddLocationHazard
  | OpsCommand.DeleteLocationHazard
  | OpsCommand.UpdateLocationHazard;
export type MedicalControlContactLogEntriesFeatureCommand =
  | OpsCommand.AddMedicalControlContactLogEntry
  | OpsCommand.DeleteMedicalControlContactLogEntry
  | OpsCommand.UpdateMedicalControlContactLogEntry;
export type MessageStatusUpdatesFeatureCommand = OpsCommand.AddMessageStatusUpdate;
export type NewAgencyLocationRequestsFeatureCommand =
  | OpsCommand.AddNewAgencyLocationRequest
  | OpsCommand.DeleteNewAgencyLocationRequest
  | OpsCommand.UpdateNewAgencyLocationRequest;
export type NextDueTypesFeatureCommand =
  | OpsCommand.AddNextDueType
  | OpsCommand.DeleteNextDueType
  | OpsCommand.UpdateNextDueType;
export type NonReferralReasonsFeatureCommand =
  | OpsCommand.AddNonReferralReason
  | OpsCommand.DeleteNonReferralReason
  | OpsCommand.UpdateNonReferralReason;
export type NotificationGroupMembersFeatureCommand =
  | OpsCommand.AddNotificationGroupMember
  | OpsCommand.DeleteNotificationGroupMember
  | OpsCommand.UpdateNotificationGroupMember;
export type NotificationGroupsFeatureCommand =
  | OpsCommand.AddNotificationGroup
  | OpsCommand.DeleteNotificationGroup
  | OpsCommand.UpdateNotificationGroup
  | OpsCommand.UpsertPersonNotificationGroups;
export type NotificationRecipientsFeatureCommand =
  | OpsCommand.AddNotificationRecipient
  | OpsCommand.AddNotificationRecipients
  | OpsCommand.DeleteNotificationRecipient
  | OpsCommand.DeleteNotificationRecipients
  | OpsCommand.UpdateNotificationRecipient
  | OpsCommand.UpdateRecipientMessageStatus;
export type NotificationsFeatureCommand =
  | OpsCommand.AddNotification
  | OpsCommand.DeleteNotification
  | OpsCommand.SendNotification
  | OpsCommand.UpdateNotification;
export type NotificationSubscriptionsFeatureCommand =
  | OpsCommand.AddNotificationSubscription
  | OpsCommand.DeleteNotificationSubscription
  | OpsCommand.UpdateNotificationSubscription;
export type NotificationTemplatesFeatureCommand =
  | OpsCommand.AddNotificationTemplate
  | OpsCommand.CopyNotificationTemplate
  | OpsCommand.DeleteNotificationTemplate
  | OpsCommand.UpdateNotificationTemplate;
export type OemActivitiesFeatureCommand =
  | OpsCommand.AddOemActivity
  | OpsCommand.DeleteOemActivity
  | OpsCommand.UpdateOemActivity;
export type OemAssetsFeatureCommand =
  | OpsCommand.AddOemAsset
  | OpsCommand.DeleteOemAsset
  | OpsCommand.UpdateOemAsset;
export type OemPlanChangeRequestsFeatureCommand =
  | OpsCommand.AddOemPlanChangeRequest
  | OpsCommand.DeleteOemPlanChangeRequest
  | OpsCommand.UpdateOemPlanChangeRequest;
export type OemPlansFeatureCommand =
  | OpsCommand.AddOemPlan
  | OpsCommand.DeleteOemPlan
  | OpsCommand.UpdateOemPlan;
export type OfferAlgorithmsFeatureCommand =
  | OpsCommand.AddOfferAlgorithm
  | OpsCommand.CopyOfferAlgorithm
  | OpsCommand.DeleteOfferAlgorithm
  | OpsCommand.UpdateOfferAlgorithm;
export type OperationsFeatureCommand =
  | OpsCommand.ActivateUnit
  | OpsCommand.AddOperation
  | OpsCommand.ArriveVehicle
  | OpsCommand.CancelOperation
  | OpsCommand.ChangeVehicle
  | OpsCommand.CreateGroundRun
  | OpsCommand.CreateMaintenanceOperation
  | OpsCommand.CreateTrainingOperation
  | OpsCommand.DeclineOrAbortOperation
  | OpsCommand.DeleteOperation
  | OpsCommand.DepartVehicle
  | OpsCommand.PlaceUnitOnStandby
  | OpsCommand.RepositionUnit
  | OpsCommand.UndoAbortOperation
  | OpsCommand.UndoArriveVehicle
  | OpsCommand.UndoDepartVehicle
  | OpsCommand.UpdateOperation
  | OpsCommand.UpdateOperationContactInfo
  | OpsCommand.UpdateRiskAnalysis;
export type OutOfServiceEventNotesFeatureCommand =
  | OpsCommand.AddOutOfServiceEventNote
  | OpsCommand.DeleteOutOfServiceEventNote
  | OpsCommand.UpdateOutOfServiceEventNote;
export type OutOfServiceEventsFeatureCommand =
  | OpsCommand.AcknowledgeOutOfServiceEvent
  | OpsCommand.AddCrewOutOfServiceEvent
  | OpsCommand.AddOutOfServiceEvent
  | OpsCommand.AddUnitOutOfServiceEvent
  | OpsCommand.AddVehicleOutOfServiceEvent
  | OpsCommand.BeginOutOfServiceEvent
  | OpsCommand.CreateTicketFromOutOfServiceEvent
  | OpsCommand.DeleteOutOfServiceEvent
  | OpsCommand.EndCrewMemberOutOfServiceEvent
  | OpsCommand.EndOutOfServiceEvent
  | OpsCommand.LinkOutOfServiceEvent
  | OpsCommand.UpdateOutOfServiceEvent;
export type OutOfServiceReasonsFeatureCommand =
  | OpsCommand.AddOutOfServiceReason
  | OpsCommand.DeleteOutOfServiceReason
  | OpsCommand.UpdateOutOfServiceReason;
export type OutOfServiceSecondaryReasonsFeatureCommand =
  | OpsCommand.AddOutOfServiceSecondaryReason
  | OpsCommand.DeleteOutOfServiceSecondaryReason
  | OpsCommand.UpdateOutOfServiceSecondaryReason;
export type OutOfServiceTicketsFeatureCommand =
  | OpsCommand.AcceptOutOfServiceTicket
  | OpsCommand.AcknowledgeOutOfServiceTicket
  | OpsCommand.CloseTicketsForOOSEvent
  | OpsCommand.DeleteOutOfServiceTicket
  | OpsCommand.ReviewSubmittedOutOfServiceTicket
  | OpsCommand.SubmitOutOfServiceTicket;
export type PaipEventsFeatureCommand =
  | OpsCommand.AddPaipEvent
  | OpsCommand.DeletePaipEvent
  | OpsCommand.EndPaipEvent
  | OpsCommand.UpdatePaipEvent;
export type PaipReasonsFeatureCommand =
  | OpsCommand.AddPaipReason
  | OpsCommand.DeletePaipReason
  | OpsCommand.UpdatePaipReason;
export type PassdownLogArchivedLogsFeatureCommand = OpsCommand.ArchivePassdownLog;
export type PassdownLogsFeatureCommand =
  | OpsCommand.AcknowledgePassdownLog
  | OpsCommand.AddPassdownLog
  | OpsCommand.DeletePassdownLog
  | OpsCommand.UpdatePassdownLog;
export type PositionReportAlertsFeatureCommand =
  | OpsCommand.AddPositionReportAlert
  | OpsCommand.DeletePositionReportAlert
  | OpsCommand.UpdatePositionReportAlert;
export type PositionReportsFeatureCommand =
  | OpsCommand.AddPositionReport
  | OpsCommand.ConfirmPositionReport
  | OpsCommand.DeletePositionReport
  | OpsCommand.UpdatePositionReport;
export type QuestionChoicesFeatureCommand = OpsCommand.UpsertQuestionChoice;
export type QuestionnaireQuestionResponseNotesFeatureCommand =
  | OpsCommand.AddQuestionnaireQuestionResponseNote
  | OpsCommand.DeleteQuestionnaireQuestionResponseNote
  | OpsCommand.UpdateQuestionnaireQuestionResponseNote
  | OpsCommand.UpsertQuestionnaireQuestionResponseNote;
export type QuestionnaireQuestionResponsesFeatureCommand =
  | OpsCommand.AddQuestionnaireQuestionResponse
  | OpsCommand.DeleteQuestionnaireQuestionResponse
  | OpsCommand.UpdateQuestionnaireQuestionResponse
  | OpsCommand.UpdateQuestionnaireQuestionResponseDeep;
export type QuestionnaireResponsesFeatureCommand =
  | OpsCommand.AddQuestionnaireResponse
  | OpsCommand.DeleteQuestionnaireResponse
  | OpsCommand.SubmitQuestionnaireResponse
  | OpsCommand.UpdateQuestionnaireResponse
  | OpsCommand.UpdateQuestionnaireResponseDeep;
export type QuestionnairesFeatureCommand =
  | OpsCommand.AddQuestionnaire
  | OpsCommand.DeleteQuestionnaire
  | OpsCommand.UpdateQuestionnaire;
export type QuestionnaireSectionQuestionsFeatureCommand =
  | OpsCommand.DeleteQuestionnaireSectionQuestion
  | OpsCommand.UpsertQuestionnaireSectionQuestion;
export type QuestionnaireSectionsFeatureCommand =
  | OpsCommand.DeleteQuestionnaireSection
  | OpsCommand.UpsertQuestionnaireSection;
export type QuestionsFeatureCommand =
  | OpsCommand.AddQuestion
  | OpsCommand.DeleteQuestion
  | OpsCommand.UpdateQuestion;
export type ReceivingFacilityRequestsFeatureCommand =
  | OpsCommand.AcceptReceivingFacilityRequest
  | OpsCommand.AddReceivingFacilityRequestDeclineHistory
  | OpsCommand.CancelReceivingFacilityRequest
  | OpsCommand.DeleteReceivingFacilityRequest
  | OpsCommand.DenyReceivingFacilityRequest
  | OpsCommand.DivertReceivingFacilityRequest
  | OpsCommand.ReferReceivingFacilityRequest;
export type RendezvousRequestsFeatureCommand =
  | OpsCommand.AddRendezvousRequest
  | OpsCommand.DeleteRendezvousRequest
  | OpsCommand.UpdateRendezvousRequest;
export type RequesterRolesFeatureCommand =
  | OpsCommand.AddRequesterRole
  | OpsCommand.DeleteRequesterRole
  | OpsCommand.UpdateRequesterRole;
export type RequestersFeatureCommand =
  | OpsCommand.UpdateRequester
  | OpsCommand.UpdateRequesterSpecialtyTeam
  | OpsCommand.UpdateRequestorAgencyLocation
  | OpsCommand.UpdateTransferCenterCallInfo;
export type RequestLocationsFeatureCommand =
  | OpsCommand.UpdateReceivingFacilityAutoAcceptance
  | OpsCommand.UpdateRequestLocation;
export type RequestPatientsFeatureCommand =
  | OpsCommand.AddRequestPatient
  | OpsCommand.DeleteRequestPatient
  | OpsCommand.UpdateChiefComplaint
  | OpsCommand.UpdatePatientClinicalInfo
  | OpsCommand.UpdatePatientInfo
  | OpsCommand.UpdateRequestPatient;
export type RequestsFeatureCommand =
  | OpsCommand.AcknowledgeExternalRequest
  | OpsCommand.BeginAssignment
  | OpsCommand.CancelRequest
  | OpsCommand.CancelRequestFromTransferCenter
  | OpsCommand.ChangeCallType
  | OpsCommand.ChangeRequestCancellationReason
  | OpsCommand.ChangeRequestType
  | OpsCommand.CreateRequest
  | OpsCommand.DelayAssignment
  | OpsCommand.DuplicateRequest
  | OpsCommand.ReactivateRequest
  | OpsCommand.ReactivateRequestFromTransferCenter
  | OpsCommand.RecalculateCandidates
  | OpsCommand.RequestPublicRelationFromUnit
  | OpsCommand.UpdateRequest
  | OpsCommand.UpdateRequestAtlo
  | OpsCommand.UpdateRequestPublicUtilityInfo
  | OpsCommand.UpdateRequestRegion
  | OpsCommand.UpdateRequestSafetyQuestions
  | OpsCommand.UpdateRequestStandbyStatus;
export type TimelineItemsFeatureCommand =
  | OpsCommand.AddTimelineItem
  | OpsCommand.DeleteTimelineItem
  | OpsCommand.UpdateTimelineItem
  | OpsCommand.UpsertTimelineItem;
export type TimelinesFeatureCommand =
  | OpsCommand.AddTimeline
  | OpsCommand.DeleteTimeline
  | OpsCommand.UpdateTimeline;
export type TimestampsFeatureCommand =
  | OpsCommand.AddEmsReport
  | OpsCommand.AddTimestamp
  | OpsCommand.DeleteTimestamp
  | OpsCommand.ReSendToDataWarehouse
  | OpsCommand.SendToImageTrend
  | OpsCommand.UpdateEmsReport
  | OpsCommand.UpdateTimestamp;
export type TimestampTypesFeatureCommand =
  | OpsCommand.AddTimestampType
  | OpsCommand.DeleteTimestampType
  | OpsCommand.UpdateTimestampType;
export type TrackedMessagesFeatureCommand =
  | OpsCommand.DeliverTrackedMessage
  | OpsCommand.SendMessage
  | OpsCommand.SendSupportRequestEmail
  | OpsCommand.UpdateTrackedMessage;
export type TransferReasonsFeatureCommand =
  | OpsCommand.AddTransferReason
  | OpsCommand.DeleteTransferReason
  | OpsCommand.UpdateTransferReason;
export type TransportOfferOptionsFeatureCommand = OpsCommand.UpdateTransportOfferOption;
export type TransportOffersFeatureCommand =
  | OpsCommand.AcceptTransportOffer
  | OpsCommand.AddCancellation
  | OpsCommand.AddDecline
  | OpsCommand.AddTransportOffer
  | OpsCommand.BeginTransportOffer
  | OpsCommand.CancelTransportOffer
  | OpsCommand.DeclineAndAssignNewTransportOffer
  | OpsCommand.DeclineTransportOffer
  | OpsCommand.DeclineTransportOfferAndDelayAssignment
  | OpsCommand.DeleteTransportOffer
  | OpsCommand.InitiateTransportCheck
  | OpsCommand.OfferWithBulkSkip
  | OpsCommand.ReferTransportOffer
  | OpsCommand.SkipTransportOffer
  | OpsCommand.UpdateCancellation
  | OpsCommand.UpdateDecline
  | OpsCommand.UpdateOfferRank
  | OpsCommand.UpdateSkip
  | OpsCommand.UpdateTransportOffer
  | OpsCommand.UpdateTransportOfferEta;
export type TransportReasonsFeatureCommand =
  | OpsCommand.AddTransportReason
  | OpsCommand.DeleteTransportReason
  | OpsCommand.UpdateTransportReason;
export type TripLegManifestEntriesFeatureCommand =
  | OpsCommand.AddManifestEntry
  | OpsCommand.DeleteManifestEntry
  | OpsCommand.UpdateManifestEntry;
export type TripLegsFeatureCommand =
  | OpsCommand.UpdateOdometerReadings
  | OpsCommand.UpdateTripLegOnFinal;
export type TripPassengersFeatureCommand =
  | OpsCommand.AddTripPassenger
  | OpsCommand.DeleteTripPassenger
  | OpsCommand.UpdateTripPassenger;
export type TripsFeatureCommand =
  | OpsCommand.AddTrip
  | OpsCommand.AddTripLegManifestEntry
  | OpsCommand.CalculateEtas
  | OpsCommand.ConfirmManifest
  | OpsCommand.CreatePrecautionaryLanding
  | OpsCommand.CreatePrecautionaryLandingV2
  | OpsCommand.DeleteTrip
  | OpsCommand.DeleteTripLegManifestEntry
  | OpsCommand.InsertWaypoint
  | OpsCommand.MergePostAndDropoffWaypoints
  | OpsCommand.MergeUnitOriginAndPickupWaypoints
  | OpsCommand.ModifyWaypoint
  | OpsCommand.RecalculateTripMileage
  | OpsCommand.RemoveWaypoint
  | OpsCommand.SplitUnitOriginAndPickupWaypoints
  | OpsCommand.SplitUnitPostAndDropoffWaypoints
  | OpsCommand.SwapWaypoint
  | OpsCommand.UpdateTrip;
export type UnitActivationRulesFeatureCommand =
  | OpsCommand.AddUnitActivationRule
  | OpsCommand.DeleteUnitActivationRule
  | OpsCommand.UpdateUnitActivationRule;
export type UnitEMSystemMappingsFeatureCommand =
  | OpsCommand.AddUnitEMSystemMapping
  | OpsCommand.DeleteUnitEMSystemMapping
  | OpsCommand.UpdateUnitEMSystemMapping;
export type UnitNotesFeatureCommand =
  | OpsCommand.AddUnitNote
  | OpsCommand.DeleteUnitNote
  | OpsCommand.UpdateUnitNote;
export type UnitPositionsFeatureCommand =
  | OpsCommand.AddUnitPosition
  | OpsCommand.DeleteUnitPosition
  | OpsCommand.RemoveTeamMemberFromUnitPosition
  | OpsCommand.UpdateUnitPosition
  | OpsCommand.UpsertUnitPosition;
export type UnitsFeatureCommand =
  | OpsCommand.AddUnit
  | OpsCommand.AssignVehicle
  | OpsCommand.DelayUnit
  | OpsCommand.DeleteUnit
  | OpsCommand.DisableUnit
  | OpsCommand.EnableUnit
  | OpsCommand.EnsureThirdPartyUnit
  | OpsCommand.EnsureThirdPartyUnits
  | OpsCommand.HideUnit
  | OpsCommand.MarkAsPilotUpdated
  | OpsCommand.ReassignVehicle
  | OpsCommand.RemoveDelayFromUnit
  | OpsCommand.RemoveVehicleFromUnit
  | OpsCommand.ReturnUnitToService
  | OpsCommand.SourceCrewFromOutOfServiceUnit
  | OpsCommand.SwapUnitVehicles
  | OpsCommand.TakeUnitOutOfService
  | OpsCommand.TeleportUnit
  | OpsCommand.UnhideUnit
  | OpsCommand.UpdatePilotUnitConfiguration
  | OpsCommand.UpdateUnit
  | OpsCommand.UpdateUnitConfiguration;
export type UnitShiftsFeatureCommand =
  | OpsCommand.AddUnitShift
  | OpsCommand.DeleteUnitShift
  | OpsCommand.UpdateUnitShift;
export type VehicleDispositionsFeatureCommand =
  | OpsCommand.AddVehicleDisposition
  | OpsCommand.DeleteVehicleDisposition
  | OpsCommand.UpdateVehicleDisposition;
export type VehicleNotificationGroupsFeatureCommand =
  | OpsCommand.AddVehicleNotificationGroup
  | OpsCommand.DeleteVehicleNotificationGroup;
export type WaypointsFeatureCommand =
  | OpsCommand.AddFuelBurn
  | OpsCommand.AddWaypoint
  | OpsCommand.DeleteWaypoint
  | OpsCommand.UpdateWaypoint;
export type WebOrderLogsFeatureCommand =
  | OpsCommand.AcknowledgeWebOrderLog
  | OpsCommand.AddWebOrderLog;

export const OpsFeatures: { [key in OpsFeature]: OpsCommand[] } = {
  ActivationRules: [
    OpsCommand.AddActivationRule,
    OpsCommand.DeleteActivationRule,
    OpsCommand.UpdateActivationRule,
  ],
  ActiveAlerts: [
    OpsCommand.AcknowledgeAlert,
    OpsCommand.AddActiveAlert,
    OpsCommand.CleanupActiveAlerts,
    OpsCommand.CleanupCardActiveAlerts,
    OpsCommand.DeleteActiveAlert,
    OpsCommand.SnoozeAlert,
    OpsCommand.UpdateActiveAlert,
  ],
  ActiveTimelines: [OpsCommand.DeleteActiveTimeline, OpsCommand.UpdateActiveTimeline],
  Alerts: [
    OpsCommand.AddAlert,
    OpsCommand.CopyAlert,
    OpsCommand.DeleteAlert,
    OpsCommand.UpdateAlert,
  ],
  ApplicationNotifications: [
    OpsCommand.AddApplicationNotification,
    OpsCommand.DeleteApplicationNotification,
    OpsCommand.DismissApplicationNotification,
    OpsCommand.UpdateApplicationNotification,
  ],
  AssignmentDelayedReasons: [
    OpsCommand.AddAssignmentDelayedReason,
    OpsCommand.DeleteAssignmentDelayedReason,
    OpsCommand.UpdateAssignmentDelayedReason,
  ],
  CancellationCategories: [
    OpsCommand.AddCancellationCategory,
    OpsCommand.DeleteCancellationCategory,
    OpsCommand.UpdateCancellationCategory,
  ],
  CancellationReasons: [
    OpsCommand.AddCancellationReason,
    OpsCommand.DeleteCancellationReason,
    OpsCommand.UpdateCancellationReason,
  ],
  CancellationSecondaryReasons: [
    OpsCommand.AddCancellationSecondaryReason,
    OpsCommand.DeleteCancellationSecondaryReason,
    OpsCommand.UpdateCancellationSecondaryReason,
  ],
  CardLinks: [OpsCommand.AddCardLink, OpsCommand.DeleteCardLink, OpsCommand.UpdateCardLink],
  CardNoteArchives: [
    OpsCommand.AddCardNoteArchive,
    OpsCommand.DeleteCardNoteArchive,
    OpsCommand.UpdateCardNoteArchive,
  ],
  CardNotes: [
    OpsCommand.AddCardNote,
    OpsCommand.DeleteCardNote,
    OpsCommand.SendNoteToCard,
    OpsCommand.UpdateCardNote,
  ],
  CardReOpenReasons: [
    OpsCommand.AddCardReOpenReason,
    OpsCommand.DeleteCardReOpenReason,
    OpsCommand.UpdateCardReOpenReason,
  ],
  Cards: [
    OpsCommand.AddCard,
    OpsCommand.ChangeCardCallStatus,
    OpsCommand.ChangeUnit,
    OpsCommand.CheckForFlightFollowingDestinationConflict,
    OpsCommand.CleanupCards,
    OpsCommand.CloseCard,
    OpsCommand.CreateSystemCrewNotification,
    OpsCommand.DeleteCard,
    OpsCommand.Divert,
    OpsCommand.GenerateCardReport,
    OpsCommand.GenerateCardSummaryChange,
    OpsCommand.GenerateCardSummaryChangeV2,
    OpsCommand.LinkCards,
    OpsCommand.ReOpenCard,
    OpsCommand.RequestAdditionalUnits,
    OpsCommand.ScanForFlights,
    OpsCommand.SendPatientInfo,
    OpsCommand.SetCardLockStatus,
    OpsCommand.UnDeleteCard,
    OpsCommand.UpdateCard,
    OpsCommand.UpdateCardBillable,
    OpsCommand.UpdateCardContactCompleted,
    OpsCommand.UpdateCardDiversionType,
    OpsCommand.UpdateCardSearchIndex,
    OpsCommand.UpdateGmrCadNumber,
    OpsCommand.UpdatePlannedCardCompletionTime,
  ],
  ConfigurationSettings: [
    OpsCommand.AddConfigurationSetting,
    OpsCommand.UpdateConfigurationSetting,
  ],
  Conversations: [OpsCommand.AddConversationToCardWithParticipant, OpsCommand.CloseConversation],
  DeclineCategories: [
    OpsCommand.AddDeclineCategory,
    OpsCommand.DeleteDeclineCategory,
    OpsCommand.UpdateDeclineCategory,
  ],
  DeclineReasons: [
    OpsCommand.AddDeclineReason,
    OpsCommand.DeleteDeclineReason,
    OpsCommand.UpdateDeclineReason,
  ],
  DeclineSecondaryReasons: [
    OpsCommand.AddDeclineSecondaryReason,
    OpsCommand.DeleteDeclineSecondaryReason,
    OpsCommand.UpdateDeclineSecondaryReason,
  ],
  DiversionReasons: [
    OpsCommand.AddDiversionReason,
    OpsCommand.DeleteDiversionReason,
    OpsCommand.UpdateDiversionReason,
  ],
  EscortRequests: [
    OpsCommand.AddEscortRequest,
    OpsCommand.DeleteEscortRequest,
    OpsCommand.UpdateEscortRequest,
  ],
  EstimatedDurations: [
    OpsCommand.MakeEstimatedDurationOfficial,
    OpsCommand.UpdateEstimatedDurations,
    OpsCommand.UpdateTripLegDuration,
    OpsCommand.UpdateWaypointDuration,
  ],
  ExternalActions: [
    OpsCommand.AddExternalAction,
    OpsCommand.CleanupPendingExternalActions,
    OpsCommand.DeleteExternalAction,
    OpsCommand.DisregardExternalAction,
    OpsCommand.UpdateExternalAction,
  ],
  ExternalActionTypes: [
    OpsCommand.AddExternalActionType,
    OpsCommand.DeleteExternalActionType,
    OpsCommand.UpdateExternalActionType,
  ],
  FacilityNonAcceptanceReasons: [
    OpsCommand.AddFacilityNonAcceptanceReason,
    OpsCommand.DeleteFacilityNonAcceptanceReason,
    OpsCommand.UpdateFacilityNonAcceptanceReason,
  ],
  FirewallRules: [
    OpsCommand.AddFirewallRule,
    OpsCommand.DeleteFirewallRule,
    OpsCommand.UpdateFirewallRule,
  ],
  FlightFollowingReports: [
    OpsCommand.AddFlightFollowingReport,
    OpsCommand.DeleteFlightFollowingReport,
    OpsCommand.UpdateFlightFollowingReport,
  ],
  LocationHazardAttachments: [
    OpsCommand.DeleteLocationHazardAttachment,
    OpsCommand.GenerateLocationHazardAttachmentUrl,
  ],
  LocationHazards: [
    OpsCommand.AddLocationHazard,
    OpsCommand.DeleteLocationHazard,
    OpsCommand.UpdateLocationHazard,
  ],
  MedicalControlContactLogEntries: [
    OpsCommand.AddMedicalControlContactLogEntry,
    OpsCommand.DeleteMedicalControlContactLogEntry,
    OpsCommand.UpdateMedicalControlContactLogEntry,
  ],
  MessageStatusUpdates: [OpsCommand.AddMessageStatusUpdate],
  NewAgencyLocationRequests: [
    OpsCommand.AddNewAgencyLocationRequest,
    OpsCommand.DeleteNewAgencyLocationRequest,
    OpsCommand.UpdateNewAgencyLocationRequest,
  ],
  NextDueTypes: [
    OpsCommand.AddNextDueType,
    OpsCommand.DeleteNextDueType,
    OpsCommand.UpdateNextDueType,
  ],
  NonReferralReasons: [
    OpsCommand.AddNonReferralReason,
    OpsCommand.DeleteNonReferralReason,
    OpsCommand.UpdateNonReferralReason,
  ],
  NotificationGroupMembers: [
    OpsCommand.AddNotificationGroupMember,
    OpsCommand.DeleteNotificationGroupMember,
    OpsCommand.UpdateNotificationGroupMember,
  ],
  NotificationGroups: [
    OpsCommand.AddNotificationGroup,
    OpsCommand.DeleteNotificationGroup,
    OpsCommand.UpdateNotificationGroup,
    OpsCommand.UpsertPersonNotificationGroups,
  ],
  NotificationRecipients: [
    OpsCommand.AddNotificationRecipient,
    OpsCommand.AddNotificationRecipients,
    OpsCommand.DeleteNotificationRecipient,
    OpsCommand.DeleteNotificationRecipients,
    OpsCommand.UpdateNotificationRecipient,
    OpsCommand.UpdateRecipientMessageStatus,
  ],
  Notifications: [
    OpsCommand.AddNotification,
    OpsCommand.DeleteNotification,
    OpsCommand.SendNotification,
    OpsCommand.UpdateNotification,
  ],
  NotificationSubscriptions: [
    OpsCommand.AddNotificationSubscription,
    OpsCommand.DeleteNotificationSubscription,
    OpsCommand.UpdateNotificationSubscription,
  ],
  NotificationTemplates: [
    OpsCommand.AddNotificationTemplate,
    OpsCommand.CopyNotificationTemplate,
    OpsCommand.DeleteNotificationTemplate,
    OpsCommand.UpdateNotificationTemplate,
  ],
  OemActivities: [
    OpsCommand.AddOemActivity,
    OpsCommand.DeleteOemActivity,
    OpsCommand.UpdateOemActivity,
  ],
  OemAssets: [OpsCommand.AddOemAsset, OpsCommand.DeleteOemAsset, OpsCommand.UpdateOemAsset],
  OemPlanChangeRequests: [
    OpsCommand.AddOemPlanChangeRequest,
    OpsCommand.DeleteOemPlanChangeRequest,
    OpsCommand.UpdateOemPlanChangeRequest,
  ],
  OemPlans: [OpsCommand.AddOemPlan, OpsCommand.DeleteOemPlan, OpsCommand.UpdateOemPlan],
  OfferAlgorithms: [
    OpsCommand.AddOfferAlgorithm,
    OpsCommand.CopyOfferAlgorithm,
    OpsCommand.DeleteOfferAlgorithm,
    OpsCommand.UpdateOfferAlgorithm,
  ],
  Operations: [
    OpsCommand.ActivateUnit,
    OpsCommand.AddOperation,
    OpsCommand.ArriveVehicle,
    OpsCommand.CancelOperation,
    OpsCommand.ChangeVehicle,
    OpsCommand.CreateGroundRun,
    OpsCommand.CreateMaintenanceOperation,
    OpsCommand.CreateTrainingOperation,
    OpsCommand.DeclineOrAbortOperation,
    OpsCommand.DeleteOperation,
    OpsCommand.DepartVehicle,
    OpsCommand.PlaceUnitOnStandby,
    OpsCommand.RepositionUnit,
    OpsCommand.UndoAbortOperation,
    OpsCommand.UndoArriveVehicle,
    OpsCommand.UndoDepartVehicle,
    OpsCommand.UpdateOperation,
    OpsCommand.UpdateOperationContactInfo,
    OpsCommand.UpdateRiskAnalysis,
  ],
  OutOfServiceEventNotes: [
    OpsCommand.AddOutOfServiceEventNote,
    OpsCommand.DeleteOutOfServiceEventNote,
    OpsCommand.UpdateOutOfServiceEventNote,
  ],
  OutOfServiceEvents: [
    OpsCommand.AcknowledgeOutOfServiceEvent,
    OpsCommand.AddCrewOutOfServiceEvent,
    OpsCommand.AddOutOfServiceEvent,
    OpsCommand.AddUnitOutOfServiceEvent,
    OpsCommand.AddVehicleOutOfServiceEvent,
    OpsCommand.BeginOutOfServiceEvent,
    OpsCommand.CreateTicketFromOutOfServiceEvent,
    OpsCommand.DeleteOutOfServiceEvent,
    OpsCommand.EndCrewMemberOutOfServiceEvent,
    OpsCommand.EndOutOfServiceEvent,
    OpsCommand.LinkOutOfServiceEvent,
    OpsCommand.UpdateOutOfServiceEvent,
  ],
  OutOfServiceReasons: [
    OpsCommand.AddOutOfServiceReason,
    OpsCommand.DeleteOutOfServiceReason,
    OpsCommand.UpdateOutOfServiceReason,
  ],
  OutOfServiceSecondaryReasons: [
    OpsCommand.AddOutOfServiceSecondaryReason,
    OpsCommand.DeleteOutOfServiceSecondaryReason,
    OpsCommand.UpdateOutOfServiceSecondaryReason,
  ],
  OutOfServiceTickets: [
    OpsCommand.AcceptOutOfServiceTicket,
    OpsCommand.AcknowledgeOutOfServiceTicket,
    OpsCommand.CloseTicketsForOOSEvent,
    OpsCommand.DeleteOutOfServiceTicket,
    OpsCommand.ReviewSubmittedOutOfServiceTicket,
    OpsCommand.SubmitOutOfServiceTicket,
  ],
  PaipEvents: [
    OpsCommand.AddPaipEvent,
    OpsCommand.DeletePaipEvent,
    OpsCommand.EndPaipEvent,
    OpsCommand.UpdatePaipEvent,
  ],
  PaipReasons: [OpsCommand.AddPaipReason, OpsCommand.DeletePaipReason, OpsCommand.UpdatePaipReason],
  PassdownLogArchivedLogs: [OpsCommand.ArchivePassdownLog],
  PassdownLogs: [
    OpsCommand.AcknowledgePassdownLog,
    OpsCommand.AddPassdownLog,
    OpsCommand.DeletePassdownLog,
    OpsCommand.UpdatePassdownLog,
  ],
  PositionReportAlerts: [
    OpsCommand.AddPositionReportAlert,
    OpsCommand.DeletePositionReportAlert,
    OpsCommand.UpdatePositionReportAlert,
  ],
  PositionReports: [
    OpsCommand.AddPositionReport,
    OpsCommand.ConfirmPositionReport,
    OpsCommand.DeletePositionReport,
    OpsCommand.UpdatePositionReport,
  ],
  QuestionChoices: [OpsCommand.UpsertQuestionChoice],
  QuestionnaireQuestionResponseNotes: [
    OpsCommand.AddQuestionnaireQuestionResponseNote,
    OpsCommand.DeleteQuestionnaireQuestionResponseNote,
    OpsCommand.UpdateQuestionnaireQuestionResponseNote,
    OpsCommand.UpsertQuestionnaireQuestionResponseNote,
  ],
  QuestionnaireQuestionResponses: [
    OpsCommand.AddQuestionnaireQuestionResponse,
    OpsCommand.DeleteQuestionnaireQuestionResponse,
    OpsCommand.UpdateQuestionnaireQuestionResponse,
    OpsCommand.UpdateQuestionnaireQuestionResponseDeep,
  ],
  QuestionnaireResponses: [
    OpsCommand.AddQuestionnaireResponse,
    OpsCommand.DeleteQuestionnaireResponse,
    OpsCommand.SubmitQuestionnaireResponse,
    OpsCommand.UpdateQuestionnaireResponse,
    OpsCommand.UpdateQuestionnaireResponseDeep,
  ],
  Questionnaires: [
    OpsCommand.AddQuestionnaire,
    OpsCommand.DeleteQuestionnaire,
    OpsCommand.UpdateQuestionnaire,
  ],
  QuestionnaireSectionQuestions: [
    OpsCommand.DeleteQuestionnaireSectionQuestion,
    OpsCommand.UpsertQuestionnaireSectionQuestion,
  ],
  QuestionnaireSections: [
    OpsCommand.DeleteQuestionnaireSection,
    OpsCommand.UpsertQuestionnaireSection,
  ],
  Questions: [OpsCommand.AddQuestion, OpsCommand.DeleteQuestion, OpsCommand.UpdateQuestion],
  ReceivingFacilityRequests: [
    OpsCommand.AcceptReceivingFacilityRequest,
    OpsCommand.AddReceivingFacilityRequestDeclineHistory,
    OpsCommand.CancelReceivingFacilityRequest,
    OpsCommand.DeleteReceivingFacilityRequest,
    OpsCommand.DenyReceivingFacilityRequest,
    OpsCommand.DivertReceivingFacilityRequest,
    OpsCommand.ReferReceivingFacilityRequest,
  ],
  RendezvousRequests: [
    OpsCommand.AddRendezvousRequest,
    OpsCommand.DeleteRendezvousRequest,
    OpsCommand.UpdateRendezvousRequest,
  ],
  RequesterRoles: [
    OpsCommand.AddRequesterRole,
    OpsCommand.DeleteRequesterRole,
    OpsCommand.UpdateRequesterRole,
  ],
  Requesters: [
    OpsCommand.UpdateRequester,
    OpsCommand.UpdateRequesterSpecialtyTeam,
    OpsCommand.UpdateRequestorAgencyLocation,
    OpsCommand.UpdateTransferCenterCallInfo,
  ],
  RequestLocations: [
    OpsCommand.UpdateReceivingFacilityAutoAcceptance,
    OpsCommand.UpdateRequestLocation,
  ],
  RequestPatients: [
    OpsCommand.AddRequestPatient,
    OpsCommand.DeleteRequestPatient,
    OpsCommand.UpdateChiefComplaint,
    OpsCommand.UpdatePatientClinicalInfo,
    OpsCommand.UpdatePatientInfo,
    OpsCommand.UpdateRequestPatient,
  ],
  Requests: [
    OpsCommand.AcknowledgeExternalRequest,
    OpsCommand.BeginAssignment,
    OpsCommand.CancelRequest,
    OpsCommand.CancelRequestFromTransferCenter,
    OpsCommand.ChangeCallType,
    OpsCommand.ChangeRequestCancellationReason,
    OpsCommand.ChangeRequestType,
    OpsCommand.CreateRequest,
    OpsCommand.DelayAssignment,
    OpsCommand.DuplicateRequest,
    OpsCommand.ReactivateRequest,
    OpsCommand.ReactivateRequestFromTransferCenter,
    OpsCommand.RecalculateCandidates,
    OpsCommand.RequestPublicRelationFromUnit,
    OpsCommand.UpdateRequest,
    OpsCommand.UpdateRequestAtlo,
    OpsCommand.UpdateRequestPublicUtilityInfo,
    OpsCommand.UpdateRequestRegion,
    OpsCommand.UpdateRequestSafetyQuestions,
    OpsCommand.UpdateRequestStandbyStatus,
  ],
  TimelineItems: [
    OpsCommand.AddTimelineItem,
    OpsCommand.DeleteTimelineItem,
    OpsCommand.UpdateTimelineItem,
    OpsCommand.UpsertTimelineItem,
  ],
  Timelines: [OpsCommand.AddTimeline, OpsCommand.DeleteTimeline, OpsCommand.UpdateTimeline],
  Timestamps: [
    OpsCommand.AddEmsReport,
    OpsCommand.AddTimestamp,
    OpsCommand.DeleteTimestamp,
    OpsCommand.ReSendToDataWarehouse,
    OpsCommand.SendToImageTrend,
    OpsCommand.UpdateEmsReport,
    OpsCommand.UpdateTimestamp,
  ],
  TimestampTypes: [
    OpsCommand.AddTimestampType,
    OpsCommand.DeleteTimestampType,
    OpsCommand.UpdateTimestampType,
  ],
  TrackedMessages: [
    OpsCommand.DeliverTrackedMessage,
    OpsCommand.SendMessage,
    OpsCommand.SendSupportRequestEmail,
    OpsCommand.UpdateTrackedMessage,
  ],
  TransferReasons: [
    OpsCommand.AddTransferReason,
    OpsCommand.DeleteTransferReason,
    OpsCommand.UpdateTransferReason,
  ],
  TransportOfferOptions: [OpsCommand.UpdateTransportOfferOption],
  TransportOffers: [
    OpsCommand.AcceptTransportOffer,
    OpsCommand.AddCancellation,
    OpsCommand.AddDecline,
    OpsCommand.AddTransportOffer,
    OpsCommand.BeginTransportOffer,
    OpsCommand.CancelTransportOffer,
    OpsCommand.DeclineAndAssignNewTransportOffer,
    OpsCommand.DeclineTransportOffer,
    OpsCommand.DeclineTransportOfferAndDelayAssignment,
    OpsCommand.DeleteTransportOffer,
    OpsCommand.InitiateTransportCheck,
    OpsCommand.OfferWithBulkSkip,
    OpsCommand.ReferTransportOffer,
    OpsCommand.SkipTransportOffer,
    OpsCommand.UpdateCancellation,
    OpsCommand.UpdateDecline,
    OpsCommand.UpdateOfferRank,
    OpsCommand.UpdateSkip,
    OpsCommand.UpdateTransportOffer,
    OpsCommand.UpdateTransportOfferEta,
  ],
  TransportReasons: [
    OpsCommand.AddTransportReason,
    OpsCommand.DeleteTransportReason,
    OpsCommand.UpdateTransportReason,
  ],
  TripLegManifestEntries: [
    OpsCommand.AddManifestEntry,
    OpsCommand.DeleteManifestEntry,
    OpsCommand.UpdateManifestEntry,
  ],
  TripLegs: [OpsCommand.UpdateOdometerReadings, OpsCommand.UpdateTripLegOnFinal],
  TripPassengers: [
    OpsCommand.AddTripPassenger,
    OpsCommand.DeleteTripPassenger,
    OpsCommand.UpdateTripPassenger,
  ],
  Trips: [
    OpsCommand.AddTrip,
    OpsCommand.AddTripLegManifestEntry,
    OpsCommand.CalculateEtas,
    OpsCommand.ConfirmManifest,
    OpsCommand.CreatePrecautionaryLanding,
    OpsCommand.CreatePrecautionaryLandingV2,
    OpsCommand.DeleteTrip,
    OpsCommand.DeleteTripLegManifestEntry,
    OpsCommand.InsertWaypoint,
    OpsCommand.MergePostAndDropoffWaypoints,
    OpsCommand.MergeUnitOriginAndPickupWaypoints,
    OpsCommand.ModifyWaypoint,
    OpsCommand.RecalculateTripMileage,
    OpsCommand.RemoveWaypoint,
    OpsCommand.SplitUnitOriginAndPickupWaypoints,
    OpsCommand.SplitUnitPostAndDropoffWaypoints,
    OpsCommand.SwapWaypoint,
    OpsCommand.UpdateTrip,
  ],
  UnitActivationRules: [
    OpsCommand.AddUnitActivationRule,
    OpsCommand.DeleteUnitActivationRule,
    OpsCommand.UpdateUnitActivationRule,
  ],
  UnitEMSystemMappings: [
    OpsCommand.AddUnitEMSystemMapping,
    OpsCommand.DeleteUnitEMSystemMapping,
    OpsCommand.UpdateUnitEMSystemMapping,
  ],
  UnitNotes: [OpsCommand.AddUnitNote, OpsCommand.DeleteUnitNote, OpsCommand.UpdateUnitNote],
  UnitPositions: [
    OpsCommand.AddUnitPosition,
    OpsCommand.DeleteUnitPosition,
    OpsCommand.RemoveTeamMemberFromUnitPosition,
    OpsCommand.UpdateUnitPosition,
    OpsCommand.UpsertUnitPosition,
  ],
  Units: [
    OpsCommand.AddUnit,
    OpsCommand.AssignVehicle,
    OpsCommand.DelayUnit,
    OpsCommand.DeleteUnit,
    OpsCommand.DisableUnit,
    OpsCommand.EnableUnit,
    OpsCommand.EnsureThirdPartyUnit,
    OpsCommand.EnsureThirdPartyUnits,
    OpsCommand.HideUnit,
    OpsCommand.MarkAsPilotUpdated,
    OpsCommand.ReassignVehicle,
    OpsCommand.RemoveDelayFromUnit,
    OpsCommand.RemoveVehicleFromUnit,
    OpsCommand.ReturnUnitToService,
    OpsCommand.SourceCrewFromOutOfServiceUnit,
    OpsCommand.SwapUnitVehicles,
    OpsCommand.TakeUnitOutOfService,
    OpsCommand.TeleportUnit,
    OpsCommand.UnhideUnit,
    OpsCommand.UpdatePilotUnitConfiguration,
    OpsCommand.UpdateUnit,
    OpsCommand.UpdateUnitConfiguration,
  ],
  UnitShifts: [OpsCommand.AddUnitShift, OpsCommand.DeleteUnitShift, OpsCommand.UpdateUnitShift],
  VehicleDispositions: [
    OpsCommand.AddVehicleDisposition,
    OpsCommand.DeleteVehicleDisposition,
    OpsCommand.UpdateVehicleDisposition,
  ],
  VehicleNotificationGroups: [
    OpsCommand.AddVehicleNotificationGroup,
    OpsCommand.DeleteVehicleNotificationGroup,
  ],
  Waypoints: [
    OpsCommand.AddFuelBurn,
    OpsCommand.AddWaypoint,
    OpsCommand.DeleteWaypoint,
    OpsCommand.UpdateWaypoint,
  ],
  WebOrderLogs: [OpsCommand.AcknowledgeWebOrderLog, OpsCommand.AddWebOrderLog],
};

export class OperationsMutations {
  constructor(private _executor: GraphqlMutationExecutorService) {}

  // ActivationRules
  public addActivationRule<T = any>(
    command: AddActivationRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddActivationRule',
      AddActivationRuleMutation,
      AddActivationRuleMutationVariables,
      T
    >({
      name: 'AddActivationRule',
      mutation: gql`
        mutation AddActivationRuleMutation($command: AddActivationRule!) {
          addActivationRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteActivationRule<T = any>(
    command: DeleteActivationRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteActivationRule',
      DeleteActivationRuleMutation,
      DeleteActivationRuleMutationVariables,
      T
    >({
      name: 'DeleteActivationRule',
      mutation: gql`
        mutation DeleteActivationRuleMutation($command: DeleteActivationRule!) {
          deleteActivationRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateActivationRule<T = any>(
    command: UpdateActivationRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateActivationRule',
      UpdateActivationRuleMutation,
      UpdateActivationRuleMutationVariables,
      T
    >({
      name: 'UpdateActivationRule',
      mutation: gql`
        mutation UpdateActivationRuleMutation($command: UpdateActivationRule!) {
          updateActivationRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ActiveAlertAcknowledgements
  // ActiveAlerts
  public acknowledgeAlert<T = any>(
    command: AcknowledgeAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcknowledgeAlert',
      AcknowledgeAlertMutation,
      AcknowledgeAlertMutationVariables,
      T
    >({
      name: 'AcknowledgeAlert',
      mutation: gql`
        mutation AcknowledgeAlertMutation($command: AcknowledgeAlert!) {
          acknowledgeAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addActiveAlert<T = any>(
    command: AddActiveAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddActiveAlert',
      AddActiveAlertMutation,
      AddActiveAlertMutationVariables,
      T
    >({
      name: 'AddActiveAlert',
      mutation: gql`
        mutation AddActiveAlertMutation($command: AddActiveAlert!) {
          addActiveAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cleanupActiveAlerts<T = any>(
    command: CleanupActiveAlerts,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CleanupActiveAlerts',
      CleanupActiveAlertsMutation,
      CleanupActiveAlertsMutationVariables,
      T
    >({
      name: 'CleanupActiveAlerts',
      mutation: gql`
        mutation CleanupActiveAlertsMutation($command: CleanupActiveAlerts!) {
          cleanupActiveAlerts(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cleanupCardActiveAlerts<T = any>(
    command: CleanupCardActiveAlerts,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CleanupCardActiveAlerts',
      CleanupCardActiveAlertsMutation,
      CleanupCardActiveAlertsMutationVariables,
      T
    >({
      name: 'CleanupCardActiveAlerts',
      mutation: gql`
        mutation CleanupCardActiveAlertsMutation($command: CleanupCardActiveAlerts!) {
          cleanupCardActiveAlerts(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteActiveAlert<T = any>(
    command: DeleteActiveAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteActiveAlert',
      DeleteActiveAlertMutation,
      DeleteActiveAlertMutationVariables,
      T
    >({
      name: 'DeleteActiveAlert',
      mutation: gql`
        mutation DeleteActiveAlertMutation($command: DeleteActiveAlert!) {
          deleteActiveAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public snoozeAlert<T = any>(
    command: SnoozeAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SnoozeAlert',
      SnoozeAlertMutation,
      SnoozeAlertMutationVariables,
      T
    >({
      name: 'SnoozeAlert',
      mutation: gql`
        mutation SnoozeAlertMutation($command: SnoozeAlert!) {
          snoozeAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateActiveAlert<T = any>(
    command: UpdateActiveAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateActiveAlert',
      UpdateActiveAlertMutation,
      UpdateActiveAlertMutationVariables,
      T
    >({
      name: 'UpdateActiveAlert',
      mutation: gql`
        mutation UpdateActiveAlertMutation($command: UpdateActiveAlert!) {
          updateActiveAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ActiveCardUnitOfferings
  // ActiveTimelines
  public deleteActiveTimeline<T = any>(
    command: DeleteActiveTimeline,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteActiveTimeline',
      DeleteActiveTimelineMutation,
      DeleteActiveTimelineMutationVariables,
      T
    >({
      name: 'DeleteActiveTimeline',
      mutation: gql`
        mutation DeleteActiveTimelineMutation($command: DeleteActiveTimeline!) {
          deleteActiveTimeline(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateActiveTimeline<T = any>(
    command: UpdateActiveTimeline,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateActiveTimeline',
      UpdateActiveTimelineMutation,
      UpdateActiveTimelineMutationVariables,
      T
    >({
      name: 'UpdateActiveTimeline',
      mutation: gql`
        mutation UpdateActiveTimelineMutation($command: UpdateActiveTimeline!) {
          updateActiveTimeline(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Alerts
  public addAlert<T = any>(
    command: AddAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddAlert', AddAlertMutation, AddAlertMutationVariables, T>({
      name: 'AddAlert',
      mutation: gql`
        mutation AddAlertMutation($command: AddAlert!) {
          addAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public copyAlert<T = any>(
    command: CopyAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'CopyAlert', CopyAlertMutation, CopyAlertMutationVariables, T>({
      name: 'CopyAlert',
      mutation: gql`
        mutation CopyAlertMutation($command: CopyAlert!) {
          copyAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteAlert<T = any>(
    command: DeleteAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteAlert',
      DeleteAlertMutation,
      DeleteAlertMutationVariables,
      T
    >({
      name: 'DeleteAlert',
      mutation: gql`
        mutation DeleteAlertMutation($command: DeleteAlert!) {
          deleteAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateAlert<T = any>(
    command: UpdateAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateAlert',
      UpdateAlertMutation,
      UpdateAlertMutationVariables,
      T
    >({
      name: 'UpdateAlert',
      mutation: gql`
        mutation UpdateAlertMutation($command: UpdateAlert!) {
          updateAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ApplicationNotifications
  public addApplicationNotification<T = any>(
    command: AddApplicationNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddApplicationNotification',
      AddApplicationNotificationMutation,
      AddApplicationNotificationMutationVariables,
      T
    >({
      name: 'AddApplicationNotification',
      mutation: gql`
        mutation AddApplicationNotificationMutation($command: AddApplicationNotification!) {
          addApplicationNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteApplicationNotification<T = any>(
    command: DeleteApplicationNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteApplicationNotification',
      DeleteApplicationNotificationMutation,
      DeleteApplicationNotificationMutationVariables,
      T
    >({
      name: 'DeleteApplicationNotification',
      mutation: gql`
        mutation DeleteApplicationNotificationMutation($command: DeleteApplicationNotification!) {
          deleteApplicationNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public dismissApplicationNotification<T = any>(
    command: DismissApplicationNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DismissApplicationNotification',
      DismissApplicationNotificationMutation,
      DismissApplicationNotificationMutationVariables,
      T
    >({
      name: 'DismissApplicationNotification',
      mutation: gql`
        mutation DismissApplicationNotificationMutation($command: DismissApplicationNotification!) {
          dismissApplicationNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateApplicationNotification<T = any>(
    command: UpdateApplicationNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateApplicationNotification',
      UpdateApplicationNotificationMutation,
      UpdateApplicationNotificationMutationVariables,
      T
    >({
      name: 'UpdateApplicationNotification',
      mutation: gql`
        mutation UpdateApplicationNotificationMutation($command: UpdateApplicationNotification!) {
          updateApplicationNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // AssignmentDelayedReasons
  public addAssignmentDelayedReason<T = any>(
    command: AddAssignmentDelayedReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddAssignmentDelayedReason',
      AddAssignmentDelayedReasonMutation,
      AddAssignmentDelayedReasonMutationVariables,
      T
    >({
      name: 'AddAssignmentDelayedReason',
      mutation: gql`
        mutation AddAssignmentDelayedReasonMutation($command: AddAssignmentDelayedReason!) {
          addAssignmentDelayedReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteAssignmentDelayedReason<T = any>(
    command: DeleteAssignmentDelayedReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteAssignmentDelayedReason',
      DeleteAssignmentDelayedReasonMutation,
      DeleteAssignmentDelayedReasonMutationVariables,
      T
    >({
      name: 'DeleteAssignmentDelayedReason',
      mutation: gql`
        mutation DeleteAssignmentDelayedReasonMutation($command: DeleteAssignmentDelayedReason!) {
          deleteAssignmentDelayedReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateAssignmentDelayedReason<T = any>(
    command: UpdateAssignmentDelayedReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateAssignmentDelayedReason',
      UpdateAssignmentDelayedReasonMutation,
      UpdateAssignmentDelayedReasonMutationVariables,
      T
    >({
      name: 'UpdateAssignmentDelayedReason',
      mutation: gql`
        mutation UpdateAssignmentDelayedReasonMutation($command: UpdateAssignmentDelayedReason!) {
          updateAssignmentDelayedReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CancellationCategories
  public addCancellationCategory<T = any>(
    command: AddCancellationCategory,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCancellationCategory',
      AddCancellationCategoryMutation,
      AddCancellationCategoryMutationVariables,
      T
    >({
      name: 'AddCancellationCategory',
      mutation: gql`
        mutation AddCancellationCategoryMutation($command: AddCancellationCategory!) {
          addCancellationCategory(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCancellationCategory<T = any>(
    command: DeleteCancellationCategory,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCancellationCategory',
      DeleteCancellationCategoryMutation,
      DeleteCancellationCategoryMutationVariables,
      T
    >({
      name: 'DeleteCancellationCategory',
      mutation: gql`
        mutation DeleteCancellationCategoryMutation($command: DeleteCancellationCategory!) {
          deleteCancellationCategory(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCancellationCategory<T = any>(
    command: UpdateCancellationCategory,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCancellationCategory',
      UpdateCancellationCategoryMutation,
      UpdateCancellationCategoryMutationVariables,
      T
    >({
      name: 'UpdateCancellationCategory',
      mutation: gql`
        mutation UpdateCancellationCategoryMutation($command: UpdateCancellationCategory!) {
          updateCancellationCategory(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CancellationReasons
  public addCancellationReason<T = any>(
    command: AddCancellationReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCancellationReason',
      AddCancellationReasonMutation,
      AddCancellationReasonMutationVariables,
      T
    >({
      name: 'AddCancellationReason',
      mutation: gql`
        mutation AddCancellationReasonMutation($command: AddCancellationReason!) {
          addCancellationReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCancellationReason<T = any>(
    command: DeleteCancellationReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCancellationReason',
      DeleteCancellationReasonMutation,
      DeleteCancellationReasonMutationVariables,
      T
    >({
      name: 'DeleteCancellationReason',
      mutation: gql`
        mutation DeleteCancellationReasonMutation($command: DeleteCancellationReason!) {
          deleteCancellationReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCancellationReason<T = any>(
    command: UpdateCancellationReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCancellationReason',
      UpdateCancellationReasonMutation,
      UpdateCancellationReasonMutationVariables,
      T
    >({
      name: 'UpdateCancellationReason',
      mutation: gql`
        mutation UpdateCancellationReasonMutation($command: UpdateCancellationReason!) {
          updateCancellationReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CancellationSecondaryReasons
  public addCancellationSecondaryReason<T = any>(
    command: AddCancellationSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCancellationSecondaryReason',
      AddCancellationSecondaryReasonMutation,
      AddCancellationSecondaryReasonMutationVariables,
      T
    >({
      name: 'AddCancellationSecondaryReason',
      mutation: gql`
        mutation AddCancellationSecondaryReasonMutation($command: AddCancellationSecondaryReason!) {
          addCancellationSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCancellationSecondaryReason<T = any>(
    command: DeleteCancellationSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCancellationSecondaryReason',
      DeleteCancellationSecondaryReasonMutation,
      DeleteCancellationSecondaryReasonMutationVariables,
      T
    >({
      name: 'DeleteCancellationSecondaryReason',
      mutation: gql`
        mutation DeleteCancellationSecondaryReasonMutation(
          $command: DeleteCancellationSecondaryReason!
        ) {
          deleteCancellationSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCancellationSecondaryReason<T = any>(
    command: UpdateCancellationSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCancellationSecondaryReason',
      UpdateCancellationSecondaryReasonMutation,
      UpdateCancellationSecondaryReasonMutationVariables,
      T
    >({
      name: 'UpdateCancellationSecondaryReason',
      mutation: gql`
        mutation UpdateCancellationSecondaryReasonMutation(
          $command: UpdateCancellationSecondaryReason!
        ) {
          updateCancellationSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CardLinks
  public addCardLink<T = any>(
    command: AddCardLink,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCardLink',
      AddCardLinkMutation,
      AddCardLinkMutationVariables,
      T
    >({
      name: 'AddCardLink',
      mutation: gql`
        mutation AddCardLinkMutation($command: AddCardLink!) {
          addCardLink(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCardLink<T = any>(
    command: DeleteCardLink,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCardLink',
      DeleteCardLinkMutation,
      DeleteCardLinkMutationVariables,
      T
    >({
      name: 'DeleteCardLink',
      mutation: gql`
        mutation DeleteCardLinkMutation($command: DeleteCardLink!) {
          deleteCardLink(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCardLink<T = any>(
    command: UpdateCardLink,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardLink',
      UpdateCardLinkMutation,
      UpdateCardLinkMutationVariables,
      T
    >({
      name: 'UpdateCardLink',
      mutation: gql`
        mutation UpdateCardLinkMutation($command: UpdateCardLink!) {
          updateCardLink(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CardNoteArchives
  public addCardNoteArchive<T = any>(
    command: AddCardNoteArchive,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCardNoteArchive',
      AddCardNoteArchiveMutation,
      AddCardNoteArchiveMutationVariables,
      T
    >({
      name: 'AddCardNoteArchive',
      mutation: gql`
        mutation AddCardNoteArchiveMutation($command: AddCardNoteArchive!) {
          addCardNoteArchive(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCardNoteArchive<T = any>(
    command: DeleteCardNoteArchive,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCardNoteArchive',
      DeleteCardNoteArchiveMutation,
      DeleteCardNoteArchiveMutationVariables,
      T
    >({
      name: 'DeleteCardNoteArchive',
      mutation: gql`
        mutation DeleteCardNoteArchiveMutation($command: DeleteCardNoteArchive!) {
          deleteCardNoteArchive(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCardNoteArchive<T = any>(
    command: UpdateCardNoteArchive,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardNoteArchive',
      UpdateCardNoteArchiveMutation,
      UpdateCardNoteArchiveMutationVariables,
      T
    >({
      name: 'UpdateCardNoteArchive',
      mutation: gql`
        mutation UpdateCardNoteArchiveMutation($command: UpdateCardNoteArchive!) {
          updateCardNoteArchive(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CardNotes
  public addCardNote<T = any>(
    command: AddCardNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCardNote',
      AddCardNoteMutation,
      AddCardNoteMutationVariables,
      T
    >({
      name: 'AddCardNote',
      mutation: gql`
        mutation AddCardNoteMutation($command: AddCardNote!) {
          addCardNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCardNote<T = any>(
    command: DeleteCardNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCardNote',
      DeleteCardNoteMutation,
      DeleteCardNoteMutationVariables,
      T
    >({
      name: 'DeleteCardNote',
      mutation: gql`
        mutation DeleteCardNoteMutation($command: DeleteCardNote!) {
          deleteCardNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public sendNoteToCard<T = any>(
    command: SendNoteToCard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SendNoteToCard',
      SendNoteToCardMutation,
      SendNoteToCardMutationVariables,
      T
    >({
      name: 'SendNoteToCard',
      mutation: gql`
        mutation SendNoteToCardMutation($command: SendNoteToCard!) {
          sendNoteToCard(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCardNote<T = any>(
    command: UpdateCardNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardNote',
      UpdateCardNoteMutation,
      UpdateCardNoteMutationVariables,
      T
    >({
      name: 'UpdateCardNote',
      mutation: gql`
        mutation UpdateCardNoteMutation($command: UpdateCardNote!) {
          updateCardNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CardReOpenReasons
  public addCardReOpenReason<T = any>(
    command: AddCardReOpenReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCardReOpenReason',
      AddCardReOpenReasonMutation,
      AddCardReOpenReasonMutationVariables,
      T
    >({
      name: 'AddCardReOpenReason',
      mutation: gql`
        mutation AddCardReOpenReasonMutation($command: AddCardReOpenReason!) {
          addCardReOpenReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCardReOpenReason<T = any>(
    command: DeleteCardReOpenReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCardReOpenReason',
      DeleteCardReOpenReasonMutation,
      DeleteCardReOpenReasonMutationVariables,
      T
    >({
      name: 'DeleteCardReOpenReason',
      mutation: gql`
        mutation DeleteCardReOpenReasonMutation($command: DeleteCardReOpenReason!) {
          deleteCardReOpenReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCardReOpenReason<T = any>(
    command: UpdateCardReOpenReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardReOpenReason',
      UpdateCardReOpenReasonMutation,
      UpdateCardReOpenReasonMutationVariables,
      T
    >({
      name: 'UpdateCardReOpenReason',
      mutation: gql`
        mutation UpdateCardReOpenReasonMutation($command: UpdateCardReOpenReason!) {
          updateCardReOpenReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Cards
  public addCard<T = any>(
    command: AddCard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddCard', AddCardMutation, AddCardMutationVariables, T>({
      name: 'AddCard',
      mutation: gql`
        mutation AddCardMutation($command: AddCard!) {
          addCard(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public changeCardCallStatus<T = any>(
    command: ChangeCardCallStatus,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ChangeCardCallStatus',
      ChangeCardCallStatusMutation,
      ChangeCardCallStatusMutationVariables,
      T
    >({
      name: 'ChangeCardCallStatus',
      mutation: gql`
        mutation ChangeCardCallStatusMutation($command: ChangeCardCallStatus!) {
          changeCardCallStatus(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public changeUnit<T = any>(
    command: ChangeUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'ChangeUnit', ChangeUnitMutation, ChangeUnitMutationVariables, T>(
      {
        name: 'ChangeUnit',
        mutation: gql`
          mutation ChangeUnitMutation($command: ChangeUnit!) {
            changeUnit(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public checkForFlightFollowingDestinationConflict<T = any>(
    command: CheckForFlightFollowingDestinationConflict,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CheckForFlightFollowingDestinationConflict',
      CheckForFlightFollowingDestinationConflictMutation,
      CheckForFlightFollowingDestinationConflictMutationVariables,
      T
    >({
      name: 'CheckForFlightFollowingDestinationConflict',
      mutation: gql`
        mutation CheckForFlightFollowingDestinationConflictMutation(
          $command: CheckForFlightFollowingDestinationConflict!
        ) {
          checkForFlightFollowingDestinationConflict(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cleanupCards<T = any>(
    command: CleanupCards,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CleanupCards',
      CleanupCardsMutation,
      CleanupCardsMutationVariables,
      T
    >({
      name: 'CleanupCards',
      mutation: gql`
        mutation CleanupCardsMutation($command: CleanupCards!) {
          cleanupCards(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public closeCard<T = any>(
    command: CloseCard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'CloseCard', CloseCardMutation, CloseCardMutationVariables, T>({
      name: 'CloseCard',
      mutation: gql`
        mutation CloseCardMutation($command: CloseCard!) {
          closeCard(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createSystemCrewNotification<T = any>(
    command: CreateSystemCrewNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreateSystemCrewNotification',
      CreateSystemCrewNotificationMutation,
      CreateSystemCrewNotificationMutationVariables,
      T
    >({
      name: 'CreateSystemCrewNotification',
      mutation: gql`
        mutation CreateSystemCrewNotificationMutation($command: CreateSystemCrewNotification!) {
          createSystemCrewNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCard<T = any>(
    command: DeleteCard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'DeleteCard', DeleteCardMutation, DeleteCardMutationVariables, T>(
      {
        name: 'DeleteCard',
        mutation: gql`
          mutation DeleteCardMutation($command: DeleteCard!) {
            deleteCard(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public divert<T = any>(
    command: Divert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'Divert', DivertMutation, DivertMutationVariables, T>({
      name: 'Divert',
      mutation: gql`
        mutation DivertMutation($command: Divert!) {
          divert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public generateCardReport<T = any>(
    command: GenerateCardReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'GenerateCardReport',
      GenerateCardReportMutation,
      GenerateCardReportMutationVariables,
      T
    >({
      name: 'GenerateCardReport',
      mutation: gql`
        mutation GenerateCardReportMutation($command: GenerateCardReport!) {
          generateCardReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public generateCardSummaryChange<T = any>(
    command: GenerateCardSummaryChange,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'GenerateCardSummaryChange',
      GenerateCardSummaryChangeMutation,
      GenerateCardSummaryChangeMutationVariables,
      T
    >({
      name: 'GenerateCardSummaryChange',
      mutation: gql`
        mutation GenerateCardSummaryChangeMutation($command: GenerateCardSummaryChange!) {
          generateCardSummaryChange(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public generateCardSummaryChangeV2<T = any>(
    command: GenerateCardSummaryChangeV2,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'GenerateCardSummaryChangeV2',
      GenerateCardSummaryChangeV2Mutation,
      GenerateCardSummaryChangeV2MutationVariables,
      T
    >({
      name: 'GenerateCardSummaryChangeV2',
      mutation: gql`
        mutation GenerateCardSummaryChangeV2Mutation($command: GenerateCardSummaryChangeV2!) {
          generateCardSummaryChangeV2(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public linkCards<T = any>(
    command: LinkCards,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'LinkCards', LinkCardsMutation, LinkCardsMutationVariables, T>({
      name: 'LinkCards',
      mutation: gql`
        mutation LinkCardsMutation($command: LinkCards!) {
          linkCards(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public reOpenCard<T = any>(
    command: ReOpenCard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'ReOpenCard', ReOpenCardMutation, ReOpenCardMutationVariables, T>(
      {
        name: 'ReOpenCard',
        mutation: gql`
          mutation ReOpenCardMutation($command: ReOpenCard!) {
            reOpenCard(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public requestAdditionalUnits<T = any>(
    command: RequestAdditionalUnits,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RequestAdditionalUnits',
      RequestAdditionalUnitsMutation,
      RequestAdditionalUnitsMutationVariables,
      T
    >({
      name: 'RequestAdditionalUnits',
      mutation: gql`
        mutation RequestAdditionalUnitsMutation($command: RequestAdditionalUnits!) {
          requestAdditionalUnits(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public scanForFlights<T = any>(
    command: ScanForFlights,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ScanForFlights',
      ScanForFlightsMutation,
      ScanForFlightsMutationVariables,
      T
    >({
      name: 'ScanForFlights',
      mutation: gql`
        mutation ScanForFlightsMutation($command: ScanForFlights!) {
          scanForFlights(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public sendPatientInfo<T = any>(
    command: SendPatientInfo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SendPatientInfo',
      SendPatientInfoMutation,
      SendPatientInfoMutationVariables,
      T
    >({
      name: 'SendPatientInfo',
      mutation: gql`
        mutation SendPatientInfoMutation($command: SendPatientInfo!) {
          sendPatientInfo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public setCardLockStatus<T = any>(
    command: SetCardLockStatus,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SetCardLockStatus',
      SetCardLockStatusMutation,
      SetCardLockStatusMutationVariables,
      T
    >({
      name: 'SetCardLockStatus',
      mutation: gql`
        mutation SetCardLockStatusMutation($command: SetCardLockStatus!) {
          setCardLockStatus(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public unDeleteCard<T = any>(
    command: UnDeleteCard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UnDeleteCard',
      UnDeleteCardMutation,
      UnDeleteCardMutationVariables,
      T
    >({
      name: 'UnDeleteCard',
      mutation: gql`
        mutation UnDeleteCardMutation($command: UnDeleteCard!) {
          unDeleteCard(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCard<T = any>(
    command: UpdateCard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'UpdateCard', UpdateCardMutation, UpdateCardMutationVariables, T>(
      {
        name: 'UpdateCard',
        mutation: gql`
          mutation UpdateCardMutation($command: UpdateCard!) {
            updateCard(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public updateCardBillable<T = any>(
    command: UpdateCardBillable,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardBillable',
      UpdateCardBillableMutation,
      UpdateCardBillableMutationVariables,
      T
    >({
      name: 'UpdateCardBillable',
      mutation: gql`
        mutation UpdateCardBillableMutation($command: UpdateCardBillable!) {
          updateCardBillable(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCardContactCompleted<T = any>(
    command: UpdateCardContactCompleted,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardContactCompleted',
      UpdateCardContactCompletedMutation,
      UpdateCardContactCompletedMutationVariables,
      T
    >({
      name: 'UpdateCardContactCompleted',
      mutation: gql`
        mutation UpdateCardContactCompletedMutation($command: UpdateCardContactCompleted!) {
          updateCardContactCompleted(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCardDiversionType<T = any>(
    command: UpdateCardDiversionType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardDiversionType',
      UpdateCardDiversionTypeMutation,
      UpdateCardDiversionTypeMutationVariables,
      T
    >({
      name: 'UpdateCardDiversionType',
      mutation: gql`
        mutation UpdateCardDiversionTypeMutation($command: UpdateCardDiversionType!) {
          updateCardDiversionType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCardSearchIndex<T = any>(
    command: UpdateCardSearchIndex,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCardSearchIndex',
      UpdateCardSearchIndexMutation,
      UpdateCardSearchIndexMutationVariables,
      T
    >({
      name: 'UpdateCardSearchIndex',
      mutation: gql`
        mutation UpdateCardSearchIndexMutation($command: UpdateCardSearchIndex!) {
          updateCardSearchIndex(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateGmrCadNumber<T = any>(
    command: UpdateGmrCadNumber,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateGmrCadNumber',
      UpdateGmrCadNumberMutation,
      UpdateGmrCadNumberMutationVariables,
      T
    >({
      name: 'UpdateGmrCadNumber',
      mutation: gql`
        mutation UpdateGmrCadNumberMutation($command: UpdateGmrCadNumber!) {
          updateGmrCadNumber(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePlannedCardCompletionTime<T = any>(
    command: UpdatePlannedCardCompletionTime,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePlannedCardCompletionTime',
      UpdatePlannedCardCompletionTimeMutation,
      UpdatePlannedCardCompletionTimeMutationVariables,
      T
    >({
      name: 'UpdatePlannedCardCompletionTime',
      mutation: gql`
        mutation UpdatePlannedCardCompletionTimeMutation(
          $command: UpdatePlannedCardCompletionTime!
        ) {
          updatePlannedCardCompletionTime(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ConfigurationSettings
  public addConfigurationSetting<T = any>(
    command: AddConfigurationSetting,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddConfigurationSetting',
      AddConfigurationSettingMutation,
      AddConfigurationSettingMutationVariables,
      T
    >({
      name: 'AddConfigurationSetting',
      mutation: gql`
        mutation AddConfigurationSettingMutation($command: AddConfigurationSetting!) {
          addConfigurationSetting(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateConfigurationSetting<T = any>(
    command: UpdateConfigurationSetting,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateConfigurationSetting',
      UpdateConfigurationSettingMutation,
      UpdateConfigurationSettingMutationVariables,
      T
    >({
      name: 'UpdateConfigurationSetting',
      mutation: gql`
        mutation UpdateConfigurationSettingMutation($command: UpdateConfigurationSetting!) {
          updateConfigurationSetting(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ConversationParticipants
  // Conversations
  public addConversationToCardWithParticipant<T = any>(
    command: AddConversationToCardWithParticipant,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddConversationToCardWithParticipant',
      AddConversationToCardWithParticipantMutation,
      AddConversationToCardWithParticipantMutationVariables,
      T
    >({
      name: 'AddConversationToCardWithParticipant',
      mutation: gql`
        mutation AddConversationToCardWithParticipantMutation(
          $command: AddConversationToCardWithParticipant!
        ) {
          addConversationToCardWithParticipant(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public closeConversation<T = any>(
    command: CloseConversation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CloseConversation',
      CloseConversationMutation,
      CloseConversationMutationVariables,
      T
    >({
      name: 'CloseConversation',
      mutation: gql`
        mutation CloseConversationMutation($command: CloseConversation!) {
          closeConversation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // DeclineCategories
  public addDeclineCategory<T = any>(
    command: AddDeclineCategory,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddDeclineCategory',
      AddDeclineCategoryMutation,
      AddDeclineCategoryMutationVariables,
      T
    >({
      name: 'AddDeclineCategory',
      mutation: gql`
        mutation AddDeclineCategoryMutation($command: AddDeclineCategory!) {
          addDeclineCategory(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteDeclineCategory<T = any>(
    command: DeleteDeclineCategory,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteDeclineCategory',
      DeleteDeclineCategoryMutation,
      DeleteDeclineCategoryMutationVariables,
      T
    >({
      name: 'DeleteDeclineCategory',
      mutation: gql`
        mutation DeleteDeclineCategoryMutation($command: DeleteDeclineCategory!) {
          deleteDeclineCategory(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateDeclineCategory<T = any>(
    command: UpdateDeclineCategory,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateDeclineCategory',
      UpdateDeclineCategoryMutation,
      UpdateDeclineCategoryMutationVariables,
      T
    >({
      name: 'UpdateDeclineCategory',
      mutation: gql`
        mutation UpdateDeclineCategoryMutation($command: UpdateDeclineCategory!) {
          updateDeclineCategory(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // DeclineReasons
  public addDeclineReason<T = any>(
    command: AddDeclineReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddDeclineReason',
      AddDeclineReasonMutation,
      AddDeclineReasonMutationVariables,
      T
    >({
      name: 'AddDeclineReason',
      mutation: gql`
        mutation AddDeclineReasonMutation($command: AddDeclineReason!) {
          addDeclineReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteDeclineReason<T = any>(
    command: DeleteDeclineReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteDeclineReason',
      DeleteDeclineReasonMutation,
      DeleteDeclineReasonMutationVariables,
      T
    >({
      name: 'DeleteDeclineReason',
      mutation: gql`
        mutation DeleteDeclineReasonMutation($command: DeleteDeclineReason!) {
          deleteDeclineReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateDeclineReason<T = any>(
    command: UpdateDeclineReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateDeclineReason',
      UpdateDeclineReasonMutation,
      UpdateDeclineReasonMutationVariables,
      T
    >({
      name: 'UpdateDeclineReason',
      mutation: gql`
        mutation UpdateDeclineReasonMutation($command: UpdateDeclineReason!) {
          updateDeclineReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // DeclineSecondaryReasons
  public addDeclineSecondaryReason<T = any>(
    command: AddDeclineSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddDeclineSecondaryReason',
      AddDeclineSecondaryReasonMutation,
      AddDeclineSecondaryReasonMutationVariables,
      T
    >({
      name: 'AddDeclineSecondaryReason',
      mutation: gql`
        mutation AddDeclineSecondaryReasonMutation($command: AddDeclineSecondaryReason!) {
          addDeclineSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteDeclineSecondaryReason<T = any>(
    command: DeleteDeclineSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteDeclineSecondaryReason',
      DeleteDeclineSecondaryReasonMutation,
      DeleteDeclineSecondaryReasonMutationVariables,
      T
    >({
      name: 'DeleteDeclineSecondaryReason',
      mutation: gql`
        mutation DeleteDeclineSecondaryReasonMutation($command: DeleteDeclineSecondaryReason!) {
          deleteDeclineSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateDeclineSecondaryReason<T = any>(
    command: UpdateDeclineSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateDeclineSecondaryReason',
      UpdateDeclineSecondaryReasonMutation,
      UpdateDeclineSecondaryReasonMutationVariables,
      T
    >({
      name: 'UpdateDeclineSecondaryReason',
      mutation: gql`
        mutation UpdateDeclineSecondaryReasonMutation($command: UpdateDeclineSecondaryReason!) {
          updateDeclineSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // DiversionReasons
  public addDiversionReason<T = any>(
    command: AddDiversionReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddDiversionReason',
      AddDiversionReasonMutation,
      AddDiversionReasonMutationVariables,
      T
    >({
      name: 'AddDiversionReason',
      mutation: gql`
        mutation AddDiversionReasonMutation($command: AddDiversionReason!) {
          addDiversionReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteDiversionReason<T = any>(
    command: DeleteDiversionReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteDiversionReason',
      DeleteDiversionReasonMutation,
      DeleteDiversionReasonMutationVariables,
      T
    >({
      name: 'DeleteDiversionReason',
      mutation: gql`
        mutation DeleteDiversionReasonMutation($command: DeleteDiversionReason!) {
          deleteDiversionReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateDiversionReason<T = any>(
    command: UpdateDiversionReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateDiversionReason',
      UpdateDiversionReasonMutation,
      UpdateDiversionReasonMutationVariables,
      T
    >({
      name: 'UpdateDiversionReason',
      mutation: gql`
        mutation UpdateDiversionReasonMutation($command: UpdateDiversionReason!) {
          updateDiversionReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // EscortRequests
  public addEscortRequest<T = any>(
    command: AddEscortRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddEscortRequest',
      AddEscortRequestMutation,
      AddEscortRequestMutationVariables,
      T
    >({
      name: 'AddEscortRequest',
      mutation: gql`
        mutation AddEscortRequestMutation($command: AddEscortRequest!) {
          addEscortRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteEscortRequest<T = any>(
    command: DeleteEscortRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteEscortRequest',
      DeleteEscortRequestMutation,
      DeleteEscortRequestMutationVariables,
      T
    >({
      name: 'DeleteEscortRequest',
      mutation: gql`
        mutation DeleteEscortRequestMutation($command: DeleteEscortRequest!) {
          deleteEscortRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateEscortRequest<T = any>(
    command: UpdateEscortRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateEscortRequest',
      UpdateEscortRequestMutation,
      UpdateEscortRequestMutationVariables,
      T
    >({
      name: 'UpdateEscortRequest',
      mutation: gql`
        mutation UpdateEscortRequestMutation($command: UpdateEscortRequest!) {
          updateEscortRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // EstimatedDurations
  public makeEstimatedDurationOfficial<T = any>(
    command: MakeEstimatedDurationOfficial,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'MakeEstimatedDurationOfficial',
      MakeEstimatedDurationOfficialMutation,
      MakeEstimatedDurationOfficialMutationVariables,
      T
    >({
      name: 'MakeEstimatedDurationOfficial',
      mutation: gql`
        mutation MakeEstimatedDurationOfficialMutation($command: MakeEstimatedDurationOfficial!) {
          makeEstimatedDurationOfficial(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateEstimatedDurations<T = any>(
    command: UpdateEstimatedDurations,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateEstimatedDurations',
      UpdateEstimatedDurationsMutation,
      UpdateEstimatedDurationsMutationVariables,
      T
    >({
      name: 'UpdateEstimatedDurations',
      mutation: gql`
        mutation UpdateEstimatedDurationsMutation($command: UpdateEstimatedDurations!) {
          updateEstimatedDurations(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTripLegDuration<T = any>(
    command: UpdateTripLegDuration,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTripLegDuration',
      UpdateTripLegDurationMutation,
      UpdateTripLegDurationMutationVariables,
      T
    >({
      name: 'UpdateTripLegDuration',
      mutation: gql`
        mutation UpdateTripLegDurationMutation($command: UpdateTripLegDuration!) {
          updateTripLegDuration(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateWaypointDuration<T = any>(
    command: UpdateWaypointDuration,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateWaypointDuration',
      UpdateWaypointDurationMutation,
      UpdateWaypointDurationMutationVariables,
      T
    >({
      name: 'UpdateWaypointDuration',
      mutation: gql`
        mutation UpdateWaypointDurationMutation($command: UpdateWaypointDuration!) {
          updateWaypointDuration(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Etas
  // ExternalActions
  public addExternalAction<T = any>(
    command: AddExternalAction,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddExternalAction',
      AddExternalActionMutation,
      AddExternalActionMutationVariables,
      T
    >({
      name: 'AddExternalAction',
      mutation: gql`
        mutation AddExternalActionMutation($command: AddExternalAction!) {
          addExternalAction(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cleanupPendingExternalActions<T = any>(
    command: CleanupPendingExternalActions,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CleanupPendingExternalActions',
      CleanupPendingExternalActionsMutation,
      CleanupPendingExternalActionsMutationVariables,
      T
    >({
      name: 'CleanupPendingExternalActions',
      mutation: gql`
        mutation CleanupPendingExternalActionsMutation($command: CleanupPendingExternalActions!) {
          cleanupPendingExternalActions(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteExternalAction<T = any>(
    command: DeleteExternalAction,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteExternalAction',
      DeleteExternalActionMutation,
      DeleteExternalActionMutationVariables,
      T
    >({
      name: 'DeleteExternalAction',
      mutation: gql`
        mutation DeleteExternalActionMutation($command: DeleteExternalAction!) {
          deleteExternalAction(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public disregardExternalAction<T = any>(
    command: DisregardExternalAction,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DisregardExternalAction',
      DisregardExternalActionMutation,
      DisregardExternalActionMutationVariables,
      T
    >({
      name: 'DisregardExternalAction',
      mutation: gql`
        mutation DisregardExternalActionMutation($command: DisregardExternalAction!) {
          disregardExternalAction(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateExternalAction<T = any>(
    command: UpdateExternalAction,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateExternalAction',
      UpdateExternalActionMutation,
      UpdateExternalActionMutationVariables,
      T
    >({
      name: 'UpdateExternalAction',
      mutation: gql`
        mutation UpdateExternalActionMutation($command: UpdateExternalAction!) {
          updateExternalAction(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ExternalActionTypes
  public addExternalActionType<T = any>(
    command: AddExternalActionType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddExternalActionType',
      AddExternalActionTypeMutation,
      AddExternalActionTypeMutationVariables,
      T
    >({
      name: 'AddExternalActionType',
      mutation: gql`
        mutation AddExternalActionTypeMutation($command: AddExternalActionType!) {
          addExternalActionType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteExternalActionType<T = any>(
    command: DeleteExternalActionType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteExternalActionType',
      DeleteExternalActionTypeMutation,
      DeleteExternalActionTypeMutationVariables,
      T
    >({
      name: 'DeleteExternalActionType',
      mutation: gql`
        mutation DeleteExternalActionTypeMutation($command: DeleteExternalActionType!) {
          deleteExternalActionType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateExternalActionType<T = any>(
    command: UpdateExternalActionType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateExternalActionType',
      UpdateExternalActionTypeMutation,
      UpdateExternalActionTypeMutationVariables,
      T
    >({
      name: 'UpdateExternalActionType',
      mutation: gql`
        mutation UpdateExternalActionTypeMutation($command: UpdateExternalActionType!) {
          updateExternalActionType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ExternalApiUserAllowedReferences
  // ExternalApiUsers
  // ExternalApiUsersApiKeys
  // ExternalSystemUnits
  // FacilityNonAcceptanceReasons
  public addFacilityNonAcceptanceReason<T = any>(
    command: AddFacilityNonAcceptanceReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddFacilityNonAcceptanceReason',
      AddFacilityNonAcceptanceReasonMutation,
      AddFacilityNonAcceptanceReasonMutationVariables,
      T
    >({
      name: 'AddFacilityNonAcceptanceReason',
      mutation: gql`
        mutation AddFacilityNonAcceptanceReasonMutation($command: AddFacilityNonAcceptanceReason!) {
          addFacilityNonAcceptanceReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteFacilityNonAcceptanceReason<T = any>(
    command: DeleteFacilityNonAcceptanceReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteFacilityNonAcceptanceReason',
      DeleteFacilityNonAcceptanceReasonMutation,
      DeleteFacilityNonAcceptanceReasonMutationVariables,
      T
    >({
      name: 'DeleteFacilityNonAcceptanceReason',
      mutation: gql`
        mutation DeleteFacilityNonAcceptanceReasonMutation(
          $command: DeleteFacilityNonAcceptanceReason!
        ) {
          deleteFacilityNonAcceptanceReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateFacilityNonAcceptanceReason<T = any>(
    command: UpdateFacilityNonAcceptanceReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateFacilityNonAcceptanceReason',
      UpdateFacilityNonAcceptanceReasonMutation,
      UpdateFacilityNonAcceptanceReasonMutationVariables,
      T
    >({
      name: 'UpdateFacilityNonAcceptanceReason',
      mutation: gql`
        mutation UpdateFacilityNonAcceptanceReasonMutation(
          $command: UpdateFacilityNonAcceptanceReason!
        ) {
          updateFacilityNonAcceptanceReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // FirewallRules
  public addFirewallRule<T = any>(
    command: AddFirewallRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddFirewallRule',
      AddFirewallRuleMutation,
      AddFirewallRuleMutationVariables,
      T
    >({
      name: 'AddFirewallRule',
      mutation: gql`
        mutation AddFirewallRuleMutation($command: AddFirewallRule!) {
          addFirewallRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteFirewallRule<T = any>(
    command: DeleteFirewallRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteFirewallRule',
      DeleteFirewallRuleMutation,
      DeleteFirewallRuleMutationVariables,
      T
    >({
      name: 'DeleteFirewallRule',
      mutation: gql`
        mutation DeleteFirewallRuleMutation($command: DeleteFirewallRule!) {
          deleteFirewallRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateFirewallRule<T = any>(
    command: UpdateFirewallRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateFirewallRule',
      UpdateFirewallRuleMutation,
      UpdateFirewallRuleMutationVariables,
      T
    >({
      name: 'UpdateFirewallRule',
      mutation: gql`
        mutation UpdateFirewallRuleMutation($command: UpdateFirewallRule!) {
          updateFirewallRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // FlightFollowingReports
  public addFlightFollowingReport<T = any>(
    command: AddFlightFollowingReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddFlightFollowingReport',
      AddFlightFollowingReportMutation,
      AddFlightFollowingReportMutationVariables,
      T
    >({
      name: 'AddFlightFollowingReport',
      mutation: gql`
        mutation AddFlightFollowingReportMutation($command: AddFlightFollowingReport!) {
          addFlightFollowingReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteFlightFollowingReport<T = any>(
    command: DeleteFlightFollowingReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteFlightFollowingReport',
      DeleteFlightFollowingReportMutation,
      DeleteFlightFollowingReportMutationVariables,
      T
    >({
      name: 'DeleteFlightFollowingReport',
      mutation: gql`
        mutation DeleteFlightFollowingReportMutation($command: DeleteFlightFollowingReport!) {
          deleteFlightFollowingReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateFlightFollowingReport<T = any>(
    command: UpdateFlightFollowingReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateFlightFollowingReport',
      UpdateFlightFollowingReportMutation,
      UpdateFlightFollowingReportMutationVariables,
      T
    >({
      name: 'UpdateFlightFollowingReport',
      mutation: gql`
        mutation UpdateFlightFollowingReportMutation($command: UpdateFlightFollowingReport!) {
          updateFlightFollowingReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // LocationHazardAttachments
  public deleteLocationHazardAttachment<T = any>(
    command: DeleteLocationHazardAttachment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteLocationHazardAttachment',
      DeleteLocationHazardAttachmentMutation,
      DeleteLocationHazardAttachmentMutationVariables,
      T
    >({
      name: 'DeleteLocationHazardAttachment',
      mutation: gql`
        mutation DeleteLocationHazardAttachmentMutation($command: DeleteLocationHazardAttachment!) {
          deleteLocationHazardAttachment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public generateLocationHazardAttachmentUrl<T = any>(
    command: GenerateLocationHazardAttachmentUrl,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'GenerateLocationHazardAttachmentUrl',
      GenerateLocationHazardAttachmentUrlMutation,
      GenerateLocationHazardAttachmentUrlMutationVariables,
      T
    >({
      name: 'GenerateLocationHazardAttachmentUrl',
      mutation: gql`
        mutation GenerateLocationHazardAttachmentUrlMutation(
          $command: GenerateLocationHazardAttachmentUrl!
        ) {
          generateLocationHazardAttachmentUrl(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // LocationHazards
  public addLocationHazard<T = any>(
    command: AddLocationHazard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddLocationHazard',
      AddLocationHazardMutation,
      AddLocationHazardMutationVariables,
      T
    >({
      name: 'AddLocationHazard',
      mutation: gql`
        mutation AddLocationHazardMutation($command: AddLocationHazard!) {
          addLocationHazard(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteLocationHazard<T = any>(
    command: DeleteLocationHazard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteLocationHazard',
      DeleteLocationHazardMutation,
      DeleteLocationHazardMutationVariables,
      T
    >({
      name: 'DeleteLocationHazard',
      mutation: gql`
        mutation DeleteLocationHazardMutation($command: DeleteLocationHazard!) {
          deleteLocationHazard(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateLocationHazard<T = any>(
    command: UpdateLocationHazard,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateLocationHazard',
      UpdateLocationHazardMutation,
      UpdateLocationHazardMutationVariables,
      T
    >({
      name: 'UpdateLocationHazard',
      mutation: gql`
        mutation UpdateLocationHazardMutation($command: UpdateLocationHazard!) {
          updateLocationHazard(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // MedicalControlContactLogEntries
  public addMedicalControlContactLogEntry<T = any>(
    command: AddMedicalControlContactLogEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddMedicalControlContactLogEntry',
      AddMedicalControlContactLogEntryMutation,
      AddMedicalControlContactLogEntryMutationVariables,
      T
    >({
      name: 'AddMedicalControlContactLogEntry',
      mutation: gql`
        mutation AddMedicalControlContactLogEntryMutation(
          $command: AddMedicalControlContactLogEntry!
        ) {
          addMedicalControlContactLogEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteMedicalControlContactLogEntry<T = any>(
    command: DeleteMedicalControlContactLogEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteMedicalControlContactLogEntry',
      DeleteMedicalControlContactLogEntryMutation,
      DeleteMedicalControlContactLogEntryMutationVariables,
      T
    >({
      name: 'DeleteMedicalControlContactLogEntry',
      mutation: gql`
        mutation DeleteMedicalControlContactLogEntryMutation(
          $command: DeleteMedicalControlContactLogEntry!
        ) {
          deleteMedicalControlContactLogEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateMedicalControlContactLogEntry<T = any>(
    command: UpdateMedicalControlContactLogEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateMedicalControlContactLogEntry',
      UpdateMedicalControlContactLogEntryMutation,
      UpdateMedicalControlContactLogEntryMutationVariables,
      T
    >({
      name: 'UpdateMedicalControlContactLogEntry',
      mutation: gql`
        mutation UpdateMedicalControlContactLogEntryMutation(
          $command: UpdateMedicalControlContactLogEntry!
        ) {
          updateMedicalControlContactLogEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // MessageStatusUpdates
  public addMessageStatusUpdate<T = any>(
    command: AddMessageStatusUpdate,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddMessageStatusUpdate',
      AddMessageStatusUpdateMutation,
      AddMessageStatusUpdateMutationVariables,
      T
    >({
      name: 'AddMessageStatusUpdate',
      mutation: gql`
        mutation AddMessageStatusUpdateMutation($command: AddMessageStatusUpdate!) {
          addMessageStatusUpdate(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NewAgencyLocationRequests
  public addNewAgencyLocationRequest<T = any>(
    command: AddNewAgencyLocationRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNewAgencyLocationRequest',
      AddNewAgencyLocationRequestMutation,
      AddNewAgencyLocationRequestMutationVariables,
      T
    >({
      name: 'AddNewAgencyLocationRequest',
      mutation: gql`
        mutation AddNewAgencyLocationRequestMutation($command: AddNewAgencyLocationRequest!) {
          addNewAgencyLocationRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNewAgencyLocationRequest<T = any>(
    command: DeleteNewAgencyLocationRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNewAgencyLocationRequest',
      DeleteNewAgencyLocationRequestMutation,
      DeleteNewAgencyLocationRequestMutationVariables,
      T
    >({
      name: 'DeleteNewAgencyLocationRequest',
      mutation: gql`
        mutation DeleteNewAgencyLocationRequestMutation($command: DeleteNewAgencyLocationRequest!) {
          deleteNewAgencyLocationRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNewAgencyLocationRequest<T = any>(
    command: UpdateNewAgencyLocationRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNewAgencyLocationRequest',
      UpdateNewAgencyLocationRequestMutation,
      UpdateNewAgencyLocationRequestMutationVariables,
      T
    >({
      name: 'UpdateNewAgencyLocationRequest',
      mutation: gql`
        mutation UpdateNewAgencyLocationRequestMutation($command: UpdateNewAgencyLocationRequest!) {
          updateNewAgencyLocationRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NextDueTypes
  public addNextDueType<T = any>(
    command: AddNextDueType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNextDueType',
      AddNextDueTypeMutation,
      AddNextDueTypeMutationVariables,
      T
    >({
      name: 'AddNextDueType',
      mutation: gql`
        mutation AddNextDueTypeMutation($command: AddNextDueType!) {
          addNextDueType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNextDueType<T = any>(
    command: DeleteNextDueType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNextDueType',
      DeleteNextDueTypeMutation,
      DeleteNextDueTypeMutationVariables,
      T
    >({
      name: 'DeleteNextDueType',
      mutation: gql`
        mutation DeleteNextDueTypeMutation($command: DeleteNextDueType!) {
          deleteNextDueType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNextDueType<T = any>(
    command: UpdateNextDueType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNextDueType',
      UpdateNextDueTypeMutation,
      UpdateNextDueTypeMutationVariables,
      T
    >({
      name: 'UpdateNextDueType',
      mutation: gql`
        mutation UpdateNextDueTypeMutation($command: UpdateNextDueType!) {
          updateNextDueType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NonReferralReasons
  public addNonReferralReason<T = any>(
    command: AddNonReferralReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNonReferralReason',
      AddNonReferralReasonMutation,
      AddNonReferralReasonMutationVariables,
      T
    >({
      name: 'AddNonReferralReason',
      mutation: gql`
        mutation AddNonReferralReasonMutation($command: AddNonReferralReason!) {
          addNonReferralReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNonReferralReason<T = any>(
    command: DeleteNonReferralReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNonReferralReason',
      DeleteNonReferralReasonMutation,
      DeleteNonReferralReasonMutationVariables,
      T
    >({
      name: 'DeleteNonReferralReason',
      mutation: gql`
        mutation DeleteNonReferralReasonMutation($command: DeleteNonReferralReason!) {
          deleteNonReferralReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNonReferralReason<T = any>(
    command: UpdateNonReferralReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNonReferralReason',
      UpdateNonReferralReasonMutation,
      UpdateNonReferralReasonMutationVariables,
      T
    >({
      name: 'UpdateNonReferralReason',
      mutation: gql`
        mutation UpdateNonReferralReasonMutation($command: UpdateNonReferralReason!) {
          updateNonReferralReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NotificationGroupMembers
  public addNotificationGroupMember<T = any>(
    command: AddNotificationGroupMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNotificationGroupMember',
      AddNotificationGroupMemberMutation,
      AddNotificationGroupMemberMutationVariables,
      T
    >({
      name: 'AddNotificationGroupMember',
      mutation: gql`
        mutation AddNotificationGroupMemberMutation($command: AddNotificationGroupMember!) {
          addNotificationGroupMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNotificationGroupMember<T = any>(
    command: DeleteNotificationGroupMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNotificationGroupMember',
      DeleteNotificationGroupMemberMutation,
      DeleteNotificationGroupMemberMutationVariables,
      T
    >({
      name: 'DeleteNotificationGroupMember',
      mutation: gql`
        mutation DeleteNotificationGroupMemberMutation($command: DeleteNotificationGroupMember!) {
          deleteNotificationGroupMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNotificationGroupMember<T = any>(
    command: UpdateNotificationGroupMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNotificationGroupMember',
      UpdateNotificationGroupMemberMutation,
      UpdateNotificationGroupMemberMutationVariables,
      T
    >({
      name: 'UpdateNotificationGroupMember',
      mutation: gql`
        mutation UpdateNotificationGroupMemberMutation($command: UpdateNotificationGroupMember!) {
          updateNotificationGroupMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NotificationGroups
  public addNotificationGroup<T = any>(
    command: AddNotificationGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNotificationGroup',
      AddNotificationGroupMutation,
      AddNotificationGroupMutationVariables,
      T
    >({
      name: 'AddNotificationGroup',
      mutation: gql`
        mutation AddNotificationGroupMutation($command: AddNotificationGroup!) {
          addNotificationGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNotificationGroup<T = any>(
    command: DeleteNotificationGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNotificationGroup',
      DeleteNotificationGroupMutation,
      DeleteNotificationGroupMutationVariables,
      T
    >({
      name: 'DeleteNotificationGroup',
      mutation: gql`
        mutation DeleteNotificationGroupMutation($command: DeleteNotificationGroup!) {
          deleteNotificationGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNotificationGroup<T = any>(
    command: UpdateNotificationGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNotificationGroup',
      UpdateNotificationGroupMutation,
      UpdateNotificationGroupMutationVariables,
      T
    >({
      name: 'UpdateNotificationGroup',
      mutation: gql`
        mutation UpdateNotificationGroupMutation($command: UpdateNotificationGroup!) {
          updateNotificationGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public upsertPersonNotificationGroups<T = any>(
    command: UpsertPersonNotificationGroups,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertPersonNotificationGroups',
      UpsertPersonNotificationGroupsMutation,
      UpsertPersonNotificationGroupsMutationVariables,
      T
    >({
      name: 'UpsertPersonNotificationGroups',
      mutation: gql`
        mutation UpsertPersonNotificationGroupsMutation($command: UpsertPersonNotificationGroups!) {
          upsertPersonNotificationGroups(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NotificationRecipients
  public addNotificationRecipient<T = any>(
    command: AddNotificationRecipient,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNotificationRecipient',
      AddNotificationRecipientMutation,
      AddNotificationRecipientMutationVariables,
      T
    >({
      name: 'AddNotificationRecipient',
      mutation: gql`
        mutation AddNotificationRecipientMutation($command: AddNotificationRecipient!) {
          addNotificationRecipient(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addNotificationRecipients<T = any>(
    command: AddNotificationRecipients,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNotificationRecipients',
      AddNotificationRecipientsMutation,
      AddNotificationRecipientsMutationVariables,
      T
    >({
      name: 'AddNotificationRecipients',
      mutation: gql`
        mutation AddNotificationRecipientsMutation($command: AddNotificationRecipients!) {
          addNotificationRecipients(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNotificationRecipient<T = any>(
    command: DeleteNotificationRecipient,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNotificationRecipient',
      DeleteNotificationRecipientMutation,
      DeleteNotificationRecipientMutationVariables,
      T
    >({
      name: 'DeleteNotificationRecipient',
      mutation: gql`
        mutation DeleteNotificationRecipientMutation($command: DeleteNotificationRecipient!) {
          deleteNotificationRecipient(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNotificationRecipients<T = any>(
    command: DeleteNotificationRecipients,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNotificationRecipients',
      DeleteNotificationRecipientsMutation,
      DeleteNotificationRecipientsMutationVariables,
      T
    >({
      name: 'DeleteNotificationRecipients',
      mutation: gql`
        mutation DeleteNotificationRecipientsMutation($command: DeleteNotificationRecipients!) {
          deleteNotificationRecipients(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNotificationRecipient<T = any>(
    command: UpdateNotificationRecipient,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNotificationRecipient',
      UpdateNotificationRecipientMutation,
      UpdateNotificationRecipientMutationVariables,
      T
    >({
      name: 'UpdateNotificationRecipient',
      mutation: gql`
        mutation UpdateNotificationRecipientMutation($command: UpdateNotificationRecipient!) {
          updateNotificationRecipient(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRecipientMessageStatus<T = any>(
    command: UpdateRecipientMessageStatus,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRecipientMessageStatus',
      UpdateRecipientMessageStatusMutation,
      UpdateRecipientMessageStatusMutationVariables,
      T
    >({
      name: 'UpdateRecipientMessageStatus',
      mutation: gql`
        mutation UpdateRecipientMessageStatusMutation($command: UpdateRecipientMessageStatus!) {
          updateRecipientMessageStatus(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Notifications
  public addNotification<T = any>(
    command: AddNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNotification',
      AddNotificationMutation,
      AddNotificationMutationVariables,
      T
    >({
      name: 'AddNotification',
      mutation: gql`
        mutation AddNotificationMutation($command: AddNotification!) {
          addNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNotification<T = any>(
    command: DeleteNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNotification',
      DeleteNotificationMutation,
      DeleteNotificationMutationVariables,
      T
    >({
      name: 'DeleteNotification',
      mutation: gql`
        mutation DeleteNotificationMutation($command: DeleteNotification!) {
          deleteNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public sendNotification<T = any>(
    command: SendNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SendNotification',
      SendNotificationMutation,
      SendNotificationMutationVariables,
      T
    >({
      name: 'SendNotification',
      mutation: gql`
        mutation SendNotificationMutation($command: SendNotification!) {
          sendNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNotification<T = any>(
    command: UpdateNotification,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNotification',
      UpdateNotificationMutation,
      UpdateNotificationMutationVariables,
      T
    >({
      name: 'UpdateNotification',
      mutation: gql`
        mutation UpdateNotificationMutation($command: UpdateNotification!) {
          updateNotification(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NotificationSubscriptions
  public addNotificationSubscription<T = any>(
    command: AddNotificationSubscription,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNotificationSubscription',
      AddNotificationSubscriptionMutation,
      AddNotificationSubscriptionMutationVariables,
      T
    >({
      name: 'AddNotificationSubscription',
      mutation: gql`
        mutation AddNotificationSubscriptionMutation($command: AddNotificationSubscription!) {
          addNotificationSubscription(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNotificationSubscription<T = any>(
    command: DeleteNotificationSubscription,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNotificationSubscription',
      DeleteNotificationSubscriptionMutation,
      DeleteNotificationSubscriptionMutationVariables,
      T
    >({
      name: 'DeleteNotificationSubscription',
      mutation: gql`
        mutation DeleteNotificationSubscriptionMutation($command: DeleteNotificationSubscription!) {
          deleteNotificationSubscription(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNotificationSubscription<T = any>(
    command: UpdateNotificationSubscription,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNotificationSubscription',
      UpdateNotificationSubscriptionMutation,
      UpdateNotificationSubscriptionMutationVariables,
      T
    >({
      name: 'UpdateNotificationSubscription',
      mutation: gql`
        mutation UpdateNotificationSubscriptionMutation($command: UpdateNotificationSubscription!) {
          updateNotificationSubscription(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // NotificationTemplates
  public addNotificationTemplate<T = any>(
    command: AddNotificationTemplate,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddNotificationTemplate',
      AddNotificationTemplateMutation,
      AddNotificationTemplateMutationVariables,
      T
    >({
      name: 'AddNotificationTemplate',
      mutation: gql`
        mutation AddNotificationTemplateMutation($command: AddNotificationTemplate!) {
          addNotificationTemplate(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public copyNotificationTemplate<T = any>(
    command: CopyNotificationTemplate,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CopyNotificationTemplate',
      CopyNotificationTemplateMutation,
      CopyNotificationTemplateMutationVariables,
      T
    >({
      name: 'CopyNotificationTemplate',
      mutation: gql`
        mutation CopyNotificationTemplateMutation($command: CopyNotificationTemplate!) {
          copyNotificationTemplate(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteNotificationTemplate<T = any>(
    command: DeleteNotificationTemplate,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteNotificationTemplate',
      DeleteNotificationTemplateMutation,
      DeleteNotificationTemplateMutationVariables,
      T
    >({
      name: 'DeleteNotificationTemplate',
      mutation: gql`
        mutation DeleteNotificationTemplateMutation($command: DeleteNotificationTemplate!) {
          deleteNotificationTemplate(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateNotificationTemplate<T = any>(
    command: UpdateNotificationTemplate,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateNotificationTemplate',
      UpdateNotificationTemplateMutation,
      UpdateNotificationTemplateMutationVariables,
      T
    >({
      name: 'UpdateNotificationTemplate',
      mutation: gql`
        mutation UpdateNotificationTemplateMutation($command: UpdateNotificationTemplate!) {
          updateNotificationTemplate(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OemActivities
  public addOemActivity<T = any>(
    command: AddOemActivity,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOemActivity',
      AddOemActivityMutation,
      AddOemActivityMutationVariables,
      T
    >({
      name: 'AddOemActivity',
      mutation: gql`
        mutation AddOemActivityMutation($command: AddOemActivity!) {
          addOemActivity(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOemActivity<T = any>(
    command: DeleteOemActivity,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOemActivity',
      DeleteOemActivityMutation,
      DeleteOemActivityMutationVariables,
      T
    >({
      name: 'DeleteOemActivity',
      mutation: gql`
        mutation DeleteOemActivityMutation($command: DeleteOemActivity!) {
          deleteOemActivity(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOemActivity<T = any>(
    command: UpdateOemActivity,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOemActivity',
      UpdateOemActivityMutation,
      UpdateOemActivityMutationVariables,
      T
    >({
      name: 'UpdateOemActivity',
      mutation: gql`
        mutation UpdateOemActivityMutation($command: UpdateOemActivity!) {
          updateOemActivity(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OemAssets
  public addOemAsset<T = any>(
    command: AddOemAsset,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOemAsset',
      AddOemAssetMutation,
      AddOemAssetMutationVariables,
      T
    >({
      name: 'AddOemAsset',
      mutation: gql`
        mutation AddOemAssetMutation($command: AddOemAsset!) {
          addOemAsset(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOemAsset<T = any>(
    command: DeleteOemAsset,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOemAsset',
      DeleteOemAssetMutation,
      DeleteOemAssetMutationVariables,
      T
    >({
      name: 'DeleteOemAsset',
      mutation: gql`
        mutation DeleteOemAssetMutation($command: DeleteOemAsset!) {
          deleteOemAsset(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOemAsset<T = any>(
    command: UpdateOemAsset,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOemAsset',
      UpdateOemAssetMutation,
      UpdateOemAssetMutationVariables,
      T
    >({
      name: 'UpdateOemAsset',
      mutation: gql`
        mutation UpdateOemAssetMutation($command: UpdateOemAsset!) {
          updateOemAsset(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OemPlanChangeRequests
  public addOemPlanChangeRequest<T = any>(
    command: AddOemPlanChangeRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOemPlanChangeRequest',
      AddOemPlanChangeRequestMutation,
      AddOemPlanChangeRequestMutationVariables,
      T
    >({
      name: 'AddOemPlanChangeRequest',
      mutation: gql`
        mutation AddOemPlanChangeRequestMutation($command: AddOemPlanChangeRequest!) {
          addOemPlanChangeRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOemPlanChangeRequest<T = any>(
    command: DeleteOemPlanChangeRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOemPlanChangeRequest',
      DeleteOemPlanChangeRequestMutation,
      DeleteOemPlanChangeRequestMutationVariables,
      T
    >({
      name: 'DeleteOemPlanChangeRequest',
      mutation: gql`
        mutation DeleteOemPlanChangeRequestMutation($command: DeleteOemPlanChangeRequest!) {
          deleteOemPlanChangeRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOemPlanChangeRequest<T = any>(
    command: UpdateOemPlanChangeRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOemPlanChangeRequest',
      UpdateOemPlanChangeRequestMutation,
      UpdateOemPlanChangeRequestMutationVariables,
      T
    >({
      name: 'UpdateOemPlanChangeRequest',
      mutation: gql`
        mutation UpdateOemPlanChangeRequestMutation($command: UpdateOemPlanChangeRequest!) {
          updateOemPlanChangeRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OemPlans
  public addOemPlan<T = any>(
    command: AddOemPlan,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddOemPlan', AddOemPlanMutation, AddOemPlanMutationVariables, T>(
      {
        name: 'AddOemPlan',
        mutation: gql`
          mutation AddOemPlanMutation($command: AddOemPlan!) {
            addOemPlan(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public deleteOemPlan<T = any>(
    command: DeleteOemPlan,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOemPlan',
      DeleteOemPlanMutation,
      DeleteOemPlanMutationVariables,
      T
    >({
      name: 'DeleteOemPlan',
      mutation: gql`
        mutation DeleteOemPlanMutation($command: DeleteOemPlan!) {
          deleteOemPlan(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOemPlan<T = any>(
    command: UpdateOemPlan,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOemPlan',
      UpdateOemPlanMutation,
      UpdateOemPlanMutationVariables,
      T
    >({
      name: 'UpdateOemPlan',
      mutation: gql`
        mutation UpdateOemPlanMutation($command: UpdateOemPlan!) {
          updateOemPlan(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OfferAlgorithms
  public addOfferAlgorithm<T = any>(
    command: AddOfferAlgorithm,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOfferAlgorithm',
      AddOfferAlgorithmMutation,
      AddOfferAlgorithmMutationVariables,
      T
    >({
      name: 'AddOfferAlgorithm',
      mutation: gql`
        mutation AddOfferAlgorithmMutation($command: AddOfferAlgorithm!) {
          addOfferAlgorithm(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public copyOfferAlgorithm<T = any>(
    command: CopyOfferAlgorithm,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CopyOfferAlgorithm',
      CopyOfferAlgorithmMutation,
      CopyOfferAlgorithmMutationVariables,
      T
    >({
      name: 'CopyOfferAlgorithm',
      mutation: gql`
        mutation CopyOfferAlgorithmMutation($command: CopyOfferAlgorithm!) {
          copyOfferAlgorithm(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOfferAlgorithm<T = any>(
    command: DeleteOfferAlgorithm,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOfferAlgorithm',
      DeleteOfferAlgorithmMutation,
      DeleteOfferAlgorithmMutationVariables,
      T
    >({
      name: 'DeleteOfferAlgorithm',
      mutation: gql`
        mutation DeleteOfferAlgorithmMutation($command: DeleteOfferAlgorithm!) {
          deleteOfferAlgorithm(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOfferAlgorithm<T = any>(
    command: UpdateOfferAlgorithm,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOfferAlgorithm',
      UpdateOfferAlgorithmMutation,
      UpdateOfferAlgorithmMutationVariables,
      T
    >({
      name: 'UpdateOfferAlgorithm',
      mutation: gql`
        mutation UpdateOfferAlgorithmMutation($command: UpdateOfferAlgorithm!) {
          updateOfferAlgorithm(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Operations
  public activateUnit<T = any>(
    command: ActivateUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ActivateUnit',
      ActivateUnitMutation,
      ActivateUnitMutationVariables,
      T
    >({
      name: 'ActivateUnit',
      mutation: gql`
        mutation ActivateUnitMutation($command: ActivateUnit!) {
          activateUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addOperation<T = any>(
    command: AddOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOperation',
      AddOperationMutation,
      AddOperationMutationVariables,
      T
    >({
      name: 'AddOperation',
      mutation: gql`
        mutation AddOperationMutation($command: AddOperation!) {
          addOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public arriveVehicle<T = any>(
    command: ArriveVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ArriveVehicle',
      ArriveVehicleMutation,
      ArriveVehicleMutationVariables,
      T
    >({
      name: 'ArriveVehicle',
      mutation: gql`
        mutation ArriveVehicleMutation($command: ArriveVehicle!) {
          arriveVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cancelOperation<T = any>(
    command: CancelOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CancelOperation',
      CancelOperationMutation,
      CancelOperationMutationVariables,
      T
    >({
      name: 'CancelOperation',
      mutation: gql`
        mutation CancelOperationMutation($command: CancelOperation!) {
          cancelOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public changeVehicle<T = any>(
    command: ChangeVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ChangeVehicle',
      ChangeVehicleMutation,
      ChangeVehicleMutationVariables,
      T
    >({
      name: 'ChangeVehicle',
      mutation: gql`
        mutation ChangeVehicleMutation($command: ChangeVehicle!) {
          changeVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createGroundRun<T = any>(
    command: CreateGroundRun,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreateGroundRun',
      CreateGroundRunMutation,
      CreateGroundRunMutationVariables,
      T
    >({
      name: 'CreateGroundRun',
      mutation: gql`
        mutation CreateGroundRunMutation($command: CreateGroundRun!) {
          createGroundRun(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createMaintenanceOperation<T = any>(
    command: CreateMaintenanceOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreateMaintenanceOperation',
      CreateMaintenanceOperationMutation,
      CreateMaintenanceOperationMutationVariables,
      T
    >({
      name: 'CreateMaintenanceOperation',
      mutation: gql`
        mutation CreateMaintenanceOperationMutation($command: CreateMaintenanceOperation!) {
          createMaintenanceOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createTrainingOperation<T = any>(
    command: CreateTrainingOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreateTrainingOperation',
      CreateTrainingOperationMutation,
      CreateTrainingOperationMutationVariables,
      T
    >({
      name: 'CreateTrainingOperation',
      mutation: gql`
        mutation CreateTrainingOperationMutation($command: CreateTrainingOperation!) {
          createTrainingOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public declineOrAbortOperation<T = any>(
    command: DeclineOrAbortOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeclineOrAbortOperation',
      DeclineOrAbortOperationMutation,
      DeclineOrAbortOperationMutationVariables,
      T
    >({
      name: 'DeclineOrAbortOperation',
      mutation: gql`
        mutation DeclineOrAbortOperationMutation($command: DeclineOrAbortOperation!) {
          declineOrAbortOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOperation<T = any>(
    command: DeleteOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOperation',
      DeleteOperationMutation,
      DeleteOperationMutationVariables,
      T
    >({
      name: 'DeleteOperation',
      mutation: gql`
        mutation DeleteOperationMutation($command: DeleteOperation!) {
          deleteOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public departVehicle<T = any>(
    command: DepartVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DepartVehicle',
      DepartVehicleMutation,
      DepartVehicleMutationVariables,
      T
    >({
      name: 'DepartVehicle',
      mutation: gql`
        mutation DepartVehicleMutation($command: DepartVehicle!) {
          departVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public placeUnitOnStandby<T = any>(
    command: PlaceUnitOnStandby,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'PlaceUnitOnStandby',
      PlaceUnitOnStandbyMutation,
      PlaceUnitOnStandbyMutationVariables,
      T
    >({
      name: 'PlaceUnitOnStandby',
      mutation: gql`
        mutation PlaceUnitOnStandbyMutation($command: PlaceUnitOnStandby!) {
          placeUnitOnStandby(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public repositionUnit<T = any>(
    command: RepositionUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RepositionUnit',
      RepositionUnitMutation,
      RepositionUnitMutationVariables,
      T
    >({
      name: 'RepositionUnit',
      mutation: gql`
        mutation RepositionUnitMutation($command: RepositionUnit!) {
          repositionUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public undoAbortOperation<T = any>(
    command: UndoAbortOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UndoAbortOperation',
      UndoAbortOperationMutation,
      UndoAbortOperationMutationVariables,
      T
    >({
      name: 'UndoAbortOperation',
      mutation: gql`
        mutation UndoAbortOperationMutation($command: UndoAbortOperation!) {
          undoAbortOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public undoArriveVehicle<T = any>(
    command: UndoArriveVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UndoArriveVehicle',
      UndoArriveVehicleMutation,
      UndoArriveVehicleMutationVariables,
      T
    >({
      name: 'UndoArriveVehicle',
      mutation: gql`
        mutation UndoArriveVehicleMutation($command: UndoArriveVehicle!) {
          undoArriveVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public undoDepartVehicle<T = any>(
    command: UndoDepartVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UndoDepartVehicle',
      UndoDepartVehicleMutation,
      UndoDepartVehicleMutationVariables,
      T
    >({
      name: 'UndoDepartVehicle',
      mutation: gql`
        mutation UndoDepartVehicleMutation($command: UndoDepartVehicle!) {
          undoDepartVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOperation<T = any>(
    command: UpdateOperation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOperation',
      UpdateOperationMutation,
      UpdateOperationMutationVariables,
      T
    >({
      name: 'UpdateOperation',
      mutation: gql`
        mutation UpdateOperationMutation($command: UpdateOperation!) {
          updateOperation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOperationContactInfo<T = any>(
    command: UpdateOperationContactInfo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOperationContactInfo',
      UpdateOperationContactInfoMutation,
      UpdateOperationContactInfoMutationVariables,
      T
    >({
      name: 'UpdateOperationContactInfo',
      mutation: gql`
        mutation UpdateOperationContactInfoMutation($command: UpdateOperationContactInfo!) {
          updateOperationContactInfo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRiskAnalysis<T = any>(
    command: UpdateRiskAnalysis,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRiskAnalysis',
      UpdateRiskAnalysisMutation,
      UpdateRiskAnalysisMutationVariables,
      T
    >({
      name: 'UpdateRiskAnalysis',
      mutation: gql`
        mutation UpdateRiskAnalysisMutation($command: UpdateRiskAnalysis!) {
          updateRiskAnalysis(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OpsApplicationStarts
  // OutOfServiceEventNotes
  public addOutOfServiceEventNote<T = any>(
    command: AddOutOfServiceEventNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOutOfServiceEventNote',
      AddOutOfServiceEventNoteMutation,
      AddOutOfServiceEventNoteMutationVariables,
      T
    >({
      name: 'AddOutOfServiceEventNote',
      mutation: gql`
        mutation AddOutOfServiceEventNoteMutation($command: AddOutOfServiceEventNote!) {
          addOutOfServiceEventNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOutOfServiceEventNote<T = any>(
    command: DeleteOutOfServiceEventNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOutOfServiceEventNote',
      DeleteOutOfServiceEventNoteMutation,
      DeleteOutOfServiceEventNoteMutationVariables,
      T
    >({
      name: 'DeleteOutOfServiceEventNote',
      mutation: gql`
        mutation DeleteOutOfServiceEventNoteMutation($command: DeleteOutOfServiceEventNote!) {
          deleteOutOfServiceEventNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOutOfServiceEventNote<T = any>(
    command: UpdateOutOfServiceEventNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOutOfServiceEventNote',
      UpdateOutOfServiceEventNoteMutation,
      UpdateOutOfServiceEventNoteMutationVariables,
      T
    >({
      name: 'UpdateOutOfServiceEventNote',
      mutation: gql`
        mutation UpdateOutOfServiceEventNoteMutation($command: UpdateOutOfServiceEventNote!) {
          updateOutOfServiceEventNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OutOfServiceEvents
  public acknowledgeOutOfServiceEvent<T = any>(
    command: AcknowledgeOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcknowledgeOutOfServiceEvent',
      AcknowledgeOutOfServiceEventMutation,
      AcknowledgeOutOfServiceEventMutationVariables,
      T
    >({
      name: 'AcknowledgeOutOfServiceEvent',
      mutation: gql`
        mutation AcknowledgeOutOfServiceEventMutation($command: AcknowledgeOutOfServiceEvent!) {
          acknowledgeOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addCrewOutOfServiceEvent<T = any>(
    command: AddCrewOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCrewOutOfServiceEvent',
      AddCrewOutOfServiceEventMutation,
      AddCrewOutOfServiceEventMutationVariables,
      T
    >({
      name: 'AddCrewOutOfServiceEvent',
      mutation: gql`
        mutation AddCrewOutOfServiceEventMutation($command: AddCrewOutOfServiceEvent!) {
          addCrewOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addOutOfServiceEvent<T = any>(
    command: AddOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOutOfServiceEvent',
      AddOutOfServiceEventMutation,
      AddOutOfServiceEventMutationVariables,
      T
    >({
      name: 'AddOutOfServiceEvent',
      mutation: gql`
        mutation AddOutOfServiceEventMutation($command: AddOutOfServiceEvent!) {
          addOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addUnitOutOfServiceEvent<T = any>(
    command: AddUnitOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddUnitOutOfServiceEvent',
      AddUnitOutOfServiceEventMutation,
      AddUnitOutOfServiceEventMutationVariables,
      T
    >({
      name: 'AddUnitOutOfServiceEvent',
      mutation: gql`
        mutation AddUnitOutOfServiceEventMutation($command: AddUnitOutOfServiceEvent!) {
          addUnitOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addVehicleOutOfServiceEvent<T = any>(
    command: AddVehicleOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleOutOfServiceEvent',
      AddVehicleOutOfServiceEventMutation,
      AddVehicleOutOfServiceEventMutationVariables,
      T
    >({
      name: 'AddVehicleOutOfServiceEvent',
      mutation: gql`
        mutation AddVehicleOutOfServiceEventMutation($command: AddVehicleOutOfServiceEvent!) {
          addVehicleOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public beginOutOfServiceEvent<T = any>(
    command: BeginOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'BeginOutOfServiceEvent',
      BeginOutOfServiceEventMutation,
      BeginOutOfServiceEventMutationVariables,
      T
    >({
      name: 'BeginOutOfServiceEvent',
      mutation: gql`
        mutation BeginOutOfServiceEventMutation($command: BeginOutOfServiceEvent!) {
          beginOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createTicketFromOutOfServiceEvent<T = any>(
    command: CreateTicketFromOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreateTicketFromOutOfServiceEvent',
      CreateTicketFromOutOfServiceEventMutation,
      CreateTicketFromOutOfServiceEventMutationVariables,
      T
    >({
      name: 'CreateTicketFromOutOfServiceEvent',
      mutation: gql`
        mutation CreateTicketFromOutOfServiceEventMutation(
          $command: CreateTicketFromOutOfServiceEvent!
        ) {
          createTicketFromOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOutOfServiceEvent<T = any>(
    command: DeleteOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOutOfServiceEvent',
      DeleteOutOfServiceEventMutation,
      DeleteOutOfServiceEventMutationVariables,
      T
    >({
      name: 'DeleteOutOfServiceEvent',
      mutation: gql`
        mutation DeleteOutOfServiceEventMutation($command: DeleteOutOfServiceEvent!) {
          deleteOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public endCrewMemberOutOfServiceEvent<T = any>(
    command: EndCrewMemberOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'EndCrewMemberOutOfServiceEvent',
      EndCrewMemberOutOfServiceEventMutation,
      EndCrewMemberOutOfServiceEventMutationVariables,
      T
    >({
      name: 'EndCrewMemberOutOfServiceEvent',
      mutation: gql`
        mutation EndCrewMemberOutOfServiceEventMutation($command: EndCrewMemberOutOfServiceEvent!) {
          endCrewMemberOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public endOutOfServiceEvent<T = any>(
    command: EndOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'EndOutOfServiceEvent',
      EndOutOfServiceEventMutation,
      EndOutOfServiceEventMutationVariables,
      T
    >({
      name: 'EndOutOfServiceEvent',
      mutation: gql`
        mutation EndOutOfServiceEventMutation($command: EndOutOfServiceEvent!) {
          endOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public linkOutOfServiceEvent<T = any>(
    command: LinkOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'LinkOutOfServiceEvent',
      LinkOutOfServiceEventMutation,
      LinkOutOfServiceEventMutationVariables,
      T
    >({
      name: 'LinkOutOfServiceEvent',
      mutation: gql`
        mutation LinkOutOfServiceEventMutation($command: LinkOutOfServiceEvent!) {
          linkOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOutOfServiceEvent<T = any>(
    command: UpdateOutOfServiceEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOutOfServiceEvent',
      UpdateOutOfServiceEventMutation,
      UpdateOutOfServiceEventMutationVariables,
      T
    >({
      name: 'UpdateOutOfServiceEvent',
      mutation: gql`
        mutation UpdateOutOfServiceEventMutation($command: UpdateOutOfServiceEvent!) {
          updateOutOfServiceEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OutOfServiceReasons
  public addOutOfServiceReason<T = any>(
    command: AddOutOfServiceReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOutOfServiceReason',
      AddOutOfServiceReasonMutation,
      AddOutOfServiceReasonMutationVariables,
      T
    >({
      name: 'AddOutOfServiceReason',
      mutation: gql`
        mutation AddOutOfServiceReasonMutation($command: AddOutOfServiceReason!) {
          addOutOfServiceReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOutOfServiceReason<T = any>(
    command: DeleteOutOfServiceReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOutOfServiceReason',
      DeleteOutOfServiceReasonMutation,
      DeleteOutOfServiceReasonMutationVariables,
      T
    >({
      name: 'DeleteOutOfServiceReason',
      mutation: gql`
        mutation DeleteOutOfServiceReasonMutation($command: DeleteOutOfServiceReason!) {
          deleteOutOfServiceReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOutOfServiceReason<T = any>(
    command: UpdateOutOfServiceReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOutOfServiceReason',
      UpdateOutOfServiceReasonMutation,
      UpdateOutOfServiceReasonMutationVariables,
      T
    >({
      name: 'UpdateOutOfServiceReason',
      mutation: gql`
        mutation UpdateOutOfServiceReasonMutation($command: UpdateOutOfServiceReason!) {
          updateOutOfServiceReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OutOfServiceSecondaryReasons
  public addOutOfServiceSecondaryReason<T = any>(
    command: AddOutOfServiceSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOutOfServiceSecondaryReason',
      AddOutOfServiceSecondaryReasonMutation,
      AddOutOfServiceSecondaryReasonMutationVariables,
      T
    >({
      name: 'AddOutOfServiceSecondaryReason',
      mutation: gql`
        mutation AddOutOfServiceSecondaryReasonMutation($command: AddOutOfServiceSecondaryReason!) {
          addOutOfServiceSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOutOfServiceSecondaryReason<T = any>(
    command: DeleteOutOfServiceSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOutOfServiceSecondaryReason',
      DeleteOutOfServiceSecondaryReasonMutation,
      DeleteOutOfServiceSecondaryReasonMutationVariables,
      T
    >({
      name: 'DeleteOutOfServiceSecondaryReason',
      mutation: gql`
        mutation DeleteOutOfServiceSecondaryReasonMutation(
          $command: DeleteOutOfServiceSecondaryReason!
        ) {
          deleteOutOfServiceSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOutOfServiceSecondaryReason<T = any>(
    command: UpdateOutOfServiceSecondaryReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOutOfServiceSecondaryReason',
      UpdateOutOfServiceSecondaryReasonMutation,
      UpdateOutOfServiceSecondaryReasonMutationVariables,
      T
    >({
      name: 'UpdateOutOfServiceSecondaryReason',
      mutation: gql`
        mutation UpdateOutOfServiceSecondaryReasonMutation(
          $command: UpdateOutOfServiceSecondaryReason!
        ) {
          updateOutOfServiceSecondaryReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OutOfServiceTickets
  public acceptOutOfServiceTicket<T = any>(
    command: AcceptOutOfServiceTicket,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcceptOutOfServiceTicket',
      AcceptOutOfServiceTicketMutation,
      AcceptOutOfServiceTicketMutationVariables,
      T
    >({
      name: 'AcceptOutOfServiceTicket',
      mutation: gql`
        mutation AcceptOutOfServiceTicketMutation($command: AcceptOutOfServiceTicket!) {
          acceptOutOfServiceTicket(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public acknowledgeOutOfServiceTicket<T = any>(
    command: AcknowledgeOutOfServiceTicket,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcknowledgeOutOfServiceTicket',
      AcknowledgeOutOfServiceTicketMutation,
      AcknowledgeOutOfServiceTicketMutationVariables,
      T
    >({
      name: 'AcknowledgeOutOfServiceTicket',
      mutation: gql`
        mutation AcknowledgeOutOfServiceTicketMutation($command: AcknowledgeOutOfServiceTicket!) {
          acknowledgeOutOfServiceTicket(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public closeTicketsForOOSEvent<T = any>(
    command: CloseTicketsForOOSEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CloseTicketsForOOSEvent',
      CloseTicketsForOOSEventMutation,
      CloseTicketsForOOSEventMutationVariables,
      T
    >({
      name: 'CloseTicketsForOOSEvent',
      mutation: gql`
        mutation CloseTicketsForOOSEventMutation($command: CloseTicketsForOOSEvent!) {
          closeTicketsForOOSEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOutOfServiceTicket<T = any>(
    command: DeleteOutOfServiceTicket,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOutOfServiceTicket',
      DeleteOutOfServiceTicketMutation,
      DeleteOutOfServiceTicketMutationVariables,
      T
    >({
      name: 'DeleteOutOfServiceTicket',
      mutation: gql`
        mutation DeleteOutOfServiceTicketMutation($command: DeleteOutOfServiceTicket!) {
          deleteOutOfServiceTicket(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public reviewSubmittedOutOfServiceTicket<T = any>(
    command: ReviewSubmittedOutOfServiceTicket,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReviewSubmittedOutOfServiceTicket',
      ReviewSubmittedOutOfServiceTicketMutation,
      ReviewSubmittedOutOfServiceTicketMutationVariables,
      T
    >({
      name: 'ReviewSubmittedOutOfServiceTicket',
      mutation: gql`
        mutation ReviewSubmittedOutOfServiceTicketMutation(
          $command: ReviewSubmittedOutOfServiceTicket!
        ) {
          reviewSubmittedOutOfServiceTicket(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public submitOutOfServiceTicket<T = any>(
    command: SubmitOutOfServiceTicket,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SubmitOutOfServiceTicket',
      SubmitOutOfServiceTicketMutation,
      SubmitOutOfServiceTicketMutationVariables,
      T
    >({
      name: 'SubmitOutOfServiceTicket',
      mutation: gql`
        mutation SubmitOutOfServiceTicketMutation($command: SubmitOutOfServiceTicket!) {
          submitOutOfServiceTicket(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // PaipEvents
  public addPaipEvent<T = any>(
    command: AddPaipEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPaipEvent',
      AddPaipEventMutation,
      AddPaipEventMutationVariables,
      T
    >({
      name: 'AddPaipEvent',
      mutation: gql`
        mutation AddPaipEventMutation($command: AddPaipEvent!) {
          addPaipEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deletePaipEvent<T = any>(
    command: DeletePaipEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeletePaipEvent',
      DeletePaipEventMutation,
      DeletePaipEventMutationVariables,
      T
    >({
      name: 'DeletePaipEvent',
      mutation: gql`
        mutation DeletePaipEventMutation($command: DeletePaipEvent!) {
          deletePaipEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public endPaipEvent<T = any>(
    command: EndPaipEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'EndPaipEvent',
      EndPaipEventMutation,
      EndPaipEventMutationVariables,
      T
    >({
      name: 'EndPaipEvent',
      mutation: gql`
        mutation EndPaipEventMutation($command: EndPaipEvent!) {
          endPaipEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePaipEvent<T = any>(
    command: UpdatePaipEvent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePaipEvent',
      UpdatePaipEventMutation,
      UpdatePaipEventMutationVariables,
      T
    >({
      name: 'UpdatePaipEvent',
      mutation: gql`
        mutation UpdatePaipEventMutation($command: UpdatePaipEvent!) {
          updatePaipEvent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // PaipReasons
  public addPaipReason<T = any>(
    command: AddPaipReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPaipReason',
      AddPaipReasonMutation,
      AddPaipReasonMutationVariables,
      T
    >({
      name: 'AddPaipReason',
      mutation: gql`
        mutation AddPaipReasonMutation($command: AddPaipReason!) {
          addPaipReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deletePaipReason<T = any>(
    command: DeletePaipReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeletePaipReason',
      DeletePaipReasonMutation,
      DeletePaipReasonMutationVariables,
      T
    >({
      name: 'DeletePaipReason',
      mutation: gql`
        mutation DeletePaipReasonMutation($command: DeletePaipReason!) {
          deletePaipReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePaipReason<T = any>(
    command: UpdatePaipReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePaipReason',
      UpdatePaipReasonMutation,
      UpdatePaipReasonMutationVariables,
      T
    >({
      name: 'UpdatePaipReason',
      mutation: gql`
        mutation UpdatePaipReasonMutation($command: UpdatePaipReason!) {
          updatePaipReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // PassdownLogAcknowledgements
  // PassdownLogArchivedLogs
  public archivePassdownLog<T = any>(
    command: ArchivePassdownLog,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ArchivePassdownLog',
      ArchivePassdownLogMutation,
      ArchivePassdownLogMutationVariables,
      T
    >({
      name: 'ArchivePassdownLog',
      mutation: gql`
        mutation ArchivePassdownLogMutation($command: ArchivePassdownLog!) {
          archivePassdownLog(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // PassdownLogs
  public acknowledgePassdownLog<T = any>(
    command: AcknowledgePassdownLog,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcknowledgePassdownLog',
      AcknowledgePassdownLogMutation,
      AcknowledgePassdownLogMutationVariables,
      T
    >({
      name: 'AcknowledgePassdownLog',
      mutation: gql`
        mutation AcknowledgePassdownLogMutation($command: AcknowledgePassdownLog!) {
          acknowledgePassdownLog(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addPassdownLog<T = any>(
    command: AddPassdownLog,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPassdownLog',
      AddPassdownLogMutation,
      AddPassdownLogMutationVariables,
      T
    >({
      name: 'AddPassdownLog',
      mutation: gql`
        mutation AddPassdownLogMutation($command: AddPassdownLog!) {
          addPassdownLog(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deletePassdownLog<T = any>(
    command: DeletePassdownLog,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeletePassdownLog',
      DeletePassdownLogMutation,
      DeletePassdownLogMutationVariables,
      T
    >({
      name: 'DeletePassdownLog',
      mutation: gql`
        mutation DeletePassdownLogMutation($command: DeletePassdownLog!) {
          deletePassdownLog(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePassdownLog<T = any>(
    command: UpdatePassdownLog,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePassdownLog',
      UpdatePassdownLogMutation,
      UpdatePassdownLogMutationVariables,
      T
    >({
      name: 'UpdatePassdownLog',
      mutation: gql`
        mutation UpdatePassdownLogMutation($command: UpdatePassdownLog!) {
          updatePassdownLog(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Patients
  // PositionReportAlerts
  public addPositionReportAlert<T = any>(
    command: AddPositionReportAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPositionReportAlert',
      AddPositionReportAlertMutation,
      AddPositionReportAlertMutationVariables,
      T
    >({
      name: 'AddPositionReportAlert',
      mutation: gql`
        mutation AddPositionReportAlertMutation($command: AddPositionReportAlert!) {
          addPositionReportAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deletePositionReportAlert<T = any>(
    command: DeletePositionReportAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeletePositionReportAlert',
      DeletePositionReportAlertMutation,
      DeletePositionReportAlertMutationVariables,
      T
    >({
      name: 'DeletePositionReportAlert',
      mutation: gql`
        mutation DeletePositionReportAlertMutation($command: DeletePositionReportAlert!) {
          deletePositionReportAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePositionReportAlert<T = any>(
    command: UpdatePositionReportAlert,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePositionReportAlert',
      UpdatePositionReportAlertMutation,
      UpdatePositionReportAlertMutationVariables,
      T
    >({
      name: 'UpdatePositionReportAlert',
      mutation: gql`
        mutation UpdatePositionReportAlertMutation($command: UpdatePositionReportAlert!) {
          updatePositionReportAlert(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // PositionReports
  public addPositionReport<T = any>(
    command: AddPositionReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPositionReport',
      AddPositionReportMutation,
      AddPositionReportMutationVariables,
      T
    >({
      name: 'AddPositionReport',
      mutation: gql`
        mutation AddPositionReportMutation($command: AddPositionReport!) {
          addPositionReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public confirmPositionReport<T = any>(
    command: ConfirmPositionReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ConfirmPositionReport',
      ConfirmPositionReportMutation,
      ConfirmPositionReportMutationVariables,
      T
    >({
      name: 'ConfirmPositionReport',
      mutation: gql`
        mutation ConfirmPositionReportMutation($command: ConfirmPositionReport!) {
          confirmPositionReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deletePositionReport<T = any>(
    command: DeletePositionReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeletePositionReport',
      DeletePositionReportMutation,
      DeletePositionReportMutationVariables,
      T
    >({
      name: 'DeletePositionReport',
      mutation: gql`
        mutation DeletePositionReportMutation($command: DeletePositionReport!) {
          deletePositionReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePositionReport<T = any>(
    command: UpdatePositionReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePositionReport',
      UpdatePositionReportMutation,
      UpdatePositionReportMutationVariables,
      T
    >({
      name: 'UpdatePositionReport',
      mutation: gql`
        mutation UpdatePositionReportMutation($command: UpdatePositionReport!) {
          updatePositionReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // QuestionChoices
  public upsertQuestionChoice<T = any>(
    command: UpsertQuestionChoice,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertQuestionChoice',
      UpsertQuestionChoiceMutation,
      UpsertQuestionChoiceMutationVariables,
      T
    >({
      name: 'UpsertQuestionChoice',
      mutation: gql`
        mutation UpsertQuestionChoiceMutation($command: UpsertQuestionChoice!) {
          upsertQuestionChoice(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // QuestionnaireQuestionResponseNotes
  public addQuestionnaireQuestionResponseNote<T = any>(
    command: AddQuestionnaireQuestionResponseNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddQuestionnaireQuestionResponseNote',
      AddQuestionnaireQuestionResponseNoteMutation,
      AddQuestionnaireQuestionResponseNoteMutationVariables,
      T
    >({
      name: 'AddQuestionnaireQuestionResponseNote',
      mutation: gql`
        mutation AddQuestionnaireQuestionResponseNoteMutation(
          $command: AddQuestionnaireQuestionResponseNote!
        ) {
          addQuestionnaireQuestionResponseNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteQuestionnaireQuestionResponseNote<T = any>(
    command: DeleteQuestionnaireQuestionResponseNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteQuestionnaireQuestionResponseNote',
      DeleteQuestionnaireQuestionResponseNoteMutation,
      DeleteQuestionnaireQuestionResponseNoteMutationVariables,
      T
    >({
      name: 'DeleteQuestionnaireQuestionResponseNote',
      mutation: gql`
        mutation DeleteQuestionnaireQuestionResponseNoteMutation(
          $command: DeleteQuestionnaireQuestionResponseNote!
        ) {
          deleteQuestionnaireQuestionResponseNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateQuestionnaireQuestionResponseNote<T = any>(
    command: UpdateQuestionnaireQuestionResponseNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateQuestionnaireQuestionResponseNote',
      UpdateQuestionnaireQuestionResponseNoteMutation,
      UpdateQuestionnaireQuestionResponseNoteMutationVariables,
      T
    >({
      name: 'UpdateQuestionnaireQuestionResponseNote',
      mutation: gql`
        mutation UpdateQuestionnaireQuestionResponseNoteMutation(
          $command: UpdateQuestionnaireQuestionResponseNote!
        ) {
          updateQuestionnaireQuestionResponseNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public upsertQuestionnaireQuestionResponseNote<T = any>(
    command: UpsertQuestionnaireQuestionResponseNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertQuestionnaireQuestionResponseNote',
      UpsertQuestionnaireQuestionResponseNoteMutation,
      UpsertQuestionnaireQuestionResponseNoteMutationVariables,
      T
    >({
      name: 'UpsertQuestionnaireQuestionResponseNote',
      mutation: gql`
        mutation UpsertQuestionnaireQuestionResponseNoteMutation(
          $command: UpsertQuestionnaireQuestionResponseNote!
        ) {
          upsertQuestionnaireQuestionResponseNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // QuestionnaireQuestionResponses
  public addQuestionnaireQuestionResponse<T = any>(
    command: AddQuestionnaireQuestionResponse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddQuestionnaireQuestionResponse',
      AddQuestionnaireQuestionResponseMutation,
      AddQuestionnaireQuestionResponseMutationVariables,
      T
    >({
      name: 'AddQuestionnaireQuestionResponse',
      mutation: gql`
        mutation AddQuestionnaireQuestionResponseMutation(
          $command: AddQuestionnaireQuestionResponse!
        ) {
          addQuestionnaireQuestionResponse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteQuestionnaireQuestionResponse<T = any>(
    command: DeleteQuestionnaireQuestionResponse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteQuestionnaireQuestionResponse',
      DeleteQuestionnaireQuestionResponseMutation,
      DeleteQuestionnaireQuestionResponseMutationVariables,
      T
    >({
      name: 'DeleteQuestionnaireQuestionResponse',
      mutation: gql`
        mutation DeleteQuestionnaireQuestionResponseMutation(
          $command: DeleteQuestionnaireQuestionResponse!
        ) {
          deleteQuestionnaireQuestionResponse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateQuestionnaireQuestionResponse<T = any>(
    command: UpdateQuestionnaireQuestionResponse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateQuestionnaireQuestionResponse',
      UpdateQuestionnaireQuestionResponseMutation,
      UpdateQuestionnaireQuestionResponseMutationVariables,
      T
    >({
      name: 'UpdateQuestionnaireQuestionResponse',
      mutation: gql`
        mutation UpdateQuestionnaireQuestionResponseMutation(
          $command: UpdateQuestionnaireQuestionResponse!
        ) {
          updateQuestionnaireQuestionResponse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateQuestionnaireQuestionResponseDeep<T = any>(
    command: UpdateQuestionnaireQuestionResponseDeep,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateQuestionnaireQuestionResponseDeep',
      UpdateQuestionnaireQuestionResponseDeepMutation,
      UpdateQuestionnaireQuestionResponseDeepMutationVariables,
      T
    >({
      name: 'UpdateQuestionnaireQuestionResponseDeep',
      mutation: gql`
        mutation UpdateQuestionnaireQuestionResponseDeepMutation(
          $command: UpdateQuestionnaireQuestionResponseDeep!
        ) {
          updateQuestionnaireQuestionResponseDeep(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // QuestionnaireResponses
  public addQuestionnaireResponse<T = any>(
    command: AddQuestionnaireResponse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddQuestionnaireResponse',
      AddQuestionnaireResponseMutation,
      AddQuestionnaireResponseMutationVariables,
      T
    >({
      name: 'AddQuestionnaireResponse',
      mutation: gql`
        mutation AddQuestionnaireResponseMutation($command: AddQuestionnaireResponse!) {
          addQuestionnaireResponse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteQuestionnaireResponse<T = any>(
    command: DeleteQuestionnaireResponse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteQuestionnaireResponse',
      DeleteQuestionnaireResponseMutation,
      DeleteQuestionnaireResponseMutationVariables,
      T
    >({
      name: 'DeleteQuestionnaireResponse',
      mutation: gql`
        mutation DeleteQuestionnaireResponseMutation($command: DeleteQuestionnaireResponse!) {
          deleteQuestionnaireResponse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public submitQuestionnaireResponse<T = any>(
    command: SubmitQuestionnaireResponse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SubmitQuestionnaireResponse',
      SubmitQuestionnaireResponseMutation,
      SubmitQuestionnaireResponseMutationVariables,
      T
    >({
      name: 'SubmitQuestionnaireResponse',
      mutation: gql`
        mutation SubmitQuestionnaireResponseMutation($command: SubmitQuestionnaireResponse!) {
          submitQuestionnaireResponse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateQuestionnaireResponse<T = any>(
    command: UpdateQuestionnaireResponse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateQuestionnaireResponse',
      UpdateQuestionnaireResponseMutation,
      UpdateQuestionnaireResponseMutationVariables,
      T
    >({
      name: 'UpdateQuestionnaireResponse',
      mutation: gql`
        mutation UpdateQuestionnaireResponseMutation($command: UpdateQuestionnaireResponse!) {
          updateQuestionnaireResponse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateQuestionnaireResponseDeep<T = any>(
    command: UpdateQuestionnaireResponseDeep,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateQuestionnaireResponseDeep',
      UpdateQuestionnaireResponseDeepMutation,
      UpdateQuestionnaireResponseDeepMutationVariables,
      T
    >({
      name: 'UpdateQuestionnaireResponseDeep',
      mutation: gql`
        mutation UpdateQuestionnaireResponseDeepMutation(
          $command: UpdateQuestionnaireResponseDeep!
        ) {
          updateQuestionnaireResponseDeep(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Questionnaires
  public addQuestionnaire<T = any>(
    command: AddQuestionnaire,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddQuestionnaire',
      AddQuestionnaireMutation,
      AddQuestionnaireMutationVariables,
      T
    >({
      name: 'AddQuestionnaire',
      mutation: gql`
        mutation AddQuestionnaireMutation($command: AddQuestionnaire!) {
          addQuestionnaire(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteQuestionnaire<T = any>(
    command: DeleteQuestionnaire,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteQuestionnaire',
      DeleteQuestionnaireMutation,
      DeleteQuestionnaireMutationVariables,
      T
    >({
      name: 'DeleteQuestionnaire',
      mutation: gql`
        mutation DeleteQuestionnaireMutation($command: DeleteQuestionnaire!) {
          deleteQuestionnaire(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateQuestionnaire<T = any>(
    command: UpdateQuestionnaire,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateQuestionnaire',
      UpdateQuestionnaireMutation,
      UpdateQuestionnaireMutationVariables,
      T
    >({
      name: 'UpdateQuestionnaire',
      mutation: gql`
        mutation UpdateQuestionnaireMutation($command: UpdateQuestionnaire!) {
          updateQuestionnaire(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // QuestionnaireSectionQuestions
  public deleteQuestionnaireSectionQuestion<T = any>(
    command: DeleteQuestionnaireSectionQuestion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteQuestionnaireSectionQuestion',
      DeleteQuestionnaireSectionQuestionMutation,
      DeleteQuestionnaireSectionQuestionMutationVariables,
      T
    >({
      name: 'DeleteQuestionnaireSectionQuestion',
      mutation: gql`
        mutation DeleteQuestionnaireSectionQuestionMutation(
          $command: DeleteQuestionnaireSectionQuestion!
        ) {
          deleteQuestionnaireSectionQuestion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public upsertQuestionnaireSectionQuestion<T = any>(
    command: UpsertQuestionnaireSectionQuestion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertQuestionnaireSectionQuestion',
      UpsertQuestionnaireSectionQuestionMutation,
      UpsertQuestionnaireSectionQuestionMutationVariables,
      T
    >({
      name: 'UpsertQuestionnaireSectionQuestion',
      mutation: gql`
        mutation UpsertQuestionnaireSectionQuestionMutation(
          $command: UpsertQuestionnaireSectionQuestion!
        ) {
          upsertQuestionnaireSectionQuestion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // QuestionnaireSections
  public deleteQuestionnaireSection<T = any>(
    command: DeleteQuestionnaireSection,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteQuestionnaireSection',
      DeleteQuestionnaireSectionMutation,
      DeleteQuestionnaireSectionMutationVariables,
      T
    >({
      name: 'DeleteQuestionnaireSection',
      mutation: gql`
        mutation DeleteQuestionnaireSectionMutation($command: DeleteQuestionnaireSection!) {
          deleteQuestionnaireSection(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public upsertQuestionnaireSection<T = any>(
    command: UpsertQuestionnaireSection,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertQuestionnaireSection',
      UpsertQuestionnaireSectionMutation,
      UpsertQuestionnaireSectionMutationVariables,
      T
    >({
      name: 'UpsertQuestionnaireSection',
      mutation: gql`
        mutation UpsertQuestionnaireSectionMutation($command: UpsertQuestionnaireSection!) {
          upsertQuestionnaireSection(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Questions
  public addQuestion<T = any>(
    command: AddQuestion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddQuestion',
      AddQuestionMutation,
      AddQuestionMutationVariables,
      T
    >({
      name: 'AddQuestion',
      mutation: gql`
        mutation AddQuestionMutation($command: AddQuestion!) {
          addQuestion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteQuestion<T = any>(
    command: DeleteQuestion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteQuestion',
      DeleteQuestionMutation,
      DeleteQuestionMutationVariables,
      T
    >({
      name: 'DeleteQuestion',
      mutation: gql`
        mutation DeleteQuestionMutation($command: DeleteQuestion!) {
          deleteQuestion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateQuestion<T = any>(
    command: UpdateQuestion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateQuestion',
      UpdateQuestionMutation,
      UpdateQuestionMutationVariables,
      T
    >({
      name: 'UpdateQuestion',
      mutation: gql`
        mutation UpdateQuestionMutation($command: UpdateQuestion!) {
          updateQuestion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ReceivingFacilityRequests
  public acceptReceivingFacilityRequest<T = any>(
    command: AcceptReceivingFacilityRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcceptReceivingFacilityRequest',
      AcceptReceivingFacilityRequestMutation,
      AcceptReceivingFacilityRequestMutationVariables,
      T
    >({
      name: 'AcceptReceivingFacilityRequest',
      mutation: gql`
        mutation AcceptReceivingFacilityRequestMutation($command: AcceptReceivingFacilityRequest!) {
          acceptReceivingFacilityRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addReceivingFacilityRequestDeclineHistory<T = any>(
    command: AddReceivingFacilityRequestDeclineHistory,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddReceivingFacilityRequestDeclineHistory',
      AddReceivingFacilityRequestDeclineHistoryMutation,
      AddReceivingFacilityRequestDeclineHistoryMutationVariables,
      T
    >({
      name: 'AddReceivingFacilityRequestDeclineHistory',
      mutation: gql`
        mutation AddReceivingFacilityRequestDeclineHistoryMutation(
          $command: AddReceivingFacilityRequestDeclineHistory!
        ) {
          addReceivingFacilityRequestDeclineHistory(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cancelReceivingFacilityRequest<T = any>(
    command: CancelReceivingFacilityRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CancelReceivingFacilityRequest',
      CancelReceivingFacilityRequestMutation,
      CancelReceivingFacilityRequestMutationVariables,
      T
    >({
      name: 'CancelReceivingFacilityRequest',
      mutation: gql`
        mutation CancelReceivingFacilityRequestMutation($command: CancelReceivingFacilityRequest!) {
          cancelReceivingFacilityRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteReceivingFacilityRequest<T = any>(
    command: DeleteReceivingFacilityRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteReceivingFacilityRequest',
      DeleteReceivingFacilityRequestMutation,
      DeleteReceivingFacilityRequestMutationVariables,
      T
    >({
      name: 'DeleteReceivingFacilityRequest',
      mutation: gql`
        mutation DeleteReceivingFacilityRequestMutation($command: DeleteReceivingFacilityRequest!) {
          deleteReceivingFacilityRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public denyReceivingFacilityRequest<T = any>(
    command: DenyReceivingFacilityRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DenyReceivingFacilityRequest',
      DenyReceivingFacilityRequestMutation,
      DenyReceivingFacilityRequestMutationVariables,
      T
    >({
      name: 'DenyReceivingFacilityRequest',
      mutation: gql`
        mutation DenyReceivingFacilityRequestMutation($command: DenyReceivingFacilityRequest!) {
          denyReceivingFacilityRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public divertReceivingFacilityRequest<T = any>(
    command: DivertReceivingFacilityRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DivertReceivingFacilityRequest',
      DivertReceivingFacilityRequestMutation,
      DivertReceivingFacilityRequestMutationVariables,
      T
    >({
      name: 'DivertReceivingFacilityRequest',
      mutation: gql`
        mutation DivertReceivingFacilityRequestMutation($command: DivertReceivingFacilityRequest!) {
          divertReceivingFacilityRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public referReceivingFacilityRequest<T = any>(
    command: ReferReceivingFacilityRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReferReceivingFacilityRequest',
      ReferReceivingFacilityRequestMutation,
      ReferReceivingFacilityRequestMutationVariables,
      T
    >({
      name: 'ReferReceivingFacilityRequest',
      mutation: gql`
        mutation ReferReceivingFacilityRequestMutation($command: ReferReceivingFacilityRequest!) {
          referReceivingFacilityRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // RendezvousRequests
  public addRendezvousRequest<T = any>(
    command: AddRendezvousRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddRendezvousRequest',
      AddRendezvousRequestMutation,
      AddRendezvousRequestMutationVariables,
      T
    >({
      name: 'AddRendezvousRequest',
      mutation: gql`
        mutation AddRendezvousRequestMutation($command: AddRendezvousRequest!) {
          addRendezvousRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteRendezvousRequest<T = any>(
    command: DeleteRendezvousRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteRendezvousRequest',
      DeleteRendezvousRequestMutation,
      DeleteRendezvousRequestMutationVariables,
      T
    >({
      name: 'DeleteRendezvousRequest',
      mutation: gql`
        mutation DeleteRendezvousRequestMutation($command: DeleteRendezvousRequest!) {
          deleteRendezvousRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRendezvousRequest<T = any>(
    command: UpdateRendezvousRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRendezvousRequest',
      UpdateRendezvousRequestMutation,
      UpdateRendezvousRequestMutationVariables,
      T
    >({
      name: 'UpdateRendezvousRequest',
      mutation: gql`
        mutation UpdateRendezvousRequestMutation($command: UpdateRendezvousRequest!) {
          updateRendezvousRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // RequesterRoles
  public addRequesterRole<T = any>(
    command: AddRequesterRole,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddRequesterRole',
      AddRequesterRoleMutation,
      AddRequesterRoleMutationVariables,
      T
    >({
      name: 'AddRequesterRole',
      mutation: gql`
        mutation AddRequesterRoleMutation($command: AddRequesterRole!) {
          addRequesterRole(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteRequesterRole<T = any>(
    command: DeleteRequesterRole,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteRequesterRole',
      DeleteRequesterRoleMutation,
      DeleteRequesterRoleMutationVariables,
      T
    >({
      name: 'DeleteRequesterRole',
      mutation: gql`
        mutation DeleteRequesterRoleMutation($command: DeleteRequesterRole!) {
          deleteRequesterRole(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequesterRole<T = any>(
    command: UpdateRequesterRole,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequesterRole',
      UpdateRequesterRoleMutation,
      UpdateRequesterRoleMutationVariables,
      T
    >({
      name: 'UpdateRequesterRole',
      mutation: gql`
        mutation UpdateRequesterRoleMutation($command: UpdateRequesterRole!) {
          updateRequesterRole(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Requesters
  public updateRequester<T = any>(
    command: UpdateRequester,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequester',
      UpdateRequesterMutation,
      UpdateRequesterMutationVariables,
      T
    >({
      name: 'UpdateRequester',
      mutation: gql`
        mutation UpdateRequesterMutation($command: UpdateRequester!) {
          updateRequester(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequesterSpecialtyTeam<T = any>(
    command: UpdateRequesterSpecialtyTeam,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequesterSpecialtyTeam',
      UpdateRequesterSpecialtyTeamMutation,
      UpdateRequesterSpecialtyTeamMutationVariables,
      T
    >({
      name: 'UpdateRequesterSpecialtyTeam',
      mutation: gql`
        mutation UpdateRequesterSpecialtyTeamMutation($command: UpdateRequesterSpecialtyTeam!) {
          updateRequesterSpecialtyTeam(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestorAgencyLocation<T = any>(
    command: UpdateRequestorAgencyLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestorAgencyLocation',
      UpdateRequestorAgencyLocationMutation,
      UpdateRequestorAgencyLocationMutationVariables,
      T
    >({
      name: 'UpdateRequestorAgencyLocation',
      mutation: gql`
        mutation UpdateRequestorAgencyLocationMutation($command: UpdateRequestorAgencyLocation!) {
          updateRequestorAgencyLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTransferCenterCallInfo<T = any>(
    command: UpdateTransferCenterCallInfo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTransferCenterCallInfo',
      UpdateTransferCenterCallInfoMutation,
      UpdateTransferCenterCallInfoMutationVariables,
      T
    >({
      name: 'UpdateTransferCenterCallInfo',
      mutation: gql`
        mutation UpdateTransferCenterCallInfoMutation($command: UpdateTransferCenterCallInfo!) {
          updateTransferCenterCallInfo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // RequestLocations
  public updateReceivingFacilityAutoAcceptance<T = any>(
    command: UpdateReceivingFacilityAutoAcceptance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateReceivingFacilityAutoAcceptance',
      UpdateReceivingFacilityAutoAcceptanceMutation,
      UpdateReceivingFacilityAutoAcceptanceMutationVariables,
      T
    >({
      name: 'UpdateReceivingFacilityAutoAcceptance',
      mutation: gql`
        mutation UpdateReceivingFacilityAutoAcceptanceMutation(
          $command: UpdateReceivingFacilityAutoAcceptance!
        ) {
          updateReceivingFacilityAutoAcceptance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestLocation<T = any>(
    command: UpdateRequestLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestLocation',
      UpdateRequestLocationMutation,
      UpdateRequestLocationMutationVariables,
      T
    >({
      name: 'UpdateRequestLocation',
      mutation: gql`
        mutation UpdateRequestLocationMutation($command: UpdateRequestLocation!) {
          updateRequestLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // RequestPatients
  public addRequestPatient<T = any>(
    command: AddRequestPatient,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddRequestPatient',
      AddRequestPatientMutation,
      AddRequestPatientMutationVariables,
      T
    >({
      name: 'AddRequestPatient',
      mutation: gql`
        mutation AddRequestPatientMutation($command: AddRequestPatient!) {
          addRequestPatient(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteRequestPatient<T = any>(
    command: DeleteRequestPatient,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteRequestPatient',
      DeleteRequestPatientMutation,
      DeleteRequestPatientMutationVariables,
      T
    >({
      name: 'DeleteRequestPatient',
      mutation: gql`
        mutation DeleteRequestPatientMutation($command: DeleteRequestPatient!) {
          deleteRequestPatient(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateChiefComplaint<T = any>(
    command: UpdateChiefComplaint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateChiefComplaint',
      UpdateChiefComplaintMutation,
      UpdateChiefComplaintMutationVariables,
      T
    >({
      name: 'UpdateChiefComplaint',
      mutation: gql`
        mutation UpdateChiefComplaintMutation($command: UpdateChiefComplaint!) {
          updateChiefComplaint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePatientClinicalInfo<T = any>(
    command: UpdatePatientClinicalInfo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePatientClinicalInfo',
      UpdatePatientClinicalInfoMutation,
      UpdatePatientClinicalInfoMutationVariables,
      T
    >({
      name: 'UpdatePatientClinicalInfo',
      mutation: gql`
        mutation UpdatePatientClinicalInfoMutation($command: UpdatePatientClinicalInfo!) {
          updatePatientClinicalInfo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePatientInfo<T = any>(
    command: UpdatePatientInfo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePatientInfo',
      UpdatePatientInfoMutation,
      UpdatePatientInfoMutationVariables,
      T
    >({
      name: 'UpdatePatientInfo',
      mutation: gql`
        mutation UpdatePatientInfoMutation($command: UpdatePatientInfo!) {
          updatePatientInfo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestPatient<T = any>(
    command: UpdateRequestPatient,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestPatient',
      UpdateRequestPatientMutation,
      UpdateRequestPatientMutationVariables,
      T
    >({
      name: 'UpdateRequestPatient',
      mutation: gql`
        mutation UpdateRequestPatientMutation($command: UpdateRequestPatient!) {
          updateRequestPatient(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Requests
  public acknowledgeExternalRequest<T = any>(
    command: AcknowledgeExternalRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcknowledgeExternalRequest',
      AcknowledgeExternalRequestMutation,
      AcknowledgeExternalRequestMutationVariables,
      T
    >({
      name: 'AcknowledgeExternalRequest',
      mutation: gql`
        mutation AcknowledgeExternalRequestMutation($command: AcknowledgeExternalRequest!) {
          acknowledgeExternalRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public beginAssignment<T = any>(
    command: BeginAssignment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'BeginAssignment',
      BeginAssignmentMutation,
      BeginAssignmentMutationVariables,
      T
    >({
      name: 'BeginAssignment',
      mutation: gql`
        mutation BeginAssignmentMutation($command: BeginAssignment!) {
          beginAssignment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cancelRequest<T = any>(
    command: CancelRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CancelRequest',
      CancelRequestMutation,
      CancelRequestMutationVariables,
      T
    >({
      name: 'CancelRequest',
      mutation: gql`
        mutation CancelRequestMutation($command: CancelRequest!) {
          cancelRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cancelRequestFromTransferCenter<T = any>(
    command: CancelRequestFromTransferCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CancelRequestFromTransferCenter',
      CancelRequestFromTransferCenterMutation,
      CancelRequestFromTransferCenterMutationVariables,
      T
    >({
      name: 'CancelRequestFromTransferCenter',
      mutation: gql`
        mutation CancelRequestFromTransferCenterMutation(
          $command: CancelRequestFromTransferCenter!
        ) {
          cancelRequestFromTransferCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public changeCallType<T = any>(
    command: ChangeCallType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ChangeCallType',
      ChangeCallTypeMutation,
      ChangeCallTypeMutationVariables,
      T
    >({
      name: 'ChangeCallType',
      mutation: gql`
        mutation ChangeCallTypeMutation($command: ChangeCallType!) {
          changeCallType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public changeRequestCancellationReason<T = any>(
    command: ChangeRequestCancellationReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ChangeRequestCancellationReason',
      ChangeRequestCancellationReasonMutation,
      ChangeRequestCancellationReasonMutationVariables,
      T
    >({
      name: 'ChangeRequestCancellationReason',
      mutation: gql`
        mutation ChangeRequestCancellationReasonMutation(
          $command: ChangeRequestCancellationReason!
        ) {
          changeRequestCancellationReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public changeRequestType<T = any>(
    command: ChangeRequestType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ChangeRequestType',
      ChangeRequestTypeMutation,
      ChangeRequestTypeMutationVariables,
      T
    >({
      name: 'ChangeRequestType',
      mutation: gql`
        mutation ChangeRequestTypeMutation($command: ChangeRequestType!) {
          changeRequestType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createRequest<T = any>(
    command: CreateRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreateRequest',
      CreateRequestMutation,
      CreateRequestMutationVariables,
      T
    >({
      name: 'CreateRequest',
      mutation: gql`
        mutation CreateRequestMutation($command: CreateRequest!) {
          createRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public delayAssignment<T = any>(
    command: DelayAssignment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DelayAssignment',
      DelayAssignmentMutation,
      DelayAssignmentMutationVariables,
      T
    >({
      name: 'DelayAssignment',
      mutation: gql`
        mutation DelayAssignmentMutation($command: DelayAssignment!) {
          delayAssignment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public duplicateRequest<T = any>(
    command: DuplicateRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DuplicateRequest',
      DuplicateRequestMutation,
      DuplicateRequestMutationVariables,
      T
    >({
      name: 'DuplicateRequest',
      mutation: gql`
        mutation DuplicateRequestMutation($command: DuplicateRequest!) {
          duplicateRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public reactivateRequest<T = any>(
    command: ReactivateRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReactivateRequest',
      ReactivateRequestMutation,
      ReactivateRequestMutationVariables,
      T
    >({
      name: 'ReactivateRequest',
      mutation: gql`
        mutation ReactivateRequestMutation($command: ReactivateRequest!) {
          reactivateRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public reactivateRequestFromTransferCenter<T = any>(
    command: ReactivateRequestFromTransferCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReactivateRequestFromTransferCenter',
      ReactivateRequestFromTransferCenterMutation,
      ReactivateRequestFromTransferCenterMutationVariables,
      T
    >({
      name: 'ReactivateRequestFromTransferCenter',
      mutation: gql`
        mutation ReactivateRequestFromTransferCenterMutation(
          $command: ReactivateRequestFromTransferCenter!
        ) {
          reactivateRequestFromTransferCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public recalculateCandidates<T = any>(
    command: RecalculateCandidates,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RecalculateCandidates',
      RecalculateCandidatesMutation,
      RecalculateCandidatesMutationVariables,
      T
    >({
      name: 'RecalculateCandidates',
      mutation: gql`
        mutation RecalculateCandidatesMutation($command: RecalculateCandidates!) {
          recalculateCandidates(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public requestPublicRelationFromUnit<T = any>(
    command: RequestPublicRelationFromUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RequestPublicRelationFromUnit',
      RequestPublicRelationFromUnitMutation,
      RequestPublicRelationFromUnitMutationVariables,
      T
    >({
      name: 'RequestPublicRelationFromUnit',
      mutation: gql`
        mutation RequestPublicRelationFromUnitMutation($command: RequestPublicRelationFromUnit!) {
          requestPublicRelationFromUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequest<T = any>(
    command: UpdateRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequest',
      UpdateRequestMutation,
      UpdateRequestMutationVariables,
      T
    >({
      name: 'UpdateRequest',
      mutation: gql`
        mutation UpdateRequestMutation($command: UpdateRequest!) {
          updateRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestAtlo<T = any>(
    command: UpdateRequestAtlo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestAtlo',
      UpdateRequestAtloMutation,
      UpdateRequestAtloMutationVariables,
      T
    >({
      name: 'UpdateRequestAtlo',
      mutation: gql`
        mutation UpdateRequestAtloMutation($command: UpdateRequestAtlo!) {
          updateRequestAtlo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestPublicUtilityInfo<T = any>(
    command: UpdateRequestPublicUtilityInfo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestPublicUtilityInfo',
      UpdateRequestPublicUtilityInfoMutation,
      UpdateRequestPublicUtilityInfoMutationVariables,
      T
    >({
      name: 'UpdateRequestPublicUtilityInfo',
      mutation: gql`
        mutation UpdateRequestPublicUtilityInfoMutation($command: UpdateRequestPublicUtilityInfo!) {
          updateRequestPublicUtilityInfo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestRegion<T = any>(
    command: UpdateRequestRegion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestRegion',
      UpdateRequestRegionMutation,
      UpdateRequestRegionMutationVariables,
      T
    >({
      name: 'UpdateRequestRegion',
      mutation: gql`
        mutation UpdateRequestRegionMutation($command: UpdateRequestRegion!) {
          updateRequestRegion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestSafetyQuestions<T = any>(
    command: UpdateRequestSafetyQuestions,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestSafetyQuestions',
      UpdateRequestSafetyQuestionsMutation,
      UpdateRequestSafetyQuestionsMutationVariables,
      T
    >({
      name: 'UpdateRequestSafetyQuestions',
      mutation: gql`
        mutation UpdateRequestSafetyQuestionsMutation($command: UpdateRequestSafetyQuestions!) {
          updateRequestSafetyQuestions(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRequestStandbyStatus<T = any>(
    command: UpdateRequestStandbyStatus,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRequestStandbyStatus',
      UpdateRequestStandbyStatusMutation,
      UpdateRequestStandbyStatusMutationVariables,
      T
    >({
      name: 'UpdateRequestStandbyStatus',
      mutation: gql`
        mutation UpdateRequestStandbyStatusMutation($command: UpdateRequestStandbyStatus!) {
          updateRequestStandbyStatus(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // SystemTimers
  // TimelineItems
  public addTimelineItem<T = any>(
    command: AddTimelineItem,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTimelineItem',
      AddTimelineItemMutation,
      AddTimelineItemMutationVariables,
      T
    >({
      name: 'AddTimelineItem',
      mutation: gql`
        mutation AddTimelineItemMutation($command: AddTimelineItem!) {
          addTimelineItem(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTimelineItem<T = any>(
    command: DeleteTimelineItem,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTimelineItem',
      DeleteTimelineItemMutation,
      DeleteTimelineItemMutationVariables,
      T
    >({
      name: 'DeleteTimelineItem',
      mutation: gql`
        mutation DeleteTimelineItemMutation($command: DeleteTimelineItem!) {
          deleteTimelineItem(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTimelineItem<T = any>(
    command: UpdateTimelineItem,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTimelineItem',
      UpdateTimelineItemMutation,
      UpdateTimelineItemMutationVariables,
      T
    >({
      name: 'UpdateTimelineItem',
      mutation: gql`
        mutation UpdateTimelineItemMutation($command: UpdateTimelineItem!) {
          updateTimelineItem(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public upsertTimelineItem<T = any>(
    command: UpsertTimelineItem,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertTimelineItem',
      UpsertTimelineItemMutation,
      UpsertTimelineItemMutationVariables,
      T
    >({
      name: 'UpsertTimelineItem',
      mutation: gql`
        mutation UpsertTimelineItemMutation($command: UpsertTimelineItem!) {
          upsertTimelineItem(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Timelines
  public addTimeline<T = any>(
    command: AddTimeline,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTimeline',
      AddTimelineMutation,
      AddTimelineMutationVariables,
      T
    >({
      name: 'AddTimeline',
      mutation: gql`
        mutation AddTimelineMutation($command: AddTimeline!) {
          addTimeline(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTimeline<T = any>(
    command: DeleteTimeline,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTimeline',
      DeleteTimelineMutation,
      DeleteTimelineMutationVariables,
      T
    >({
      name: 'DeleteTimeline',
      mutation: gql`
        mutation DeleteTimelineMutation($command: DeleteTimeline!) {
          deleteTimeline(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTimeline<T = any>(
    command: UpdateTimeline,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTimeline',
      UpdateTimelineMutation,
      UpdateTimelineMutationVariables,
      T
    >({
      name: 'UpdateTimeline',
      mutation: gql`
        mutation UpdateTimelineMutation($command: UpdateTimeline!) {
          updateTimeline(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Timestamps
  public addEmsReport<T = any>(
    command: AddEmsReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddEmsReport',
      AddEmsReportMutation,
      AddEmsReportMutationVariables,
      T
    >({
      name: 'AddEmsReport',
      mutation: gql`
        mutation AddEmsReportMutation($command: AddEmsReport!) {
          addEmsReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addTimestamp<T = any>(
    command: AddTimestamp,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTimestamp',
      AddTimestampMutation,
      AddTimestampMutationVariables,
      T
    >({
      name: 'AddTimestamp',
      mutation: gql`
        mutation AddTimestampMutation($command: AddTimestamp!) {
          addTimestamp(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTimestamp<T = any>(
    command: DeleteTimestamp,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTimestamp',
      DeleteTimestampMutation,
      DeleteTimestampMutationVariables,
      T
    >({
      name: 'DeleteTimestamp',
      mutation: gql`
        mutation DeleteTimestampMutation($command: DeleteTimestamp!) {
          deleteTimestamp(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public reSendToDataWarehouse<T = any>(
    command: ReSendToDataWarehouse,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReSendToDataWarehouse',
      ReSendToDataWarehouseMutation,
      ReSendToDataWarehouseMutationVariables,
      T
    >({
      name: 'ReSendToDataWarehouse',
      mutation: gql`
        mutation ReSendToDataWarehouseMutation($command: ReSendToDataWarehouse!) {
          reSendToDataWarehouse(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public sendToImageTrend<T = any>(
    command: SendToImageTrend,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SendToImageTrend',
      SendToImageTrendMutation,
      SendToImageTrendMutationVariables,
      T
    >({
      name: 'SendToImageTrend',
      mutation: gql`
        mutation SendToImageTrendMutation($command: SendToImageTrend!) {
          sendToImageTrend(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateEmsReport<T = any>(
    command: UpdateEmsReport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateEmsReport',
      UpdateEmsReportMutation,
      UpdateEmsReportMutationVariables,
      T
    >({
      name: 'UpdateEmsReport',
      mutation: gql`
        mutation UpdateEmsReportMutation($command: UpdateEmsReport!) {
          updateEmsReport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTimestamp<T = any>(
    command: UpdateTimestamp,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTimestamp',
      UpdateTimestampMutation,
      UpdateTimestampMutationVariables,
      T
    >({
      name: 'UpdateTimestamp',
      mutation: gql`
        mutation UpdateTimestampMutation($command: UpdateTimestamp!) {
          updateTimestamp(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TimestampTypes
  public addTimestampType<T = any>(
    command: AddTimestampType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTimestampType',
      AddTimestampTypeMutation,
      AddTimestampTypeMutationVariables,
      T
    >({
      name: 'AddTimestampType',
      mutation: gql`
        mutation AddTimestampTypeMutation($command: AddTimestampType!) {
          addTimestampType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTimestampType<T = any>(
    command: DeleteTimestampType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTimestampType',
      DeleteTimestampTypeMutation,
      DeleteTimestampTypeMutationVariables,
      T
    >({
      name: 'DeleteTimestampType',
      mutation: gql`
        mutation DeleteTimestampTypeMutation($command: DeleteTimestampType!) {
          deleteTimestampType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTimestampType<T = any>(
    command: UpdateTimestampType,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTimestampType',
      UpdateTimestampTypeMutation,
      UpdateTimestampTypeMutationVariables,
      T
    >({
      name: 'UpdateTimestampType',
      mutation: gql`
        mutation UpdateTimestampTypeMutation($command: UpdateTimestampType!) {
          updateTimestampType(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TrackedMessages
  public deliverTrackedMessage<T = any>(
    command: DeliverTrackedMessage,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeliverTrackedMessage',
      DeliverTrackedMessageMutation,
      DeliverTrackedMessageMutationVariables,
      T
    >({
      name: 'DeliverTrackedMessage',
      mutation: gql`
        mutation DeliverTrackedMessageMutation($command: DeliverTrackedMessage!) {
          deliverTrackedMessage(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public sendMessage<T = any>(
    command: SendMessage,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SendMessage',
      SendMessageMutation,
      SendMessageMutationVariables,
      T
    >({
      name: 'SendMessage',
      mutation: gql`
        mutation SendMessageMutation($command: SendMessage!) {
          sendMessage(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public sendSupportRequestEmail<T = any>(
    command: SendSupportRequestEmail,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SendSupportRequestEmail',
      SendSupportRequestEmailMutation,
      SendSupportRequestEmailMutationVariables,
      T
    >({
      name: 'SendSupportRequestEmail',
      mutation: gql`
        mutation SendSupportRequestEmailMutation($command: SendSupportRequestEmail!) {
          sendSupportRequestEmail(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTrackedMessage<T = any>(
    command: UpdateTrackedMessage,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTrackedMessage',
      UpdateTrackedMessageMutation,
      UpdateTrackedMessageMutationVariables,
      T
    >({
      name: 'UpdateTrackedMessage',
      mutation: gql`
        mutation UpdateTrackedMessageMutation($command: UpdateTrackedMessage!) {
          updateTrackedMessage(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TransferReasons
  public addTransferReason<T = any>(
    command: AddTransferReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTransferReason',
      AddTransferReasonMutation,
      AddTransferReasonMutationVariables,
      T
    >({
      name: 'AddTransferReason',
      mutation: gql`
        mutation AddTransferReasonMutation($command: AddTransferReason!) {
          addTransferReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTransferReason<T = any>(
    command: DeleteTransferReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTransferReason',
      DeleteTransferReasonMutation,
      DeleteTransferReasonMutationVariables,
      T
    >({
      name: 'DeleteTransferReason',
      mutation: gql`
        mutation DeleteTransferReasonMutation($command: DeleteTransferReason!) {
          deleteTransferReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTransferReason<T = any>(
    command: UpdateTransferReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTransferReason',
      UpdateTransferReasonMutation,
      UpdateTransferReasonMutationVariables,
      T
    >({
      name: 'UpdateTransferReason',
      mutation: gql`
        mutation UpdateTransferReasonMutation($command: UpdateTransferReason!) {
          updateTransferReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TransportOfferOptions
  public updateTransportOfferOption<T = any>(
    command: UpdateTransportOfferOption,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTransportOfferOption',
      UpdateTransportOfferOptionMutation,
      UpdateTransportOfferOptionMutationVariables,
      T
    >({
      name: 'UpdateTransportOfferOption',
      mutation: gql`
        mutation UpdateTransportOfferOptionMutation($command: UpdateTransportOfferOption!) {
          updateTransportOfferOption(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TransportOffers
  public acceptTransportOffer<T = any>(
    command: AcceptTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcceptTransportOffer',
      AcceptTransportOfferMutation,
      AcceptTransportOfferMutationVariables,
      T
    >({
      name: 'AcceptTransportOffer',
      mutation: gql`
        mutation AcceptTransportOfferMutation($command: AcceptTransportOffer!) {
          acceptTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addCancellation<T = any>(
    command: AddCancellation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCancellation',
      AddCancellationMutation,
      AddCancellationMutationVariables,
      T
    >({
      name: 'AddCancellation',
      mutation: gql`
        mutation AddCancellationMutation($command: AddCancellation!) {
          addCancellation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addDecline<T = any>(
    command: AddDecline,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddDecline', AddDeclineMutation, AddDeclineMutationVariables, T>(
      {
        name: 'AddDecline',
        mutation: gql`
          mutation AddDeclineMutation($command: AddDecline!) {
            addDecline(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public addTransportOffer<T = any>(
    command: AddTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTransportOffer',
      AddTransportOfferMutation,
      AddTransportOfferMutationVariables,
      T
    >({
      name: 'AddTransportOffer',
      mutation: gql`
        mutation AddTransportOfferMutation($command: AddTransportOffer!) {
          addTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public beginTransportOffer<T = any>(
    command: BeginTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'BeginTransportOffer',
      BeginTransportOfferMutation,
      BeginTransportOfferMutationVariables,
      T
    >({
      name: 'BeginTransportOffer',
      mutation: gql`
        mutation BeginTransportOfferMutation($command: BeginTransportOffer!) {
          beginTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public cancelTransportOffer<T = any>(
    command: CancelTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CancelTransportOffer',
      CancelTransportOfferMutation,
      CancelTransportOfferMutationVariables,
      T
    >({
      name: 'CancelTransportOffer',
      mutation: gql`
        mutation CancelTransportOfferMutation($command: CancelTransportOffer!) {
          cancelTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public declineAndAssignNewTransportOffer<T = any>(
    command: DeclineAndAssignNewTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeclineAndAssignNewTransportOffer',
      DeclineAndAssignNewTransportOfferMutation,
      DeclineAndAssignNewTransportOfferMutationVariables,
      T
    >({
      name: 'DeclineAndAssignNewTransportOffer',
      mutation: gql`
        mutation DeclineAndAssignNewTransportOfferMutation(
          $command: DeclineAndAssignNewTransportOffer!
        ) {
          declineAndAssignNewTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public declineTransportOffer<T = any>(
    command: DeclineTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeclineTransportOffer',
      DeclineTransportOfferMutation,
      DeclineTransportOfferMutationVariables,
      T
    >({
      name: 'DeclineTransportOffer',
      mutation: gql`
        mutation DeclineTransportOfferMutation($command: DeclineTransportOffer!) {
          declineTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public declineTransportOfferAndDelayAssignment<T = any>(
    command: DeclineTransportOfferAndDelayAssignment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeclineTransportOfferAndDelayAssignment',
      DeclineTransportOfferAndDelayAssignmentMutation,
      DeclineTransportOfferAndDelayAssignmentMutationVariables,
      T
    >({
      name: 'DeclineTransportOfferAndDelayAssignment',
      mutation: gql`
        mutation DeclineTransportOfferAndDelayAssignmentMutation(
          $command: DeclineTransportOfferAndDelayAssignment!
        ) {
          declineTransportOfferAndDelayAssignment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTransportOffer<T = any>(
    command: DeleteTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTransportOffer',
      DeleteTransportOfferMutation,
      DeleteTransportOfferMutationVariables,
      T
    >({
      name: 'DeleteTransportOffer',
      mutation: gql`
        mutation DeleteTransportOfferMutation($command: DeleteTransportOffer!) {
          deleteTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public initiateTransportCheck<T = any>(
    command: InitiateTransportCheck,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'InitiateTransportCheck',
      InitiateTransportCheckMutation,
      InitiateTransportCheckMutationVariables,
      T
    >({
      name: 'InitiateTransportCheck',
      mutation: gql`
        mutation InitiateTransportCheckMutation($command: InitiateTransportCheck!) {
          initiateTransportCheck(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public offerWithBulkSkip<T = any>(
    command: OfferWithBulkSkip,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'OfferWithBulkSkip',
      OfferWithBulkSkipMutation,
      OfferWithBulkSkipMutationVariables,
      T
    >({
      name: 'OfferWithBulkSkip',
      mutation: gql`
        mutation OfferWithBulkSkipMutation($command: OfferWithBulkSkip!) {
          offerWithBulkSkip(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public referTransportOffer<T = any>(
    command: ReferTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReferTransportOffer',
      ReferTransportOfferMutation,
      ReferTransportOfferMutationVariables,
      T
    >({
      name: 'ReferTransportOffer',
      mutation: gql`
        mutation ReferTransportOfferMutation($command: ReferTransportOffer!) {
          referTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public skipTransportOffer<T = any>(
    command: SkipTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SkipTransportOffer',
      SkipTransportOfferMutation,
      SkipTransportOfferMutationVariables,
      T
    >({
      name: 'SkipTransportOffer',
      mutation: gql`
        mutation SkipTransportOfferMutation($command: SkipTransportOffer!) {
          skipTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCancellation<T = any>(
    command: UpdateCancellation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCancellation',
      UpdateCancellationMutation,
      UpdateCancellationMutationVariables,
      T
    >({
      name: 'UpdateCancellation',
      mutation: gql`
        mutation UpdateCancellationMutation($command: UpdateCancellation!) {
          updateCancellation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateDecline<T = any>(
    command: UpdateDecline,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateDecline',
      UpdateDeclineMutation,
      UpdateDeclineMutationVariables,
      T
    >({
      name: 'UpdateDecline',
      mutation: gql`
        mutation UpdateDeclineMutation($command: UpdateDecline!) {
          updateDecline(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOfferRank<T = any>(
    command: UpdateOfferRank,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOfferRank',
      UpdateOfferRankMutation,
      UpdateOfferRankMutationVariables,
      T
    >({
      name: 'UpdateOfferRank',
      mutation: gql`
        mutation UpdateOfferRankMutation($command: UpdateOfferRank!) {
          updateOfferRank(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateSkip<T = any>(
    command: UpdateSkip,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'UpdateSkip', UpdateSkipMutation, UpdateSkipMutationVariables, T>(
      {
        name: 'UpdateSkip',
        mutation: gql`
          mutation UpdateSkipMutation($command: UpdateSkip!) {
            updateSkip(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public updateTransportOffer<T = any>(
    command: UpdateTransportOffer,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTransportOffer',
      UpdateTransportOfferMutation,
      UpdateTransportOfferMutationVariables,
      T
    >({
      name: 'UpdateTransportOffer',
      mutation: gql`
        mutation UpdateTransportOfferMutation($command: UpdateTransportOffer!) {
          updateTransportOffer(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTransportOfferEta<T = any>(
    command: UpdateTransportOfferEta,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTransportOfferEta',
      UpdateTransportOfferEtaMutation,
      UpdateTransportOfferEtaMutationVariables,
      T
    >({
      name: 'UpdateTransportOfferEta',
      mutation: gql`
        mutation UpdateTransportOfferEtaMutation($command: UpdateTransportOfferEta!) {
          updateTransportOfferEta(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TransportReasons
  public addTransportReason<T = any>(
    command: AddTransportReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTransportReason',
      AddTransportReasonMutation,
      AddTransportReasonMutationVariables,
      T
    >({
      name: 'AddTransportReason',
      mutation: gql`
        mutation AddTransportReasonMutation($command: AddTransportReason!) {
          addTransportReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTransportReason<T = any>(
    command: DeleteTransportReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTransportReason',
      DeleteTransportReasonMutation,
      DeleteTransportReasonMutationVariables,
      T
    >({
      name: 'DeleteTransportReason',
      mutation: gql`
        mutation DeleteTransportReasonMutation($command: DeleteTransportReason!) {
          deleteTransportReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTransportReason<T = any>(
    command: UpdateTransportReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTransportReason',
      UpdateTransportReasonMutation,
      UpdateTransportReasonMutationVariables,
      T
    >({
      name: 'UpdateTransportReason',
      mutation: gql`
        mutation UpdateTransportReasonMutation($command: UpdateTransportReason!) {
          updateTransportReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TripLegManifestEntries
  public addManifestEntry<T = any>(
    command: AddManifestEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddManifestEntry',
      AddManifestEntryMutation,
      AddManifestEntryMutationVariables,
      T
    >({
      name: 'AddManifestEntry',
      mutation: gql`
        mutation AddManifestEntryMutation($command: AddManifestEntry!) {
          addManifestEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteManifestEntry<T = any>(
    command: DeleteManifestEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteManifestEntry',
      DeleteManifestEntryMutation,
      DeleteManifestEntryMutationVariables,
      T
    >({
      name: 'DeleteManifestEntry',
      mutation: gql`
        mutation DeleteManifestEntryMutation($command: DeleteManifestEntry!) {
          deleteManifestEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateManifestEntry<T = any>(
    command: UpdateManifestEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateManifestEntry',
      UpdateManifestEntryMutation,
      UpdateManifestEntryMutationVariables,
      T
    >({
      name: 'UpdateManifestEntry',
      mutation: gql`
        mutation UpdateManifestEntryMutation($command: UpdateManifestEntry!) {
          updateManifestEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TripLegs
  public updateOdometerReadings<T = any>(
    command: UpdateOdometerReadings,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOdometerReadings',
      UpdateOdometerReadingsMutation,
      UpdateOdometerReadingsMutationVariables,
      T
    >({
      name: 'UpdateOdometerReadings',
      mutation: gql`
        mutation UpdateOdometerReadingsMutation($command: UpdateOdometerReadings!) {
          updateOdometerReadings(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTripLegOnFinal<T = any>(
    command: UpdateTripLegOnFinal,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTripLegOnFinal',
      UpdateTripLegOnFinalMutation,
      UpdateTripLegOnFinalMutationVariables,
      T
    >({
      name: 'UpdateTripLegOnFinal',
      mutation: gql`
        mutation UpdateTripLegOnFinalMutation($command: UpdateTripLegOnFinal!) {
          updateTripLegOnFinal(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TripPassengers
  public addTripPassenger<T = any>(
    command: AddTripPassenger,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTripPassenger',
      AddTripPassengerMutation,
      AddTripPassengerMutationVariables,
      T
    >({
      name: 'AddTripPassenger',
      mutation: gql`
        mutation AddTripPassengerMutation($command: AddTripPassenger!) {
          addTripPassenger(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTripPassenger<T = any>(
    command: DeleteTripPassenger,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTripPassenger',
      DeleteTripPassengerMutation,
      DeleteTripPassengerMutationVariables,
      T
    >({
      name: 'DeleteTripPassenger',
      mutation: gql`
        mutation DeleteTripPassengerMutation($command: DeleteTripPassenger!) {
          deleteTripPassenger(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTripPassenger<T = any>(
    command: UpdateTripPassenger,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTripPassenger',
      UpdateTripPassengerMutation,
      UpdateTripPassengerMutationVariables,
      T
    >({
      name: 'UpdateTripPassenger',
      mutation: gql`
        mutation UpdateTripPassengerMutation($command: UpdateTripPassenger!) {
          updateTripPassenger(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Trips
  public addTrip<T = any>(
    command: AddTrip,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddTrip', AddTripMutation, AddTripMutationVariables, T>({
      name: 'AddTrip',
      mutation: gql`
        mutation AddTripMutation($command: AddTrip!) {
          addTrip(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addTripLegManifestEntry<T = any>(
    command: AddTripLegManifestEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTripLegManifestEntry',
      AddTripLegManifestEntryMutation,
      AddTripLegManifestEntryMutationVariables,
      T
    >({
      name: 'AddTripLegManifestEntry',
      mutation: gql`
        mutation AddTripLegManifestEntryMutation($command: AddTripLegManifestEntry!) {
          addTripLegManifestEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public calculateEtas<T = any>(
    command: CalculateEtas,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CalculateEtas',
      CalculateEtasMutation,
      CalculateEtasMutationVariables,
      T
    >({
      name: 'CalculateEtas',
      mutation: gql`
        mutation CalculateEtasMutation($command: CalculateEtas!) {
          calculateEtas(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public confirmManifest<T = any>(
    command: ConfirmManifest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ConfirmManifest',
      ConfirmManifestMutation,
      ConfirmManifestMutationVariables,
      T
    >({
      name: 'ConfirmManifest',
      mutation: gql`
        mutation ConfirmManifestMutation($command: ConfirmManifest!) {
          confirmManifest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createPrecautionaryLanding<T = any>(
    command: CreatePrecautionaryLanding,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreatePrecautionaryLanding',
      CreatePrecautionaryLandingMutation,
      CreatePrecautionaryLandingMutationVariables,
      T
    >({
      name: 'CreatePrecautionaryLanding',
      mutation: gql`
        mutation CreatePrecautionaryLandingMutation($command: CreatePrecautionaryLanding!) {
          createPrecautionaryLanding(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public createPrecautionaryLandingV2<T = any>(
    command: CreatePrecautionaryLandingV2,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'CreatePrecautionaryLandingV2',
      CreatePrecautionaryLandingV2Mutation,
      CreatePrecautionaryLandingV2MutationVariables,
      T
    >({
      name: 'CreatePrecautionaryLandingV2',
      mutation: gql`
        mutation CreatePrecautionaryLandingV2Mutation($command: CreatePrecautionaryLandingV2!) {
          createPrecautionaryLandingV2(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTrip<T = any>(
    command: DeleteTrip,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'DeleteTrip', DeleteTripMutation, DeleteTripMutationVariables, T>(
      {
        name: 'DeleteTrip',
        mutation: gql`
          mutation DeleteTripMutation($command: DeleteTrip!) {
            deleteTrip(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public deleteTripLegManifestEntry<T = any>(
    command: DeleteTripLegManifestEntry,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTripLegManifestEntry',
      DeleteTripLegManifestEntryMutation,
      DeleteTripLegManifestEntryMutationVariables,
      T
    >({
      name: 'DeleteTripLegManifestEntry',
      mutation: gql`
        mutation DeleteTripLegManifestEntryMutation($command: DeleteTripLegManifestEntry!) {
          deleteTripLegManifestEntry(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public insertWaypoint<T = any>(
    command: InsertWaypoint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'InsertWaypoint',
      InsertWaypointMutation,
      InsertWaypointMutationVariables,
      T
    >({
      name: 'InsertWaypoint',
      mutation: gql`
        mutation InsertWaypointMutation($command: InsertWaypoint!) {
          insertWaypoint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public mergePostAndDropoffWaypoints<T = any>(
    command: MergePostAndDropoffWaypoints,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'MergePostAndDropoffWaypoints',
      MergePostAndDropoffWaypointsMutation,
      MergePostAndDropoffWaypointsMutationVariables,
      T
    >({
      name: 'MergePostAndDropoffWaypoints',
      mutation: gql`
        mutation MergePostAndDropoffWaypointsMutation($command: MergePostAndDropoffWaypoints!) {
          mergePostAndDropoffWaypoints(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public mergeUnitOriginAndPickupWaypoints<T = any>(
    command: MergeUnitOriginAndPickupWaypoints,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'MergeUnitOriginAndPickupWaypoints',
      MergeUnitOriginAndPickupWaypointsMutation,
      MergeUnitOriginAndPickupWaypointsMutationVariables,
      T
    >({
      name: 'MergeUnitOriginAndPickupWaypoints',
      mutation: gql`
        mutation MergeUnitOriginAndPickupWaypointsMutation(
          $command: MergeUnitOriginAndPickupWaypoints!
        ) {
          mergeUnitOriginAndPickupWaypoints(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public modifyWaypoint<T = any>(
    command: ModifyWaypoint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ModifyWaypoint',
      ModifyWaypointMutation,
      ModifyWaypointMutationVariables,
      T
    >({
      name: 'ModifyWaypoint',
      mutation: gql`
        mutation ModifyWaypointMutation($command: ModifyWaypoint!) {
          modifyWaypoint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public recalculateTripMileage<T = any>(
    command: RecalculateTripMileage,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RecalculateTripMileage',
      RecalculateTripMileageMutation,
      RecalculateTripMileageMutationVariables,
      T
    >({
      name: 'RecalculateTripMileage',
      mutation: gql`
        mutation RecalculateTripMileageMutation($command: RecalculateTripMileage!) {
          recalculateTripMileage(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public removeWaypoint<T = any>(
    command: RemoveWaypoint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RemoveWaypoint',
      RemoveWaypointMutation,
      RemoveWaypointMutationVariables,
      T
    >({
      name: 'RemoveWaypoint',
      mutation: gql`
        mutation RemoveWaypointMutation($command: RemoveWaypoint!) {
          removeWaypoint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public splitUnitOriginAndPickupWaypoints<T = any>(
    command: SplitUnitOriginAndPickupWaypoints,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SplitUnitOriginAndPickupWaypoints',
      SplitUnitOriginAndPickupWaypointsMutation,
      SplitUnitOriginAndPickupWaypointsMutationVariables,
      T
    >({
      name: 'SplitUnitOriginAndPickupWaypoints',
      mutation: gql`
        mutation SplitUnitOriginAndPickupWaypointsMutation(
          $command: SplitUnitOriginAndPickupWaypoints!
        ) {
          splitUnitOriginAndPickupWaypoints(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public splitUnitPostAndDropoffWaypoints<T = any>(
    command: SplitUnitPostAndDropoffWaypoints,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SplitUnitPostAndDropoffWaypoints',
      SplitUnitPostAndDropoffWaypointsMutation,
      SplitUnitPostAndDropoffWaypointsMutationVariables,
      T
    >({
      name: 'SplitUnitPostAndDropoffWaypoints',
      mutation: gql`
        mutation SplitUnitPostAndDropoffWaypointsMutation(
          $command: SplitUnitPostAndDropoffWaypoints!
        ) {
          splitUnitPostAndDropoffWaypoints(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public swapWaypoint<T = any>(
    command: SwapWaypoint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SwapWaypoint',
      SwapWaypointMutation,
      SwapWaypointMutationVariables,
      T
    >({
      name: 'SwapWaypoint',
      mutation: gql`
        mutation SwapWaypointMutation($command: SwapWaypoint!) {
          swapWaypoint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTrip<T = any>(
    command: UpdateTrip,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'UpdateTrip', UpdateTripMutation, UpdateTripMutationVariables, T>(
      {
        name: 'UpdateTrip',
        mutation: gql`
          mutation UpdateTripMutation($command: UpdateTrip!) {
            updateTrip(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  // UnitActivationRules
  public addUnitActivationRule<T = any>(
    command: AddUnitActivationRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddUnitActivationRule',
      AddUnitActivationRuleMutation,
      AddUnitActivationRuleMutationVariables,
      T
    >({
      name: 'AddUnitActivationRule',
      mutation: gql`
        mutation AddUnitActivationRuleMutation($command: AddUnitActivationRule!) {
          addUnitActivationRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteUnitActivationRule<T = any>(
    command: DeleteUnitActivationRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteUnitActivationRule',
      DeleteUnitActivationRuleMutation,
      DeleteUnitActivationRuleMutationVariables,
      T
    >({
      name: 'DeleteUnitActivationRule',
      mutation: gql`
        mutation DeleteUnitActivationRuleMutation($command: DeleteUnitActivationRule!) {
          deleteUnitActivationRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateUnitActivationRule<T = any>(
    command: UpdateUnitActivationRule,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateUnitActivationRule',
      UpdateUnitActivationRuleMutation,
      UpdateUnitActivationRuleMutationVariables,
      T
    >({
      name: 'UpdateUnitActivationRule',
      mutation: gql`
        mutation UpdateUnitActivationRuleMutation($command: UpdateUnitActivationRule!) {
          updateUnitActivationRule(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // UnitEMSystemMappings
  public addUnitEMSystemMapping<T = any>(
    command: AddUnitEMSystemMapping,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddUnitEMSystemMapping',
      AddUnitEMSystemMappingMutation,
      AddUnitEMSystemMappingMutationVariables,
      T
    >({
      name: 'AddUnitEMSystemMapping',
      mutation: gql`
        mutation AddUnitEMSystemMappingMutation($command: AddUnitEMSystemMapping!) {
          addUnitEMSystemMapping(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteUnitEMSystemMapping<T = any>(
    command: DeleteUnitEMSystemMapping,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteUnitEMSystemMapping',
      DeleteUnitEMSystemMappingMutation,
      DeleteUnitEMSystemMappingMutationVariables,
      T
    >({
      name: 'DeleteUnitEMSystemMapping',
      mutation: gql`
        mutation DeleteUnitEMSystemMappingMutation($command: DeleteUnitEMSystemMapping!) {
          deleteUnitEMSystemMapping(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateUnitEMSystemMapping<T = any>(
    command: UpdateUnitEMSystemMapping,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateUnitEMSystemMapping',
      UpdateUnitEMSystemMappingMutation,
      UpdateUnitEMSystemMappingMutationVariables,
      T
    >({
      name: 'UpdateUnitEMSystemMapping',
      mutation: gql`
        mutation UpdateUnitEMSystemMappingMutation($command: UpdateUnitEMSystemMapping!) {
          updateUnitEMSystemMapping(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // UnitNotes
  public addUnitNote<T = any>(
    command: AddUnitNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddUnitNote',
      AddUnitNoteMutation,
      AddUnitNoteMutationVariables,
      T
    >({
      name: 'AddUnitNote',
      mutation: gql`
        mutation AddUnitNoteMutation($command: AddUnitNote!) {
          addUnitNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteUnitNote<T = any>(
    command: DeleteUnitNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteUnitNote',
      DeleteUnitNoteMutation,
      DeleteUnitNoteMutationVariables,
      T
    >({
      name: 'DeleteUnitNote',
      mutation: gql`
        mutation DeleteUnitNoteMutation($command: DeleteUnitNote!) {
          deleteUnitNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateUnitNote<T = any>(
    command: UpdateUnitNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateUnitNote',
      UpdateUnitNoteMutation,
      UpdateUnitNoteMutationVariables,
      T
    >({
      name: 'UpdateUnitNote',
      mutation: gql`
        mutation UpdateUnitNoteMutation($command: UpdateUnitNote!) {
          updateUnitNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // UnitPositions
  public addUnitPosition<T = any>(
    command: AddUnitPosition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddUnitPosition',
      AddUnitPositionMutation,
      AddUnitPositionMutationVariables,
      T
    >({
      name: 'AddUnitPosition',
      mutation: gql`
        mutation AddUnitPositionMutation($command: AddUnitPosition!) {
          addUnitPosition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteUnitPosition<T = any>(
    command: DeleteUnitPosition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteUnitPosition',
      DeleteUnitPositionMutation,
      DeleteUnitPositionMutationVariables,
      T
    >({
      name: 'DeleteUnitPosition',
      mutation: gql`
        mutation DeleteUnitPositionMutation($command: DeleteUnitPosition!) {
          deleteUnitPosition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public removeTeamMemberFromUnitPosition<T = any>(
    command: RemoveTeamMemberFromUnitPosition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RemoveTeamMemberFromUnitPosition',
      RemoveTeamMemberFromUnitPositionMutation,
      RemoveTeamMemberFromUnitPositionMutationVariables,
      T
    >({
      name: 'RemoveTeamMemberFromUnitPosition',
      mutation: gql`
        mutation RemoveTeamMemberFromUnitPositionMutation(
          $command: RemoveTeamMemberFromUnitPosition!
        ) {
          removeTeamMemberFromUnitPosition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateUnitPosition<T = any>(
    command: UpdateUnitPosition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateUnitPosition',
      UpdateUnitPositionMutation,
      UpdateUnitPositionMutationVariables,
      T
    >({
      name: 'UpdateUnitPosition',
      mutation: gql`
        mutation UpdateUnitPositionMutation($command: UpdateUnitPosition!) {
          updateUnitPosition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public upsertUnitPosition<T = any>(
    command: UpsertUnitPosition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertUnitPosition',
      UpsertUnitPositionMutation,
      UpsertUnitPositionMutationVariables,
      T
    >({
      name: 'UpsertUnitPosition',
      mutation: gql`
        mutation UpsertUnitPositionMutation($command: UpsertUnitPosition!) {
          upsertUnitPosition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Units
  public addUnit<T = any>(
    command: AddUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddUnit', AddUnitMutation, AddUnitMutationVariables, T>({
      name: 'AddUnit',
      mutation: gql`
        mutation AddUnitMutation($command: AddUnit!) {
          addUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public assignVehicle<T = any>(
    command: AssignVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AssignVehicle',
      AssignVehicleMutation,
      AssignVehicleMutationVariables,
      T
    >({
      name: 'AssignVehicle',
      mutation: gql`
        mutation AssignVehicleMutation($command: AssignVehicle!) {
          assignVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public delayUnit<T = any>(
    command: DelayUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'DelayUnit', DelayUnitMutation, DelayUnitMutationVariables, T>({
      name: 'DelayUnit',
      mutation: gql`
        mutation DelayUnitMutation($command: DelayUnit!) {
          delayUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteUnit<T = any>(
    command: DeleteUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'DeleteUnit', DeleteUnitMutation, DeleteUnitMutationVariables, T>(
      {
        name: 'DeleteUnit',
        mutation: gql`
          mutation DeleteUnitMutation($command: DeleteUnit!) {
            deleteUnit(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public disableUnit<T = any>(
    command: DisableUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DisableUnit',
      DisableUnitMutation,
      DisableUnitMutationVariables,
      T
    >({
      name: 'DisableUnit',
      mutation: gql`
        mutation DisableUnitMutation($command: DisableUnit!) {
          disableUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public enableUnit<T = any>(
    command: EnableUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'EnableUnit', EnableUnitMutation, EnableUnitMutationVariables, T>(
      {
        name: 'EnableUnit',
        mutation: gql`
          mutation EnableUnitMutation($command: EnableUnit!) {
            enableUnit(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public ensureThirdPartyUnit<T = any>(
    command: EnsureThirdPartyUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'EnsureThirdPartyUnit',
      EnsureThirdPartyUnitMutation,
      EnsureThirdPartyUnitMutationVariables,
      T
    >({
      name: 'EnsureThirdPartyUnit',
      mutation: gql`
        mutation EnsureThirdPartyUnitMutation($command: EnsureThirdPartyUnit!) {
          ensureThirdPartyUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public ensureThirdPartyUnits<T = any>(
    command: EnsureThirdPartyUnits,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'EnsureThirdPartyUnits',
      EnsureThirdPartyUnitsMutation,
      EnsureThirdPartyUnitsMutationVariables,
      T
    >({
      name: 'EnsureThirdPartyUnits',
      mutation: gql`
        mutation EnsureThirdPartyUnitsMutation($command: EnsureThirdPartyUnits!) {
          ensureThirdPartyUnits(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public hideUnit<T = any>(
    command: HideUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'HideUnit', HideUnitMutation, HideUnitMutationVariables, T>({
      name: 'HideUnit',
      mutation: gql`
        mutation HideUnitMutation($command: HideUnit!) {
          hideUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public markAsPilotUpdated<T = any>(
    command: MarkAsPilotUpdated,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'MarkAsPilotUpdated',
      MarkAsPilotUpdatedMutation,
      MarkAsPilotUpdatedMutationVariables,
      T
    >({
      name: 'MarkAsPilotUpdated',
      mutation: gql`
        mutation MarkAsPilotUpdatedMutation($command: MarkAsPilotUpdated!) {
          markAsPilotUpdated(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public reassignVehicle<T = any>(
    command: ReassignVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReassignVehicle',
      ReassignVehicleMutation,
      ReassignVehicleMutationVariables,
      T
    >({
      name: 'ReassignVehicle',
      mutation: gql`
        mutation ReassignVehicleMutation($command: ReassignVehicle!) {
          reassignVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public removeDelayFromUnit<T = any>(
    command: RemoveDelayFromUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RemoveDelayFromUnit',
      RemoveDelayFromUnitMutation,
      RemoveDelayFromUnitMutationVariables,
      T
    >({
      name: 'RemoveDelayFromUnit',
      mutation: gql`
        mutation RemoveDelayFromUnitMutation($command: RemoveDelayFromUnit!) {
          removeDelayFromUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public removeVehicleFromUnit<T = any>(
    command: RemoveVehicleFromUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RemoveVehicleFromUnit',
      RemoveVehicleFromUnitMutation,
      RemoveVehicleFromUnitMutationVariables,
      T
    >({
      name: 'RemoveVehicleFromUnit',
      mutation: gql`
        mutation RemoveVehicleFromUnitMutation($command: RemoveVehicleFromUnit!) {
          removeVehicleFromUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public returnUnitToService<T = any>(
    command: ReturnUnitToService,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ReturnUnitToService',
      ReturnUnitToServiceMutation,
      ReturnUnitToServiceMutationVariables,
      T
    >({
      name: 'ReturnUnitToService',
      mutation: gql`
        mutation ReturnUnitToServiceMutation($command: ReturnUnitToService!) {
          returnUnitToService(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public sourceCrewFromOutOfServiceUnit<T = any>(
    command: SourceCrewFromOutOfServiceUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SourceCrewFromOutOfServiceUnit',
      SourceCrewFromOutOfServiceUnitMutation,
      SourceCrewFromOutOfServiceUnitMutationVariables,
      T
    >({
      name: 'SourceCrewFromOutOfServiceUnit',
      mutation: gql`
        mutation SourceCrewFromOutOfServiceUnitMutation($command: SourceCrewFromOutOfServiceUnit!) {
          sourceCrewFromOutOfServiceUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public swapUnitVehicles<T = any>(
    command: SwapUnitVehicles,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SwapUnitVehicles',
      SwapUnitVehiclesMutation,
      SwapUnitVehiclesMutationVariables,
      T
    >({
      name: 'SwapUnitVehicles',
      mutation: gql`
        mutation SwapUnitVehiclesMutation($command: SwapUnitVehicles!) {
          swapUnitVehicles(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public takeUnitOutOfService<T = any>(
    command: TakeUnitOutOfService,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'TakeUnitOutOfService',
      TakeUnitOutOfServiceMutation,
      TakeUnitOutOfServiceMutationVariables,
      T
    >({
      name: 'TakeUnitOutOfService',
      mutation: gql`
        mutation TakeUnitOutOfServiceMutation($command: TakeUnitOutOfService!) {
          takeUnitOutOfService(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public teleportUnit<T = any>(
    command: TeleportUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'TeleportUnit',
      TeleportUnitMutation,
      TeleportUnitMutationVariables,
      T
    >({
      name: 'TeleportUnit',
      mutation: gql`
        mutation TeleportUnitMutation($command: TeleportUnit!) {
          teleportUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public unhideUnit<T = any>(
    command: UnhideUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'UnhideUnit', UnhideUnitMutation, UnhideUnitMutationVariables, T>(
      {
        name: 'UnhideUnit',
        mutation: gql`
          mutation UnhideUnitMutation($command: UnhideUnit!) {
            unhideUnit(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public updatePilotUnitConfiguration<T = any>(
    command: UpdatePilotUnitConfiguration,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePilotUnitConfiguration',
      UpdatePilotUnitConfigurationMutation,
      UpdatePilotUnitConfigurationMutationVariables,
      T
    >({
      name: 'UpdatePilotUnitConfiguration',
      mutation: gql`
        mutation UpdatePilotUnitConfigurationMutation($command: UpdatePilotUnitConfiguration!) {
          updatePilotUnitConfiguration(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateUnit<T = any>(
    command: UpdateUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'UpdateUnit', UpdateUnitMutation, UpdateUnitMutationVariables, T>(
      {
        name: 'UpdateUnit',
        mutation: gql`
          mutation UpdateUnitMutation($command: UpdateUnit!) {
            updateUnit(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public updateUnitConfiguration<T = any>(
    command: UpdateUnitConfiguration,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateUnitConfiguration',
      UpdateUnitConfigurationMutation,
      UpdateUnitConfigurationMutationVariables,
      T
    >({
      name: 'UpdateUnitConfiguration',
      mutation: gql`
        mutation UpdateUnitConfigurationMutation($command: UpdateUnitConfiguration!) {
          updateUnitConfiguration(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // UnitShifts
  public addUnitShift<T = any>(
    command: AddUnitShift,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddUnitShift',
      AddUnitShiftMutation,
      AddUnitShiftMutationVariables,
      T
    >({
      name: 'AddUnitShift',
      mutation: gql`
        mutation AddUnitShiftMutation($command: AddUnitShift!) {
          addUnitShift(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteUnitShift<T = any>(
    command: DeleteUnitShift,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteUnitShift',
      DeleteUnitShiftMutation,
      DeleteUnitShiftMutationVariables,
      T
    >({
      name: 'DeleteUnitShift',
      mutation: gql`
        mutation DeleteUnitShiftMutation($command: DeleteUnitShift!) {
          deleteUnitShift(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateUnitShift<T = any>(
    command: UpdateUnitShift,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateUnitShift',
      UpdateUnitShiftMutation,
      UpdateUnitShiftMutationVariables,
      T
    >({
      name: 'UpdateUnitShift',
      mutation: gql`
        mutation UpdateUnitShiftMutation($command: UpdateUnitShift!) {
          updateUnitShift(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleDispositions
  public addVehicleDisposition<T = any>(
    command: AddVehicleDisposition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleDisposition',
      AddVehicleDispositionMutation,
      AddVehicleDispositionMutationVariables,
      T
    >({
      name: 'AddVehicleDisposition',
      mutation: gql`
        mutation AddVehicleDispositionMutation($command: AddVehicleDisposition!) {
          addVehicleDisposition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleDisposition<T = any>(
    command: DeleteVehicleDisposition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleDisposition',
      DeleteVehicleDispositionMutation,
      DeleteVehicleDispositionMutationVariables,
      T
    >({
      name: 'DeleteVehicleDisposition',
      mutation: gql`
        mutation DeleteVehicleDispositionMutation($command: DeleteVehicleDisposition!) {
          deleteVehicleDisposition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicleDisposition<T = any>(
    command: UpdateVehicleDisposition,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicleDisposition',
      UpdateVehicleDispositionMutation,
      UpdateVehicleDispositionMutationVariables,
      T
    >({
      name: 'UpdateVehicleDisposition',
      mutation: gql`
        mutation UpdateVehicleDispositionMutation($command: UpdateVehicleDisposition!) {
          updateVehicleDisposition(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleNotificationGroups
  public addVehicleNotificationGroup<T = any>(
    command: AddVehicleNotificationGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleNotificationGroup',
      AddVehicleNotificationGroupMutation,
      AddVehicleNotificationGroupMutationVariables,
      T
    >({
      name: 'AddVehicleNotificationGroup',
      mutation: gql`
        mutation AddVehicleNotificationGroupMutation($command: AddVehicleNotificationGroup!) {
          addVehicleNotificationGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleNotificationGroup<T = any>(
    command: DeleteVehicleNotificationGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleNotificationGroup',
      DeleteVehicleNotificationGroupMutation,
      DeleteVehicleNotificationGroupMutationVariables,
      T
    >({
      name: 'DeleteVehicleNotificationGroup',
      mutation: gql`
        mutation DeleteVehicleNotificationGroupMutation($command: DeleteVehicleNotificationGroup!) {
          deleteVehicleNotificationGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehiclePositionSummaries
  // Waypoints
  public addFuelBurn<T = any>(
    command: AddFuelBurn,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddFuelBurn',
      AddFuelBurnMutation,
      AddFuelBurnMutationVariables,
      T
    >({
      name: 'AddFuelBurn',
      mutation: gql`
        mutation AddFuelBurnMutation($command: AddFuelBurn!) {
          addFuelBurn(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addWaypoint<T = any>(
    command: AddWaypoint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddWaypoint',
      AddWaypointMutation,
      AddWaypointMutationVariables,
      T
    >({
      name: 'AddWaypoint',
      mutation: gql`
        mutation AddWaypointMutation($command: AddWaypoint!) {
          addWaypoint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteWaypoint<T = any>(
    command: DeleteWaypoint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteWaypoint',
      DeleteWaypointMutation,
      DeleteWaypointMutationVariables,
      T
    >({
      name: 'DeleteWaypoint',
      mutation: gql`
        mutation DeleteWaypointMutation($command: DeleteWaypoint!) {
          deleteWaypoint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateWaypoint<T = any>(
    command: UpdateWaypoint,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateWaypoint',
      UpdateWaypointMutation,
      UpdateWaypointMutationVariables,
      T
    >({
      name: 'UpdateWaypoint',
      mutation: gql`
        mutation UpdateWaypointMutation($command: UpdateWaypoint!) {
          updateWaypoint(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // WebhookEventBodies
  // WebhookSubscriptionEvents
  // WebhookSubscriptions
  // WebOrderLogs
  public acknowledgeWebOrderLog<T = any>(
    command: AcknowledgeWebOrderLog,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AcknowledgeWebOrderLog',
      AcknowledgeWebOrderLogMutation,
      AcknowledgeWebOrderLogMutationVariables,
      T
    >({
      name: 'AcknowledgeWebOrderLog',
      mutation: gql`
        mutation AcknowledgeWebOrderLogMutation($command: AcknowledgeWebOrderLog!) {
          acknowledgeWebOrderLog(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addWebOrderLog<T = any>(
    command: AddWebOrderLog,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddWebOrderLog',
      AddWebOrderLogMutation,
      AddWebOrderLogMutationVariables,
      T
    >({
      name: 'AddWebOrderLog',
      mutation: gql`
        mutation AddWebOrderLogMutation($command: AddWebOrderLog!) {
          addWebOrderLog(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
}
